import { space as space$1, color as color$1, opacity as opacity$1 } from '@xstyled/system';
import styled54, { compose, flex, flexGrow, flexShrink, flexBasis, justifySelf, alignSelf, order, gridArea, gridColumn, gridRow, space, sizing, layout, interactivity, effects, borders, tables, backgrounds, color, overflow, overflowX, overflowY, createCss, flexboxes, gap, keyframes, grids, style, typography, styled, opacity, css, backgroundColor, getInset, getColor as getColor$1, createGlobalStyle, getSpace as getSpace$1, th, maxHeight, useColor, ThemeProvider as ThemeProvider$1, ColorModeProvider } from '@xstyled/styled-components';
export { generateHexAlphaVariants, useColor, useColorMode, useDown, useRadius, useScreens, useShadow, useSpace, useTh, useTheme, useUp, useViewportWidth } from '@xstyled/styled-components';
import * as React122 from 'react';
import React122__default, { forwardRef, useCallback, createContext, useState, useEffect, useMemo, memo, useContext, useRef, useLayoutEffect, useImperativeHandle } from 'react';
import { useComposedRefs, useSafeLayoutEffect, useRect, useSize, useCloseOnClick, useCloseOnScroll, useWindowSize, useControllableState, useChildrenValidation, usePubSub, useLatest, useId, useCloseOnEscape } from '@aircall/hooks';
import { motion, AnimatePresence } from 'framer-motion';
import ReactDOM, { createPortal } from 'react-dom';
import { getLuminance } from 'polished';
import { TickOutlined, ChevronDownOutlined, ChevronUpOutlined, PlayFilled, PauseFilled, ReplayFilled, CloseOutlined, ChevronLeftOutlined, ChevronRightOutlined, LoadingRedoUndoOutlined, MenuVerticalFilled, ArrowDownFilled, ArrowUpFilled, TickCircleFilled, InformationFilled, WarningFilled, CloseCircleFilled, SearchOutlined } from '@aircall/icons';
import { range, get, uniqueId, debounce, merge } from 'lodash-es';
import PubSub from 'pubsub-js';
import { isAfter, isSameMonth, isBefore, subMonths, startOfMonth, sub, endOfMonth, add, eachWeekOfInterval, addDays, addMonths, format, isSameDay } from 'date-fns';
import { normalize } from 'styled-normalize';
import loadable from '@loadable/component';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x5) => x5.done ? resolve(x5.value) : Promise.resolve(x5.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var flexboxItem = compose(flex, flexGrow, flexShrink, flexBasis, justifySelf, alignSelf, order);
var gridItem = compose(gridArea, gridColumn, gridRow);
var boxSystem = compose(
  space,
  sizing,
  layout,
  interactivity,
  effects,
  borders,
  tables,
  backgrounds,
  flexboxItem,
  gridItem,
  color,
  overflow,
  overflowX,
  overflowY
);
var { x } = createCss(boxSystem);
var Box = x.div;
var Box_default = Box;

// src/components/Flex/Flex.tsx
var flexSystem = compose(boxSystem, flexboxes, gap);
var { x: x2 } = createCss(flexSystem);
var Flex = x2.div;
Flex.defaultProps = {
  display: "flex"
};
var Flex_default = Flex;
var AccordionMainContext = React122.createContext(null);
var AccordionSubContext = React122.createContext(null);
var AccordionBodyWrapper = styled54(motion.div)`
  z-index: 0;
  display: block;
  width: 100%;
  max-height: 100%;
  flex-shrink: 1;
  overflow-y: auto;
  color: text-base;
`;
var animationVariants = {
  enter: {
    opacity: 1,
    height: "max-content",
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    }
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      duration: 0.5,
      ease: "easeInOut"
    },
    overflow: "hidden"
  }
};
var AccordionBody = (_a) => {
  var _b = _a, { children } = _b, styleProps = __objRest(_b, ["children"]);
  const { selectedItemId } = useContext(AccordionMainContext);
  const { id } = useContext(AccordionSubContext);
  return /* @__PURE__ */ React122__default.createElement(AnimatePresence, null, selectedItemId === id && /* @__PURE__ */ React122__default.createElement(
    AccordionBodyWrapper,
    __spreadValues({
      variants: animationVariants,
      initial: "exit",
      animate: "enter",
      exit: "exit"
    }, styleProps),
    children
  ));
};
AccordionBody.displayName = "AccordionBody";
var AccordionHeader = (_a) => {
  var _b = _a, { children } = _b, styleProps = __objRest(_b, ["children"]);
  const { onItemClick } = React122.useContext(AccordionMainContext);
  const { id } = React122.useContext(AccordionSubContext);
  const handleSelect = React122.useCallback(() => {
    onItemClick == null ? void 0 : onItemClick(id);
  }, [id, onItemClick]);
  return /* @__PURE__ */ React122.createElement(Flex_default, __spreadValues({ zIndex: 1, onClick: handleSelect, "data-test": `accordion-header-${id}` }, styleProps), children);
};
AccordionHeader.displayName = "AccordionHeader";

// src/components/Accordion/components/AccordionItem.tsx
function AccordionItem({ children, id }) {
  useChildrenValidation(children, "AccordionItem", [AccordionHeader, AccordionBody]);
  return /* @__PURE__ */ React122__default.createElement(AccordionSubContext.Provider, { value: { id } }, children);
}
AccordionItem.displayName = "AccordionItem";

// src/components/Accordion/Accordion.tsx
var AccordionWrapper = styled54(Flex_default).attrs({
  flexDirection: "column",
  flexShrink: 1,
  minHeight: 0,
  maxHeight: "auto",
  height: "max-content"
})``;
var Accordion = (_a) => {
  var _b = _a, {
    children,
    selected: selectedProp,
    defaultSelected,
    onChange
  } = _b, accordionProps = __objRest(_b, [
    "children",
    "selected",
    "defaultSelected",
    "onChange"
  ]);
  const [selectedItemId, setSelectedItemId] = useControllableState({
    prop: selectedProp,
    defaultProp: defaultSelected,
    onChange
  });
  useChildrenValidation(children, "AccordionItem", AccordionItem);
  return /* @__PURE__ */ React122.createElement(
    AccordionMainContext.Provider,
    {
      value: {
        selectedItemId,
        onItemClick: setSelectedItemId
      }
    },
    /* @__PURE__ */ React122.createElement(AccordionWrapper, __spreadValues({}, accordionProps), children)
  );
};
var PopoverContext = React122.createContext(null);
var usePopoverContext = () => React122.useContext(PopoverContext);
var PopoverPlacementContext = React122.createContext(null);
var usePopoverPlacement = () => React122.useContext(PopoverPlacementContext);
var PopoverArrowContext = React122.createContext(null);
var usePopoverArrow = () => React122.useContext(PopoverArrowContext);

// src/components/Popover/components/PopoverArrow.tsx
var PopoverArrow = React122.forwardRef(
  (props, forwardedRef) => {
    const { offset, children } = props;
    const context = usePopoverArrow();
    const { onArrowOffsetChange } = context;
    const composedRefs = useComposedRefs(forwardedRef, (node) => context.onArrowChange(node));
    React122.useEffect(() => onArrowOffsetChange(offset), [onArrowOffsetChange, offset]);
    return /* @__PURE__ */ React122.createElement("span", { style: __spreadProps(__spreadValues({}, context.arrowStyles), { pointerEvents: "none" }), ref: composedRefs }, children);
  }
);
var MotionBox = motion(Box_default);

// src/components/Portal/Portal.tsx
var MAX_Z_INDEX = 2147483647;
var Portal = React122.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, { containerRef, zIndex = MAX_Z_INDEX } = _b, portalProps = __objRest(_b, ["containerRef", "zIndex"]);
    var _a2, _b2;
    const hostElement = (_b2 = containerRef == null ? void 0 : containerRef.current) != null ? _b2 : (_a2 = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _a2.body;
    const [, forceUpdate] = React122.useState({});
    useSafeLayoutEffect(() => {
      forceUpdate({});
    }, []);
    if (!hostElement) {
      return null;
    }
    const domNode = ReactDOM.createPortal(
      /* @__PURE__ */ React122.createElement(
        Box_default,
        __spreadProps(__spreadValues({}, portalProps), {
          ref: forwardedRef,
          style: (
            /**
             * If the Portal is injected in `body`, we assume we want whatever is portalled
             * to appear on top of everything. Ideally this would be handled by making sure the
             * app root creates a new stacking context, however this is quite hard to automate.
             * For this reason, we have opted for setting the max z-index on the portal itself.
             */
            hostElement === document.body ? {
              position: "absolute",
              top: 0,
              left: 0,
              zIndex
            } : void 0
          )
        })
      ),
      hostElement
    );
    return /* @__PURE__ */ React122.createElement(React122.Fragment, null, domNode);
  }
);
var slideUpAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" }
});
var slideRightAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(-2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" }
});
var slideDownAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(-2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" }
});
var slideLeftAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateX(2px)" },
  "100%": { opacity: 1, transform: "translateX(0)" }
});
var StyledContent = styled54(Flex_default)`
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  animation-fill-mode: forwards;
  will-change: transform, opacity;

  &[data-state='open'] {
    &[data-side='top'] {
      animation-name: ${slideDownAndFade};
    }
    &[data-side='right'] {
      animation-name: ${slideLeftAndFade};
    }
    &[data-side='bottom'] {
      animation-name: ${slideUpAndFade};
    }
    &[data-side='left'] {
      animation-name: ${slideRightAndFade};
    }
  }
`;

// src/components/Popover/utils.ts
function getPlacementData({
  anchorRect,
  popoverSize,
  arrowSize,
  arrowOffset = 0,
  side,
  sideOffset = 0,
  align,
  alignOffset = 0,
  shouldAvoidCollisions = true,
  collisionBoundariesRect,
  collisionTolerance = 0,
  arrowPointsAtCenter = false
}) {
  if (!anchorRect || !popoverSize || !collisionBoundariesRect) {
    return {
      popoverStyles: UNMEASURED_POPPER_STYLES,
      arrowStyles: UNMEASURED_ARROW_STYLES
    };
  }
  const allPlacementPoints = getAllPlacementPoints(
    popoverSize,
    anchorRect,
    sideOffset,
    alignOffset,
    arrowSize
  );
  const popoverPoint = allPlacementPoints[side][align];
  if (shouldAvoidCollisions === false) {
    const popoverStyles2 = getPlacementStylesForPoint(popoverPoint);
    let arrowStyles2 = UNMEASURED_ARROW_STYLES;
    if (arrowSize) {
      arrowStyles2 = getPopoverArrowStyles({
        anchorRect,
        popoverSize,
        arrowSize,
        arrowOffset,
        side,
        align,
        arrowPointsAtCenter
      });
    }
    const transformOrigin2 = getTransformOrigin(popoverSize, side, align, arrowOffset, arrowSize);
    return {
      popoverStyles: __spreadProps(__spreadValues({}, popoverStyles2), {
        ["--popover-transform-origin"]: transformOrigin2
      }),
      arrowStyles: arrowStyles2,
      placedSide: side,
      placedAlign: align
    };
  }
  const popoverRect = DOMRect.fromRect(__spreadValues(__spreadValues({}, popoverSize), popoverPoint));
  const collisionBoundariesRectWithTolerance = getContractedRect(
    collisionBoundariesRect,
    collisionTolerance
  );
  const popoverCollisions = getCollisions(popoverRect, collisionBoundariesRectWithTolerance);
  const oppositeSide = getOppositeSide(side);
  const oppositeSidePopoverPoint = allPlacementPoints[oppositeSide][align];
  const updatedOppositeSidePopoverPoint = DOMRect.fromRect(__spreadValues(__spreadValues({}, popoverSize), oppositeSidePopoverPoint));
  const oppositeSidePopoverCollisions = getCollisions(
    updatedOppositeSidePopoverPoint,
    collisionBoundariesRectWithTolerance
  );
  const placedSide = getSideAccountingForCollisions(
    side,
    popoverCollisions,
    oppositeSidePopoverCollisions
  );
  const placedAlign = getAlignAccountingForCollisions(
    popoverSize,
    anchorRect,
    side,
    align,
    popoverCollisions
  );
  const placedPopoverPoint = allPlacementPoints[placedSide][placedAlign];
  const popoverStyles = getPlacementStylesForPoint(placedPopoverPoint);
  let arrowStyles = UNMEASURED_ARROW_STYLES;
  if (arrowSize) {
    arrowStyles = getPopoverArrowStyles({
      anchorRect,
      popoverSize,
      arrowSize,
      arrowOffset,
      side: placedSide,
      align: placedAlign,
      arrowPointsAtCenter
    });
  }
  const transformOrigin = getTransformOrigin(
    popoverSize,
    placedSide,
    placedAlign,
    arrowOffset,
    arrowSize
  );
  return {
    popoverStyles: __spreadProps(__spreadValues({}, popoverStyles), {
      ["--popover-transform-origin"]: transformOrigin
    }),
    arrowStyles,
    placedSide,
    placedAlign
  };
}
function getAllPlacementPoints(popoverSize, anchorRect, sideOffset = 0, alignOffset = 0, arrowSize) {
  const arrowBaseToTipLength = arrowSize ? arrowSize.height : 0;
  const x5 = getPopoverSlotsForAxis(anchorRect, popoverSize, "x");
  const y = getPopoverSlotsForAxis(anchorRect, popoverSize, "y");
  const topY = y.before - sideOffset - arrowBaseToTipLength;
  const bottomY = y.after + sideOffset + arrowBaseToTipLength;
  const leftX = x5.before - sideOffset - arrowBaseToTipLength;
  const rightX = x5.after + sideOffset + arrowBaseToTipLength;
  const map = {
    top: {
      start: { x: x5.start + alignOffset, y: topY },
      center: { x: x5.center, y: topY },
      end: { x: x5.end - alignOffset, y: topY }
    },
    right: {
      start: { x: rightX, y: y.start + alignOffset },
      center: { x: rightX, y: y.center },
      end: { x: rightX, y: y.end - alignOffset }
    },
    bottom: {
      start: { x: x5.start + alignOffset, y: bottomY },
      center: { x: x5.center, y: bottomY },
      end: { x: x5.end - alignOffset, y: bottomY }
    },
    left: {
      start: { x: leftX, y: y.start + alignOffset },
      center: { x: leftX, y: y.center },
      end: { x: leftX, y: y.end - alignOffset }
    }
  };
  return map;
}
function getPopoverSlotsForAxis(anchorRect, popoverSize, axis) {
  const startSide = axis === "x" ? "left" : "top";
  const anchorStart = anchorRect[startSide];
  const dimension = axis === "x" ? "width" : "height";
  const anchorDimension = anchorRect[dimension];
  const popoverDimension = popoverSize[dimension];
  return {
    before: anchorStart - popoverDimension,
    start: anchorStart,
    center: anchorStart + (anchorDimension - popoverDimension) / 2,
    end: anchorStart + anchorDimension - popoverDimension,
    after: anchorStart + anchorDimension
  };
}
function getSideAccountingForCollisions(side, collisions, oppositeSideCollisions) {
  const oppositeSide = getOppositeSide(side);
  if (collisions[side] <= 0 && oppositeSideCollisions[oppositeSide] <= 0)
    return side;
  else if (collisions[side] > 0 && oppositeSideCollisions[oppositeSide] > 0)
    return collisions[side] < oppositeSideCollisions[oppositeSide] ? side : oppositeSide;
  return collisions[side] <= 0 ? side : oppositeSide;
}
function getAlignAccountingForCollisions(popoverSize, anchorSize, side, align, collisions) {
  const isHorizontalSide = side === "top" || side === "bottom";
  const startBound = isHorizontalSide ? "left" : "top";
  const endBound = isHorizontalSide ? "right" : "bottom";
  const dimension = isHorizontalSide ? "width" : "height";
  const isAnchorBigger = anchorSize[dimension] > popoverSize[dimension];
  if (align === "start" || align === "center") {
    if (collisions[startBound] > 0 && isAnchorBigger || collisions[endBound] > 0 && !isAnchorBigger) {
      return "end";
    }
  }
  if (align === "end" || align === "center") {
    if (collisions[endBound] > 0 && isAnchorBigger || collisions[startBound] > 0 && !isAnchorBigger) {
      return "start";
    }
  }
  return align;
}
function getPlacementStylesForPoint(point) {
  const x5 = Math.round(point.x + window.scrollX);
  const y = Math.round(point.y + window.scrollY);
  return {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "max-content",
    willChange: "transform",
    transform: `translate3d(${x5}px, ${y}px, 0)`
  };
}
function getTransformOrigin(popoverSize, side, align, arrowOffset, arrowSize) {
  const isHorizontalSide = side === "top" || side === "bottom";
  const arrowBaseLength = arrowSize ? arrowSize.width : 0;
  const arrowBaseToTipLength = arrowSize ? arrowSize.height : 0;
  const sideOffset = arrowBaseToTipLength;
  const alignOffset = arrowBaseLength / 2 + arrowOffset;
  let x5 = "";
  let y = "";
  if (isHorizontalSide) {
    x5 = {
      start: `${alignOffset}px`,
      center: "center",
      end: `${popoverSize.width - alignOffset}px`
    }[align];
    y = side === "top" ? `${popoverSize.height + sideOffset}px` : `${-sideOffset}px`;
  } else {
    x5 = side === "left" ? `${popoverSize.width + sideOffset}px` : `${-sideOffset}px`;
    y = {
      start: `${alignOffset}px`,
      center: "center",
      end: `${popoverSize.height - alignOffset}px`
    }[align];
  }
  return `${x5} ${y}`;
}
var UNMEASURED_POPPER_STYLES = {
  // position: 'fixed' here is important because it will take the popover
  // out of the flow so it does not disturb the position of the anchor
  position: "fixed",
  top: 0,
  left: 0,
  opacity: 0,
  transform: "translate3d(0, -200%, 0)"
};
var UNMEASURED_ARROW_STYLES = {
  // given the arrow is nested inside the popover,
  // make sure that it is out of the flow and doesn't hinder then popover's measurement
  position: "absolute",
  opacity: 0
};
function getPopoverArrowStyles({
  anchorRect,
  popoverSize,
  arrowSize,
  arrowOffset,
  side,
  align,
  arrowPointsAtCenter
}) {
  const popoverCenterX = (popoverSize.width - arrowSize.width) / 2;
  const popoverCenterY = (popoverSize.height - arrowSize.width) / 2;
  const anchorCenterX = (anchorRect.width - arrowSize.width) / 2;
  const anchorCenterY = (anchorRect.width - arrowSize.width) / 2;
  const rotationMap = { top: 0, right: 90, bottom: 180, left: -90 };
  const rotation = rotationMap[side];
  const arrowMaxDimension = Math.max(arrowSize.width, arrowSize.height);
  const styles = {
    // we make sure we put the arrow inside a 1:1 ratio container
    // this is to make the rotation handling simpler
    // as we do no need to worry about changing the transform-origin
    width: `${arrowMaxDimension}px`,
    height: `${arrowMaxDimension}px`,
    // rotate the arrow appropriately
    transform: `rotate(${rotation}deg)`,
    willChange: "transform",
    // position the arrow appropriately
    position: "absolute",
    [side]: "100%",
    // Because the arrow gets rotated (see `transform above`)
    // and we are putting it inside a 1:1 ratio container
    // we need to adjust the CSS direction from `ltr` to `rtl`
    // in some circumstances
    direction: getArrowCssDirection(side, align)
  };
  if (side === "top" || side === "bottom") {
    if (arrowPointsAtCenter) {
      if (align === "start") {
        styles.left = `${anchorCenterX}px`;
      }
      if (align === "center") {
        styles.left = `${popoverCenterX}px`;
      }
      if (align === "end") {
        styles.right = `${anchorCenterX}px`;
      }
    } else {
      if (align === "start") {
        styles.left = `${arrowOffset}px`;
      }
      if (align === "center") {
        styles.left = `${popoverCenterX}px`;
      }
      if (align === "end") {
        styles.right = `${arrowOffset}px`;
      }
    }
  }
  if (side === "left" || side === "right") {
    if (arrowPointsAtCenter) {
      if (align === "start") {
        styles.top = `${anchorCenterY}px`;
      }
      if (align === "center") {
        styles.top = `${popoverCenterY}px`;
      }
      if (align === "end") {
        styles.bottom = `${anchorCenterY}px`;
      }
    } else {
      if (align === "start") {
        styles.top = `${arrowOffset}px`;
      }
      if (align === "center") {
        styles.top = `${popoverCenterY}px`;
      }
      if (align === "end") {
        styles.bottom = `${arrowOffset}px`;
      }
    }
  }
  return styles;
}
function getArrowCssDirection(side, align) {
  if ((side === "top" || side === "right") && align === "end") {
    return "rtl";
  }
  if ((side === "bottom" || side === "left") && align !== "end") {
    return "rtl";
  }
  return "ltr";
}
function getOppositeSide(side) {
  const oppositeSides = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  };
  return oppositeSides[side];
}
function getContractedRect(rect, amount) {
  return DOMRect.fromRect({
    width: rect.width - amount * 2,
    height: rect.height - amount * 2,
    x: rect.left + amount,
    y: rect.top + amount
  });
}
function getCollisions(rect, collisionBoundariesRect) {
  return {
    top: collisionBoundariesRect.top - rect.top,
    right: rect.right - collisionBoundariesRect.right,
    bottom: rect.bottom - collisionBoundariesRect.bottom,
    left: collisionBoundariesRect.left - rect.left
  };
}
function getLeftoverViewportHeight({
  side,
  takeViewportHeight,
  collisionBoundariesRect,
  anchorRect,
  sideOffset
}) {
  var _a, _b, _c, _d;
  if (!takeViewportHeight || !side || ["left", "right"].includes(side)) {
    return void 0;
  }
  return side === "bottom" ? ((_a = collisionBoundariesRect == null ? void 0 : collisionBoundariesRect.height) != null ? _a : 0) - ((_b = anchorRect == null ? void 0 : anchorRect.bottom) != null ? _b : 0) - sideOffset - 16 : ((_c = anchorRect == null ? void 0 : anchorRect.top) != null ? _c : 0) - ((_d = collisionBoundariesRect == null ? void 0 : collisionBoundariesRect.top) != null ? _d : 0) - sideOffset - 16;
}

// src/components/Popover/components/PopoverContent.tsx
var PopoverContent = React122.forwardRef(
  (props, forwaredRef) => {
    const _a = props, { portalled = true } = _a, popoverContent = __objRest(_a, ["portalled"]);
    const { open } = usePopoverContext();
    if (!open) {
      return null;
    }
    const Wrapper = portalled ? Portal : React122.Fragment;
    return /* @__PURE__ */ React122.createElement(Wrapper, null, /* @__PURE__ */ React122.createElement(PopoverContentImpl, __spreadProps(__spreadValues({}, popoverContent), { ref: forwaredRef })));
  }
);
var PopoverContentImpl = React122.forwardRef(
  (_a, forwardedRef) => {
    var _b = _a, {
      side = "bottom",
      sideOffset = 0,
      align = "center",
      alignOffset,
      collisionTolerance,
      avoidCollisions = true,
      children,
      takeTriggerWidth = false,
      takeViewportHeight = false,
      closeOnOutsideClick = true,
      closeOnInsideClick = false,
      arrowPointsAtCenter = false
    } = _b, contentProps = __objRest(_b, [
      "side",
      "sideOffset",
      "align",
      "alignOffset",
      "collisionTolerance",
      "avoidCollisions",
      "children",
      "takeTriggerWidth",
      "takeViewportHeight",
      "closeOnOutsideClick",
      "closeOnInsideClick",
      "arrowPointsAtCenter"
    ]);
    const context = usePopoverContext();
    const [arrowOffset, setArrowOffset] = React122.useState();
    const anchorRect = useRect(context.trigger);
    const [content, setContent] = React122.useState(null);
    const contentSize = useSize(content);
    const [arrow, setArrow] = React122.useState(null);
    const arrowSize = useSize(arrow);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setContent(node));
    const closeContent = () => context.setOpen(false);
    useCloseOnClick({
      container: document.body,
      triggerNode: context.trigger,
      node: content,
      closeOnInsideClick,
      onClose: () => closeOnOutsideClick && context.setOpen(false)
    });
    useCloseOnScroll({
      container: window,
      node: content,
      onClose: closeContent
    });
    const windowSize = useWindowSize();
    const collisionBoundariesRect = windowSize ? DOMRect.fromRect(__spreadProps(__spreadValues({}, windowSize), { x: 0, y: 0 })) : void 0;
    const { popoverStyles, arrowStyles, placedSide, placedAlign } = getPlacementData({
      anchorRect,
      popoverSize: contentSize,
      arrowSize,
      // config
      arrowOffset,
      side,
      sideOffset,
      align,
      alignOffset,
      shouldAvoidCollisions: avoidCollisions,
      collisionBoundariesRect,
      collisionTolerance,
      arrowPointsAtCenter
    });
    const isPlaced = placedSide !== void 0;
    const maxHeight2 = getLeftoverViewportHeight({
      side: placedSide,
      anchorRect,
      collisionBoundariesRect,
      sideOffset,
      takeViewportHeight
    });
    return /* @__PURE__ */ React122.createElement(PopoverPlacementContext.Provider, { value: { side: placedSide, align: placedAlign } }, /* @__PURE__ */ React122.createElement(
      PopoverArrowContext.Provider,
      {
        value: {
          arrowStyles,
          onArrowChange: setArrow,
          onArrowOffsetChange: setArrowOffset
        }
      },
      /* @__PURE__ */ React122.createElement("div", { style: popoverStyles }, /* @__PURE__ */ React122.createElement(
        StyledContent,
        __spreadProps(__spreadValues({}, contentProps), {
          ref: composedRefs,
          "data-side": placedSide,
          "data-align": placedAlign,
          "data-state": context.open ? "open" : "closed",
          w: takeTriggerWidth ? anchorRect == null ? void 0 : anchorRect.width : void 0,
          maxHeight: maxHeight2,
          style: {
            // if the PopoverContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPlaced ? "none" : void 0
          }
        }),
        children
      ))
    ));
  }
);
var PopoverRoot = ({
  children,
  open: openProp,
  defaultOpen,
  onOpenChange
}) => {
  const [trigger, setTrigger] = React122.useState(null);
  const [open = false, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ React122.createElement(
    PopoverContext.Provider,
    {
      value: {
        trigger,
        onTriggerChange: setTrigger,
        open,
        setOpen,
        toggleOpen: React122.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen])
      }
    },
    children
  );
};

// src/utils/handlers.ts
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  };
}

// src/components/Popover/components/PopoverTrigger.tsx
var PopoverTrigger = (_a) => {
  var _b = _a, { children } = _b, triggerProps = __objRest(_b, ["children"]);
  var _a2, _b2;
  const child = React122.Children.only(children);
  const { onTriggerChange, open, setOpen } = usePopoverContext();
  const closePopoverContent = () => {
    setOpen(false);
  };
  useCloseOnEscape(open, closePopoverContent);
  const ref = React122.useRef(null);
  const composedRefs = useComposedRefs(child.ref, ref);
  React122.useEffect(() => {
    onTriggerChange(ref.current);
  });
  return React122.cloneElement(child, __spreadProps(__spreadValues(__spreadValues({}, child.props), triggerProps), {
    ref: composedRefs,
    onBlur: composeEventHandlers((_a2 = child.props) == null ? void 0 : _a2.onBlur, triggerProps.onBlur),
    onClick: composeEventHandlers((_b2 = child.props) == null ? void 0 : _b2.onClick, triggerProps.onClick)
  }));
};

// src/components/Popover/Popover.tsx
var Popover = {
  Root: PopoverRoot,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  Arrow: PopoverArrow
};
var DropdownContent = (_a) => {
  var _b = _a, { children } = _b, popoverContent = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122.createElement(
    Popover.Content,
    __spreadProps(__spreadValues({}, popoverContent), {
      sideOffset: 8,
      boxShadow: 1,
      borderRadius: "sm",
      bg: "surface-interactive-default",
      py: 2
    }),
    children
  );
};

// src/components/Dropdown/contexts/context.ts
var useDropdownContext = usePopoverContext;

// src/components/Dropdown/components/DropdownTrigger/DropdownTrigger.tsx
var DropdownTrigger = (_a) => {
  var triggerProps = __objRest(_a, []);
  const { toggleOpen } = useDropdownContext();
  const onClick = (event) => {
    event.stopPropagation();
    toggleOpen();
  };
  return /* @__PURE__ */ React122.createElement(Popover.Trigger, __spreadProps(__spreadValues({}, triggerProps), { onClick }));
};

// src/components/Dropdown/Dropdown.tsx
var Dropdown = ({
  trigger,
  side = "bottom",
  align = "center",
  defaultVisible = false,
  visible,
  onVisibilityChange,
  closeOnInsideClick = true,
  children,
  "data-test": testId = "dropdown",
  maxWidth = 344,
  maxHeight: maxHeight2
}) => {
  return /* @__PURE__ */ React122__default.createElement(Popover.Root, { defaultOpen: defaultVisible, open: visible, onOpenChange: onVisibilityChange }, /* @__PURE__ */ React122__default.createElement(DropdownTrigger, null, trigger), /* @__PURE__ */ React122__default.createElement(
    DropdownContent,
    {
      side,
      align,
      "data-test": testId,
      maxWidth,
      maxHeight: maxHeight2,
      closeOnInsideClick
    },
    children
  ));
};
function forwardRef4(component) {
  return forwardRef(component);
}

// src/utils/general.ts
function noop() {
  return void 0;
}
function mapValues(value, iterator) {
  return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, iterator(v)]));
}
var fromTheme = (key, fallback) => th(key, fallback);
var getColor = (key, fallback) => th.color(key, fallback);
var getRadii = (key, fallback) => th.radius(key, fallback);
var getSpace = (key, fallback) => th.space(key, fallback);
var getShadow = (key, fallback) => th.shadow(key, fallback);
function textColor(color4, white, dark) {
  const isColorLight = getLuminance(color4) > 0.179;
  return isColorLight ? dark : white;
}

// src/utils/string.ts
var join = (values, separator = " ") => values.filter(Boolean).join(separator);
var FormContext = React122.createContext(null);
var useFormContext = () => React122.useContext(FormContext);
var FormItemContext = React122.createContext(null);
var useFormItemContext = () => React122.useContext(FormItemContext);

// src/components/Form/components/Form/Form.tsx
var Form = (_a) => {
  var _b = _a, {
    size: size2 = "regular",
    children
  } = _b, otherFormProps = __objRest(_b, [
    "size",
    "children"
  ]);
  return /* @__PURE__ */ React122.createElement(FormContext.Provider, { value: { size: size2 } }, /* @__PURE__ */ React122.createElement("form", __spreadValues({}, otherFormProps), children));
};
var Form_default = Form;
var gridSystem = compose(boxSystem, flexboxes, grids);
var { x: x3 } = createCss(gridSystem);
var Grid = x3.div;
Grid.defaultProps = {
  display: "grid"
};
var wordBreak = style({
  prop: "wordBreak"
});
var variant = style({
  prop: "variant",
  css: (value) => ({ theme }) => ({
    fontSize: theme.typography[value].fontSize,
    lineHeight: theme.typography[value].lineHeight,
    fontWeight: theme.typography[value].fontWeight
  })
});
var ellipsis = style({
  prop: "ellipsis",
  css: (value) => {
    if (typeof value === "number" && value > 0)
      return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        WebkitLineClamp: value,
        WebkitBoxOrient: "vertical",
        display: "-webkit-box"
      };
    if (value === true) {
      return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      };
    } else
      return {};
  }
});
var typographySystem = compose(boxSystem, typography, wordBreak, variant, ellipsis);
var { x: x4 } = createCss(typographySystem);
var Typography = x4.div;
Typography.defaultProps = {
  variant: "bodyMediumS",
  fontFamily: "default"
};
var Typography_default = Typography;
var CustomTypography = styled54(Typography_default)`
  display: inline;
  background-color: transparent;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  color: ${getColor("text-interactive-primary")};

  &:hover {
    text-decoration: underline;
    color: ${getColor("text-interactive-primary-hover")};
  }

  &:active {
    color: ${getColor("text-interactive-primary-active")};
  }
`;
var Link = (props) => {
  return /* @__PURE__ */ React122__default.createElement(CustomTypography, __spreadValues({ variant: "bodyMediumS", as: "a" }, props));
};
var Link_default = Link;

// src/components/Form/components/FormItem/FormItem.tsx
var FormItem = (_a) => {
  var _b = _a, {
    label,
    name,
    helpText,
    validationStatus,
    children
  } = _b, otherStylingProps = __objRest(_b, [
    "label",
    "name",
    "helpText",
    "validationStatus",
    "children"
  ]);
  const error = validationStatus === "error";
  return /* @__PURE__ */ React122.createElement(FormItemContext.Provider, { value: { validationStatus, name } }, /* @__PURE__ */ React122.createElement(Grid, __spreadValues({ gap: "xxs" }, otherStylingProps), label && /* @__PURE__ */ React122.createElement(Typography_default, { textAlign: "start", color: "text-base", as: "label", htmlFor: name }, label), children, helpText && /* @__PURE__ */ React122.createElement(
    Typography_default,
    {
      textAlign: "start",
      color: error ? "text-critical" : "text-placeholder",
      variant: "supportingMediumXS"
    },
    helpText
  )));
};
var FormItem_default = FormItem;

// src/components/Button/constants.ts
var linkSizes = {
  xSmall: {
    height: "28px",
    minWidth: "28px",
    padding: "0 8px"
  },
  small: {
    height: "40px",
    minWidth: "40px",
    padding: "0 8px"
  },
  regular: {
    height: "48px",
    minWidth: "48px",
    padding: "0 8px"
  },
  large: {
    height: "56px",
    minWidth: "56px",
    padding: "0 8px"
  }
};
var buttonSizes = {
  xSmall: {
    height: "28px",
    minWidth: "28px",
    padding: "0 8px"
  },
  small: {
    height: "40px",
    minWidth: "40px",
    padding: "0 16px"
  },
  regular: {
    height: "48px",
    minWidth: "48px",
    padding: "0 16px"
  },
  large: {
    height: "56px",
    minWidth: "56px",
    padding: "0 16px"
  }
};
var iconButtonSizes = {
  xSmall: {
    height: "16px",
    width: "16px"
  },
  small: {
    height: "24px",
    width: "24px"
  },
  regular: {
    height: "24px",
    width: "24px"
  },
  large: {
    height: "24px",
    width: "24px"
  }
};

// src/components/Button/utils.tsx
var makeButtonVariant = ({
  variant: variant2,
  disabled,
  mode,
  readOnly
}) => {
  const getBackgroundColor = (color4, state) => {
    switch (mode) {
      case "outline":
      case "link":
        return "transparent";
      case "ghost":
        return join([color4, "ghost", state], "-");
      default:
        return join([color4, state], "-");
    }
  };
  const getBorderColor = (color4, state) => {
    switch (mode) {
      case "link":
        return "transparent";
      case "ghost":
        return join([color4, "ghost", state], "-");
      default:
        return join([color4, state], "-");
    }
  };
  const getTextColor = (color4, state) => {
    switch (mode) {
      case "fill":
        return "text-contrast-light";
      case "ghost":
        return join([color4, "ghost"], "-");
      default:
        return join([color4, state], "-");
    }
  };
  if (disabled) {
    return css`
      pointer-events: none;
      background-color: ${getBackgroundColor("surface-interactive-disabled")};
      border-color: ${getBorderColor("graphic-disabled")};
      cursor: not-allowed;
      color: text-disabled;
      svg {
        fill: text-disabled;
      }
    `;
  }
  return css`
    color: ${getTextColor(`text-interactive-${variant2}`)};
    svg {
      fill: ${getTextColor(`text-interactive-${variant2}`)};
    }

    background-color: ${getBackgroundColor(`surface-interactive-${variant2}`)};
    border-color: ${getBorderColor(`graphic-interactive-${variant2}`)};

    ${!readOnly && css`
      :hover {
        background-color: ${getBackgroundColor(`surface-interactive-${variant2}`, "hover")};
        border-color: ${getBorderColor(`graphic-interactive-${variant2}`, "hover")};
        color: ${getTextColor(`text-interactive-${variant2}`, "hover")};
        svg {
          fill: ${getTextColor(`text-interactive-${variant2}`, "hover")};
        }
      }

      :focus {
        background-color: ${getBackgroundColor(`surface-interactive-${variant2}`)};
        border-color: ${getBorderColor(`graphic-interactive-${variant2}`, "active")};
        color: ${getTextColor(`text-interactive-${variant2}`)};
        svg {
          fill: ${getTextColor(`text-interactive-${variant2}`)};
        }
      }

      :active {
        background-color: ${getBackgroundColor(`surface-interactive-${variant2}`, "active")};
        border-color: ${getBorderColor(`graphic-interactive-${variant2}`, "active")};
        color: ${getTextColor(`text-interactive-${variant2}`, "active")};
        svg {
          fill: ${getTextColor(`text-interactive-${variant2}`, "active")};
        }
      }
    `}
  `;
};
var makeButtonTypography = ({
  mode,
  buttonSize,
  disabled,
  theme
}) => {
  const typography3 = buttonSize === "xSmall" ? theme.typography.bodyMediumS : theme.typography.bodyMediumM;
  if (mode === "link") {
    return css`
      ${typography3}

      ${disabled ? void 0 : css`
            :hover,
            :active,
            :focus {
              text-decoration: underline;
            }
          `}
    `;
  }
  return css`
    ${typography3}

    :hover,
    :active,
    :focus {
      text-decoration: none;
    }
  `;
};
var makeButtonSize = ({ mode, buttonSize }) => {
  if (mode === "link") {
    return linkSizes[buttonSize];
  }
  return buttonSizes[buttonSize];
};
var makeIconButtonSize = ({ mode, buttonSize }) => {
  return css`
    svg {
      ${iconButtonSizes[buttonSize]}
    }
  `;
};
var shouldForwardProp = (prop) => !["mode", "buttonSize", "variant", "block", "shape"].includes(prop);
var spaceChildren = (children) => {
  return React122.Children.map(children, (child) => {
    if (typeof child === "string") {
      return /* @__PURE__ */ React122.createElement("span", null, child);
    }
    return child;
  });
};

// src/components/Button/Button.tsx
var ButtonContainer = styled54(Flex_default).withConfig({ shouldForwardProp })`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2;
  white-space: nowrap;
  text-align: center;
  font-family: default;
  transition: default;
  background-image: none;
  border: 1.5px solid transparent;
  touch-action: manipulation;
  border-radius: ${({ shape }) => getRadii(shape === "circle" ? "full" : "sm")};
  cursor: ${({ readOnly }) => readOnly ? "normal" : "pointer"};
  width: ${({ block }) => block ? "100%" : void 0};
  user-select: none;

  ${makeButtonVariant}
  ${makeButtonTypography}
  ${makeButtonSize}
  ${makeIconButtonSize}

  &,
  :not([disabled]):active,
  :active :focus {
    outline: 0;
  }

  :has(> *:only-child):has(> svg) {
    padding: 0;
  }
`;
var Button = forwardRef4(
  (_a, ref) => {
    var _b = _a, {
      size: size2,
      variant: variant2 = "primary",
      mode = "fill",
      disabled = false,
      readOnly = false,
      block = false,
      onClick,
      children,
      onMouseUp,
      shape = "default",
      type = "button",
      as = "button"
    } = _b, otherStyleProps = __objRest(_b, [
      "size",
      "variant",
      "mode",
      "disabled",
      "readOnly",
      "block",
      "onClick",
      "children",
      "onMouseUp",
      "shape",
      "type",
      "as"
    ]);
    const formContext = useFormContext();
    const buttonSize = size2 || (formContext == null ? void 0 : formContext.size) || "regular";
    const childrenNodes = spaceChildren(children);
    const handleMouseUp = React122.useCallback(
      (event) => {
        event.currentTarget.blur();
        onMouseUp == null ? void 0 : onMouseUp(event);
      },
      [onMouseUp]
    );
    return /* @__PURE__ */ React122.createElement(
      ButtonContainer,
      __spreadValues(__spreadProps(__spreadValues({}, { as, type, ref, buttonSize, variant: variant2, mode, disabled, readOnly, block, shape }), {
        onClick: readOnly ? void 0 : onClick,
        onMouseUp: handleMouseUp
      }), otherStyleProps),
      childrenNodes
    );
  }
);
Button.displayName = "Button";
var DropdownButton = React122.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      iconOpen = /* @__PURE__ */ React122.createElement(ChevronUpOutlined, null),
      iconClose = /* @__PURE__ */ React122.createElement(ChevronDownOutlined, null),
      variant: variant2 = "primary",
      children,
      "data-test": testId = "dropdown-button"
    } = _b, props = __objRest(_b, [
      "iconOpen",
      "iconClose",
      "variant",
      "children",
      "data-test"
    ]);
    const { open } = useDropdownContext();
    return /* @__PURE__ */ React122.createElement(Button, __spreadProps(__spreadValues({}, props), { variant: variant2, ref, "data-test": testId }), children, open ? iconOpen : iconClose);
  }
);
var useMenuSelection = ({
  selectionMode = "single",
  selectedKeys: controlledSelectedKeys,
  defaultSelectedKeys = [],
  onSelect,
  onDeselect,
  onSelectionChange,
  disabled
}) => {
  const [selectedKeys = [], setSelectedKeys] = useControllableState({
    prop: controlledSelectedKeys,
    defaultProp: selectionMode === "none" ? [] : defaultSelectedKeys,
    onChange: onSelectionChange
  });
  const computedSelectedKeys = React122.useMemo(() => {
    switch (selectionMode) {
      case "none":
        return [];
      case "single":
        return selectedKeys.length ? [selectedKeys[0]] : [];
      case "multiple":
        return selectedKeys;
    }
  }, [selectionMode, selectedKeys]);
  const onItemSelect = React122.useCallback(
    (key) => {
      if (disabled || selectionMode === "none") {
        return;
      }
      if (selectedKeys.includes(key)) {
        if (selectionMode === "multiple") {
          const nextSelectedKeys = selectedKeys.filter((k) => k !== key);
          setSelectedKeys(nextSelectedKeys);
          onDeselect == null ? void 0 : onDeselect(key, nextSelectedKeys);
        } else {
          const nextSelectedKeys = [key];
          setSelectedKeys(nextSelectedKeys);
          onSelect == null ? void 0 : onSelect(key, nextSelectedKeys);
        }
      } else {
        const nextSelectedKeys = selectionMode === "single" ? [key] : [...selectedKeys, key];
        setSelectedKeys(nextSelectedKeys);
        onSelect == null ? void 0 : onSelect(key, nextSelectedKeys);
      }
    },
    [selectedKeys, onDeselect, onSelect, disabled, selectionMode, setSelectedKeys]
  );
  return {
    onItemSelect,
    menuDisabled: disabled,
    selectedKeys: computedSelectedKeys,
    selectionMode,
    setSelectedKeys
  };
};
var MenuContext = React122.createContext(null);
var useMenu = () => {
  return React122.useContext(MenuContext);
};
var MenuProvider = ({
  selectionMode,
  size: size2,
  bordered = false,
  readOnly,
  selectedKeys: controlledSelectedKeys,
  defaultSelectedKeys = [],
  onSelect,
  onDeselect,
  onSelectionChange,
  disabled,
  children
}) => {
  const { menuDisabled, onItemSelect, selectedKeys, setSelectedKeys } = useMenuSelection({
    selectedKeys: controlledSelectedKeys,
    selectionMode,
    defaultSelectedKeys,
    onSelect,
    onDeselect,
    onSelectionChange,
    disabled
  });
  const value = React122.useMemo(
    () => ({
      selectionMode,
      menuDisabled,
      menuBordered: bordered,
      menuReadOnly: readOnly,
      onItemSelect,
      selectedKeys,
      size: size2,
      setSelectedKeys
    }),
    [
      bordered,
      menuDisabled,
      onItemSelect,
      readOnly,
      selectedKeys,
      selectionMode,
      setSelectedKeys,
      size2
    ]
  );
  return /* @__PURE__ */ React122.createElement(MenuContext.Provider, { value }, children);
};

// src/components/Form/hooks/useForm/useForm.ts
var useForm = ({ validationStatus, id, size: size2 }) => {
  var _a;
  const formContext = useFormContext();
  const formItemContext = useFormItemContext();
  const componentStatus = validationStatus != null ? validationStatus : formItemContext == null ? void 0 : formItemContext.validationStatus;
  const componentId = id != null ? id : formItemContext == null ? void 0 : formItemContext.name;
  const componentSize = (_a = size2 != null ? size2 : formContext == null ? void 0 : formContext.size) != null ? _a : "regular";
  const error = componentStatus === "error";
  return {
    componentStatus,
    componentId,
    componentSize,
    error
  };
};
var CheckboxLabel = styled(Typography_default).attrs({
  as: "span",
  "data-test": "checkbox-label"
})`
  grid-area: label;
  align-self: center;
  user-select: none;
  margin-left: 2;
`;
CheckboxLabel.displayName = "CheckboxLabel";

// src/components/Checkbox/constants.ts
var CHECKBOX_SIZES_MAP = {
  small: "16px",
  regular: "24px",
  large: "32px"
};
var CHECKBOX_TICK_SIZES_MAP = {
  small: "14px",
  regular: "22px",
  large: "30px"
};

// src/components/Checkbox/components/StyledCheckboxContainer.tsx
var makeCheckboxSize = ({ checkboxSize }) => {
  const size2 = CHECKBOX_SIZES_MAP[checkboxSize];
  return css`
    width: ${size2};
    height: ${size2};
  `;
};
var StyledCheckboxContainer = styled54(Flex_default)`
  position: relative;
  align-items: center;
  justify-content: center;
  transition: background 300ms, border-color 300ms;
  outline: 0;
  user-select: none;
  border: 1.5px solid transparent;
  border-radius: xs;

  input {
    // We can't focus on a hidden element. So we use opacity:0 instead of display: none here.
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  ${makeCheckboxSize}
`;
var CheckboxDescription = styled(Typography_default).attrs({
  as: "span",
  "data-test": "checkbox-description"
})`
  grid-area: description;
  margin-top: 2;
  margin-left: 2;
  user-select: none;
`;
CheckboxDescription.displayName = "CheckboxDescription";

// src/components/Checkbox/components/StyledCheckboxLayout.tsx
var makeCheckboxTypography = ({
  checkboxSize,
  disabled,
  theme
}) => {
  return css`
    ${CheckboxLabel} {
      ${checkboxSize === "small" ? theme.typography.bodyRegularS : theme.typography.bodyRegularM};
      color: ${getColor$1(disabled ? "text-disabled" : "text-base")};
    }

    ${CheckboxDescription} {
      ${theme.typography.supportingRegularS};
      color: ${getColor$1(disabled ? "text-disabled" : "text-secondary")};
    }
  `;
};
var makeCheckboxColor = ({
  checked,
  disabled,
  error
}) => {
  if (disabled) {
    return css`
      ${StyledCheckboxContainer} {
        background-color: ${getColor$1("surface-disabled")};
        border-color: ${getColor$1("graphic-disabled")};
      }
    `;
  }
  if (error) {
    return css`
      ${StyledCheckboxContainer} {
        background-color: ${getColor$1("surface-critical")};
        border-color: ${getColor$1("graphic-interactive-critical")};
      }

      &:hover {
        ${StyledCheckboxContainer} {
          border-color: ${getColor$1("graphic-interactive-critical-hover")};
        }
      }

      /* Using focus-within because the one receiving focus is the input, not the div. */
      &:focus-within,
      &:active {
        ${StyledCheckboxContainer} {
          border-color: ${getColor$1("graphic-interactive-critical-active")};
        }
      }
    `;
  }
  if (checked) {
    return css`
      ${StyledCheckboxContainer} {
        background-color: ${getColor$1("surface-interactive-primary")};
        border-color: ${getColor$1("graphic-interactive-primary")};
      }

      &:hover {
        ${StyledCheckboxContainer} {
          background-color: ${getColor$1("surface-interactive-primary-hover")};
          border-color: ${getColor$1("graphic-interactive-primary-hover")};
        }
      }

      /* Using focus-within because the one receiving focus is the input, not the div. */
      &:focus-within,
      &:active {
        ${StyledCheckboxContainer} {
          background-color: ${getColor$1("surface-interactive-primary-active")};
          border-color: ${getColor$1("graphic-interactive-primary-active")};
        }
      }
    `;
  }
  return css`
    ${StyledCheckboxContainer} {
      background-color: ${getColor$1("surface-interactive-default")};
      border-color: ${getColor$1("graphic-interactive-default")};
    }

    &:hover {
      ${StyledCheckboxContainer} {
        background-color: ${getColor$1("surface-interactive-default-hover")};
        border-color: ${getColor$1("graphic-interactive-default-hover")};
      }
    }

    /* Using focus-within because the one receiving focus is the input, not the div. */
    &:focus-within,
    &:active {
      ${StyledCheckboxContainer} {
        background-color: ${getColor$1("surface-interactive-default-active")};
        border-color: ${getColor$1("graphic-interactive-default-active")};
      }
    }
  `;
};
var StyledCheckboxLayout = styled54(Grid)`
  display: inline-grid;
  grid-template-areas:
    'icon label'
    '. description';
  grid-template-rows: 1fr auto;
  justify-content: flex-start;
  align-items: center;
  pointer-events: ${({ readOnly }) => readOnly ? "none" : "all"};

  &,
  input {
    cursor: ${({ disabled, readOnly }) => disabled || readOnly ? void 0 : "pointer"};
  }

  ${makeCheckboxTypography}
  ${makeCheckboxColor}
`;

// src/components/Checkbox/utils.ts
var getIndicatorColor = (disabled, error) => {
  if (disabled) {
    return "icon-disabled";
  }
  if (error) {
    return "icon-critical";
  }
  return "icon-contrast-light";
};

// src/components/Checkbox/Checkbox.tsx
var Checkbox = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      disabled = false,
      size: size2,
      checked: checkedProp,
      validationStatus,
      defaultChecked = false,
      onChange,
      children,
      id,
      readOnly,
      autoFocus,
      onMouseUp
    } = _b, otherStyleProps = __objRest(_b, [
      "disabled",
      "size",
      "checked",
      "validationStatus",
      "defaultChecked",
      "onChange",
      "children",
      "id",
      "readOnly",
      "autoFocus",
      "onMouseUp"
    ]);
    const { componentId, componentSize, error } = useForm({ validationStatus, id, size: size2 });
    const [checked = defaultChecked, setChecked] = useControllableState({
      prop: checkedProp,
      defaultProp: defaultChecked,
      onChange
    });
    const handleOnChange = useCallback(
      (event) => {
        if (!disabled) {
          const { checked: checked2 } = event.target;
          setChecked(checked2);
        }
      },
      [disabled, setChecked]
    );
    const handleMouseUp = React122__default.useCallback(
      (event) => {
        event.currentTarget.blur();
        onMouseUp == null ? void 0 : onMouseUp(event);
      },
      [onMouseUp]
    );
    const childNode = typeof children === "string" ? /* @__PURE__ */ React122__default.createElement(CheckboxLabel, null, children) : children;
    return /* @__PURE__ */ React122__default.createElement(
      StyledCheckboxLayout,
      __spreadValues(__spreadValues({
        as: "label",
        htmlFor: componentId
      }, { readOnly, disabled, checkboxSize: componentSize, error, checked }), otherStyleProps),
      /* @__PURE__ */ React122__default.createElement(StyledCheckboxContainer, { gridArea: "icon", checkboxSize: componentSize }, /* @__PURE__ */ React122__default.createElement(
        "input",
        {
          id: componentId,
          ref,
          "data-test": "checkbox",
          type: "checkbox",
          "aria-checked": checked,
          autoFocus,
          checked,
          disabled,
          onChange: handleOnChange,
          onMouseUp: handleMouseUp
        }
      ), checked && /* @__PURE__ */ React122__default.createElement(
        TickOutlined,
        {
          "data-test": "checkbox-check",
          color: getIndicatorColor(disabled, error),
          size: CHECKBOX_TICK_SIZES_MAP[componentSize]
        }
      )),
      childNode
    );
  }
);
Checkbox.displayName = "Checkbox";
var MenuItemCheckArea = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122.createElement(Box_default, __spreadProps(__spreadValues({}, boxProps), { gridArea: "checked", ml: 2, w: 24 }), children);
};
var MenuItemCheckboxArea = (_a) => {
  var _b = _a, {
    children
  } = _b, flexProps = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React122.createElement(Flex_default, __spreadProps(__spreadValues({}, flexProps), { gridArea: "checkbox", mr: 2 }), children);
};
var size = style({
  prop: "size",
  css: ["width", "height"]
});
var IconContext = React122__default.createContext(null);
var IconProvider = IconContext.Provider;
var useIconContext = () => React122__default.useContext(IconContext);

// src/components/Icon/utils.ts
var shouldForwardProp2 = (prop, defaultValidationFn) => !["size", "color", "mode"].includes(prop) && defaultValidationFn(prop);

// src/components/Icon/Icon.tsx
var rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
var IconContainer = styled54(Box_default).withConfig({
  shouldForwardProp: shouldForwardProp2
})`
  line-height: 0;
  cursor: ${({ onClick }) => onClick && "pointer"};
  ${space};

  > svg {
    ${size};
    ${color};
    ${opacity};
    animation: ${({ spin }) => spin && css`
        ${rotate} 2s linear infinite
      `};
  }
`;
var Icon = forwardRef(
  (_a, ref) => {
    var _b = _a, { component: Component, size: size2 = "24px", spin, color: color4 } = _b, otherStyleProps = __objRest(_b, ["component", "size", "spin", "color"]);
    const iconContext = useIconContext();
    let IconComponent = null;
    if (typeof Component === "string") {
      if (!iconContext) {
        console.error(
          "Cannot select the icon component without the icons given using the `<IconProvider>`."
        );
        return null;
      }
      const selectableIcons = iconContext.icons;
      const IconComp = selectableIcons == null ? void 0 : selectableIcons[Component];
      if (!IconComp) {
        console.error(
          `Cannot find the corresponding icon component: ${Component}. Available icons are:`,
          Object.keys(selectableIcons || {})
        );
        return null;
      }
      IconComponent = IconComp;
    } else {
      IconComponent = Component;
    }
    return /* @__PURE__ */ React122__default.createElement(IconContainer, __spreadValues({ ref, size: size2, spin, color: color4 }, otherStyleProps), /* @__PURE__ */ React122__default.createElement(IconComponent, null));
  }
);
var Icon_default = Icon;
var MenuItemCheckIcon = () => {
  return /* @__PURE__ */ React122.createElement(Icon_default, { component: TickOutlined, size: 24, color: "icon-primary" });
};
var StyledMenuItemLabel = styled54(Typography_default)``;
var MenuItemLabel = (_a) => {
  var _b = _a, {
    children
  } = _b, typographyProps = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React122.createElement(StyledMenuItemLabel, __spreadProps(__spreadValues({ variant: "bodyRegularS" }, typographyProps), { gridArea: "label" }), children);
};
var StyledMenuItemDescription = styled54(Typography_default)``;
var MenuItemDescription = (_a) => {
  var _b = _a, {
    children
  } = _b, typographyProps = __objRest(_b, [
    "children"
  ]);
  return /* @__PURE__ */ React122.createElement(
    StyledMenuItemDescription,
    __spreadProps(__spreadValues({
      color: "text-secondary",
      variant: "supportingRegularS"
    }, typographyProps), {
      gridArea: "description"
    }),
    children
  );
};

// src/components/Menu/components/StyledMenuItem.ts
var MENU_ITEM_SIZES = {
  small: "40px",
  regular: "48px",
  large: "56px",
  xLarge: "64px"
};
var makeMenuItemInteractive = ({
  disabled,
  readOnly
}) => {
  return css`
    cursor: ${disabled ? "not-allowed" : readOnly ? "normal" : "pointer"};
  `;
};
var makeMenuItemDisabled = ({ disabled }) => {
  if (!disabled) {
    return css`
      &,
      &:hover,
      &:active {
        color: ${getColor("text-base")};
      }
    `;
  }
  return css`
    color: ${getColor("text-disabled")};
    background-color: ${getColor("surface-disabled")};

    ${StyledMenuItemLabel} {
      color: ${getColor("text-disabled")};
    }

    ${StyledMenuItemDescription} {
      color: ${getColor("text-disabled")};
    }
  `;
};
var makeMenuItemSize = ({ size: size2 }) => {
  const itemSize = MENU_ITEM_SIZES[size2];
  return css`
    height: ${itemSize};
  `;
};
var makeMenuItemBorder = ({ bordered }) => {
  return css`
    border-top: 1px solid;
    border-top-color: ${bordered ? getColor("graphic-default") : "transparent"};
    &:last-child {
      border-bottom: 1px solid;
      border-bottom-color: ${bordered ? getColor("graphic-default") : "transparent"};
    }
  `;
};
var makeMenuItemVariant = ({ disabled, readOnly }) => {
  if (disabled) {
    return null;
  }
  return css`
    background-color: ${getColor("surface-interactive-default")};

    ${!readOnly && css`
      :hover {
        background-color: ${getColor("surface-interactive-default-hover")};
      }

      :active,
      :focus {
        background-color: ${getColor("surface-interactive-default-active")};
      }
    `}
  `;
};
var StyledMenuItem = styled54(Grid).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop)
})(
  ({ theme }) => css`
    position: relative;
    justify-content: flex-start;
    align-items: center;
    grid-template-areas:
      'checkbox prefix label suffix checked'
      'checkbox prefix description suffix checked';
    grid-template-rows: 1fr auto;
    grid-template-columns: auto auto 1fr auto auto;
    padding: 0 4;
    user-select: none;
    transition: default;

    :hover,
    :active,
    :focus {
      text-decoration: none;
    }

    :has(${StyledMenuItemDescription}) {
      grid-template-rows: auto auto;

      ${StyledMenuItemLabel} {
        align-self: flex-end;
      }

      ${StyledMenuItemDescription} {
        align-self: flex-start;
      }
    }

    ${theme.typography.bodyRegularS}
    ${makeMenuItemInteractive}
    ${makeMenuItemDisabled}
    ${makeMenuItemSize}
    ${makeMenuItemBorder}
    ${makeMenuItemVariant}
  `
);

// src/components/Menu/components/MenuItem.tsx
var MenuItem = forwardRef4(
  (_a, ref) => {
    var _b = _a, { itemKey, children, disabled, onClick, readOnly, as = "div", bordered, size: size2 } = _b, rootProps = __objRest(_b, ["itemKey", "children", "disabled", "onClick", "readOnly", "as", "bordered", "size"]);
    var _a2;
    const {
      onItemSelect,
      menuDisabled,
      selectedKeys,
      selectionMode,
      size: menuSize,
      menuBordered,
      menuReadOnly
    } = useMenu();
    const itemSize = size2 != null ? size2 : menuSize;
    const itemDisabled = disabled != null ? disabled : menuDisabled;
    const itemBordered = bordered != null ? bordered : menuBordered;
    const itemReadOnly = (_a2 = readOnly != null ? readOnly : menuReadOnly) != null ? _a2 : selectionMode === "none" && !onClick && as !== "a" && !("href" in rootProps);
    const isSelected = React122__default.useMemo(
      () => selectionMode !== "none" && itemKey !== void 0 && selectedKeys.includes(itemKey),
      [selectionMode, itemKey, selectedKeys]
    );
    const childNode = typeof children === "string" ? /* @__PURE__ */ React122__default.createElement(MenuItemLabel, null, children) : children;
    const isSingleSelected = selectionMode === "single" && isSelected;
    const handleItemClick = React122__default.useCallback(
      (event) => {
        onItemSelect(itemKey);
        onClick == null ? void 0 : onClick(event);
      },
      [onItemSelect, onClick, itemKey]
    );
    return /* @__PURE__ */ React122__default.createElement(
      StyledMenuItem,
      __spreadValues({
        as,
        ref,
        disabled: itemDisabled,
        readOnly: itemReadOnly,
        size: itemSize,
        onClick: readOnly || itemDisabled ? void 0 : handleItemClick,
        "data-test": itemKey ? `menu-item-${itemKey}` : "menu-item",
        "data-selected": isSelected,
        "data-disabled": itemDisabled,
        bordered: itemBordered
      }, rootProps),
      selectionMode === "multiple" && /* @__PURE__ */ React122__default.createElement(MenuItemCheckboxArea, null, /* @__PURE__ */ React122__default.createElement(Checkbox, { checked: isSelected, size: "small" })),
      childNode,
      selectionMode === "single" && /* @__PURE__ */ React122__default.createElement(MenuItemCheckArea, null, isSingleSelected && /* @__PURE__ */ React122__default.createElement(MenuItemCheckIcon, null))
    );
  }
);
var sizes = {
  xSmall: "1px",
  small: "2px"
};
var Divider = (_a) => {
  var _b = _a, {
    size: size2 = "small",
    orientation = "vertical",
    bg = "graphic-default"
  } = _b, props = __objRest(_b, [
    "size",
    "orientation",
    "bg"
  ]);
  const dividerStyle = {
    vertical: {
      w: sizes[size2] || sizes.small,
      h: "100%"
    },
    horizontal: {
      h: sizes[size2] || sizes.small,
      w: "100%"
    }
  };
  return /* @__PURE__ */ React122__default.createElement(Box_default, __spreadValues(__spreadValues({}, dividerStyle[orientation]), props));
};

// src/components/Divider/Divider.decl.ts
var DividerSize = /* @__PURE__ */ ((DividerSize2) => {
  DividerSize2["X_SMALL"] = "xSmall";
  DividerSize2["SMALL"] = "small";
  return DividerSize2;
})(DividerSize || {});
var DividerOrientation = /* @__PURE__ */ ((DividerOrientation2) => {
  DividerOrientation2["VERTICAL"] = "vertical";
  DividerOrientation2["HORIZONTAL"] = "horizontal";
  return DividerOrientation2;
})(DividerOrientation || {});

// src/components/Menu/components/MenuItemGroup.tsx
var MenuItemGroup = ({ title, divider = false, children }) => {
  const { menuDisabled } = useMenu();
  return /* @__PURE__ */ React122.createElement(Box_default, { "data-test": "menu-item-group" }, title && /* @__PURE__ */ React122.createElement(
    Typography_default,
    {
      variant: "supportingMediumS",
      color: menuDisabled ? "text-disabled" : "text-placeholder",
      py: 2,
      px: 4
    },
    title
  ), divider && /* @__PURE__ */ React122.createElement(Divider, { orientation: "horizontal", size: "xSmall", color: "graphic-default", my: 2 }), /* @__PURE__ */ React122.createElement(Box_default, null, children));
};
var MenuItemPrefix = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122__default.createElement(Box_default, __spreadProps(__spreadValues({}, boxProps), { mr: 2, gridArea: "prefix" }), children);
};
var MenuItemSuffix = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122__default.createElement(Box_default, __spreadProps(__spreadValues({}, boxProps), { ml: 2, gridArea: "suffix" }), children);
};
var makeMenuBorder = ({ bordered }) => {
  return css`
    border-left: 1px solid ${bordered ? getColor("graphic-default") : "transparent"};
    border-right: 1px solid ${bordered ? getColor("graphic-default") : "transparent"};
  `;
};
var StyledMenu = styled54(Box_default)`
  user-select: none;
  text-align: left;
  ${makeMenuBorder};
`;

// src/components/Menu/Menu.tsx
var Menu = (_a) => {
  var _b = _a, {
    children,
    defaultSelectedKeys = [],
    selectedKeys,
    onItemSelected: onSelect,
    onItemDeselected: onDeselect,
    onSelectionChange,
    disabled,
    selectionMode = "none",
    size: size2 = "regular",
    bordered = false,
    readOnly
  } = _b, otherStyleProps = __objRest(_b, [
    "children",
    "defaultSelectedKeys",
    "selectedKeys",
    "onItemSelected",
    "onItemDeselected",
    "onSelectionChange",
    "disabled",
    "selectionMode",
    "size",
    "bordered",
    "readOnly"
  ]);
  return /* @__PURE__ */ React122.createElement(
    MenuProvider,
    __spreadValues({}, {
      selectedKeys,
      selectionMode,
      defaultSelectedKeys,
      onSelect,
      onDeselect,
      onSelectionChange,
      disabled,
      bordered,
      readOnly,
      size: size2
    }),
    /* @__PURE__ */ React122.createElement(
      StyledMenu,
      __spreadValues({
        "data-test": "menu",
        role: "menu",
        minWidth: 220,
        bordered
      }, otherStyleProps),
      children
    )
  );
};

// src/components/ActionMenu/ActionMenu.tsx
var ActionMenu = ({ items, trigger, side, align }) => {
  return /* @__PURE__ */ React122.createElement(Dropdown, { "data-test": "action-menu", trigger, side, align }, /* @__PURE__ */ React122.createElement(Menu, { selectionMode: "none" }, items.map((_a, index) => {
    var _b = _a, { name, prefix } = _b, menuItemProps = __objRest(_b, ["name", "prefix"]);
    return /* @__PURE__ */ React122.createElement(MenuItem, __spreadValues({ key: index }, menuItemProps), prefix && /* @__PURE__ */ React122.createElement(MenuItemPrefix, null, prefix), /* @__PURE__ */ React122.createElement(MenuItemLabel, null, name));
  })));
};

// src/contexts/AudioManager/AudioManager.decl.ts
var defaultMangerContext = {
  play: noop,
  unregister: noop
};

// src/contexts/AudioManager/AudioManager.context.ts
var AudioManagerContext = React122__default.createContext(defaultMangerContext);
var useAudioManager = () => useContext(AudioManagerContext);
var usePlay = (currentAudio) => useCallback(
  (audioRef) => __async(void 0, null, function* () {
    var _a;
    if (currentAudio.current !== audioRef) {
      (_a = currentAudio.current) == null ? void 0 : _a.pause();
      currentAudio.current = audioRef;
    }
    yield currentAudio.current.play();
  }),
  [currentAudio]
);
var useUnregister = (currentAudio) => useCallback(
  (audioRef) => {
    var _a;
    if (currentAudio.current === audioRef) {
      (_a = currentAudio.current) == null ? void 0 : _a.pause();
      currentAudio.current = null;
    }
  },
  [currentAudio]
);

// src/contexts/AudioManager/AudioManager.tsx
var AudioManager = ({ children }) => {
  const currentAudio = useRef(null);
  const play = usePlay(currentAudio);
  const unregister = useUnregister(currentAudio);
  const context = useMemo(() => ({ play, unregister }), [play, unregister]);
  return /* @__PURE__ */ React122__default.createElement(AudioManagerContext.Provider, { value: context }, children);
};
var defaultAudioContext = {
  duration: 0,
  togglePlay: () => __async(void 0, null, function* () {
  }),
  play: () => __async(void 0, null, function* () {
  }),
  pause: noop,
  isPlaying: false,
  seek: noop,
  fastForward: noop,
  rewind: noop,
  speed: 1,
  setSpeed: noop,
  error: null
};
var AudioContext = React122__default.createContext(defaultAudioContext);
var AudioTimeContext = React122__default.createContext({ currentTime: 0 });
var useAudio = () => useContext(AudioContext);
var useAudioTime = () => useContext(AudioTimeContext);
function useDuration(audioRef) {
  const [duration, setDuration] = useState(0);
  useEffect(() => {
    const audio = audioRef.current;
    const updateDuration = () => {
      setDuration(audioRef.current.duration);
    };
    audio.addEventListener("loadedmetadata", updateDuration);
    return () => audio.removeEventListener("loadedmetadata", updateDuration);
  }, [audioRef, setDuration]);
  return duration;
}
function usePlayPause(audioRef) {
  const { play: managerPlay } = useAudioManager();
  const [isPlaying, setIsPlaying] = useState(false);
  const togglePlay = useCallback(() => __async(this, null, function* () {
    if (audioRef.current.paused) {
      yield managerPlay(audioRef.current);
    } else {
      audioRef.current.pause();
    }
  }), [audioRef, managerPlay]);
  const play = useCallback(() => __async(this, null, function* () {
    yield managerPlay(audioRef.current);
  }), [audioRef, managerPlay]);
  const pause = useCallback(() => __async(this, null, function* () {
    audioRef.current.pause();
  }), [audioRef]);
  useOnPlayPauseEvent(setIsPlaying, audioRef);
  return { isPlaying, togglePlay, play, pause };
}
function useOnPlayPauseEvent(setIsPlaying, audioRef) {
  useEffect(() => {
    const pause = () => setIsPlaying(false);
    const play = () => setIsPlaying(true);
    const audioElem = audioRef.current;
    audioElem.addEventListener("pause", pause);
    audioElem.addEventListener("play", play);
    return () => {
      audioElem.removeEventListener("pause", pause);
      audioElem.removeEventListener("play", play);
    };
  }, [audioRef, setIsPlaying]);
}
var SKIPPING_INTERVAL = 10;
function useAudioTime2(audioRef) {
  const [currentTime, setCurrentTime] = useState(0);
  const seek = useCallback(
    (time) => {
      audioRef.current.currentTime = time;
      setCurrentTime(time);
    },
    [audioRef, setCurrentTime]
  );
  const fastForward = useCallback(() => {
    seek(audioRef.current.currentTime + SKIPPING_INTERVAL);
  }, [audioRef, seek]);
  const rewind = useCallback(() => {
    seek(audioRef.current.currentTime - SKIPPING_INTERVAL);
  }, [audioRef, seek]);
  useOnTimeUpdateEvent(audioRef, setCurrentTime);
  return { currentTime, seek, fastForward, rewind };
}
function useOnTimeUpdateEvent(audioRef, setTime) {
  useEffect(() => {
    const audioElem = audioRef.current;
    const handleOnTimeUpdate = () => {
      setTime(audioElem.currentTime);
    };
    audioElem.addEventListener("timeupdate", handleOnTimeUpdate);
    return () => {
      audioElem.removeEventListener("timeupdate", handleOnTimeUpdate);
    };
  }, [audioRef, setTime]);
}
function useAudioRef() {
  const audioRef = useRef(new Audio());
  const { unregister } = useAudioManager();
  useEffect(() => {
    const audio = audioRef.current;
    return () => unregister(audio);
  }, [unregister]);
  return audioRef;
}
function useSrcChanged(src, audioRef, seek, setError) {
  useEffect(() => {
    const audio = audioRef.current;
    const previousSpeed = audioRef.current.playbackRate;
    setTimeout(() => {
      audio.src = src;
      audio.playbackRate = previousSpeed;
    }, 0);
    return () => {
      audio.pause();
      setError(null);
    };
  }, [src, seek, audioRef, setError]);
}
var useSpeed = (audioRef) => {
  const [rate, setRate] = useState(1);
  const setSpeed = useCallback(
    (speed) => {
      audioRef.current.playbackRate = speed;
      setRate(speed);
    },
    [audioRef, setRate]
  );
  return { speed: rate, setSpeed };
};
var useAudioError = (audioRef) => {
  const [error, setError] = useState(null);
  useEffect(() => {
    const listener = (event) => {
      const audioElement = event.target;
      setError(audioElement.error);
    };
    const audio = audioRef.current;
    audio.addEventListener("error", listener);
    return () => {
      audio.removeEventListener("error", listener);
    };
  }, [audioRef, setError]);
  return { error, setError };
};
var useSetDeviceId = (audioRef, sinkId) => {
  useEffect(() => {
    if (!sinkId) {
      return;
    }
    if (!audioRef.current.setSinkId) {
      console.warn("HTMLAudioElement, setSinkId is not supported in this browser");
      return;
    }
    audioRef.current.setSinkId(sinkId);
  }, [audioRef, sinkId]);
};

// src/contexts/Audio/Audio.tsx
function Audio2({ src, sinkId, children }) {
  const audioRef = useAudioRef();
  const duration = useDuration(audioRef);
  const { seek, rewind, fastForward, currentTime } = useAudioTime2(audioRef);
  const { isPlaying, togglePlay, play, pause } = usePlayPause(audioRef);
  const { setSpeed, speed } = useSpeed(audioRef);
  const { error, setError } = useAudioError(audioRef);
  useSrcChanged(src, audioRef, seek, setError);
  useSetDeviceId(audioRef, sinkId);
  const context = useMemo(
    () => ({
      duration,
      isPlaying,
      play,
      pause,
      togglePlay,
      seek,
      fastForward,
      rewind,
      setSpeed,
      speed,
      error
    }),
    [
      duration,
      isPlaying,
      play,
      pause,
      togglePlay,
      seek,
      fastForward,
      rewind,
      setSpeed,
      speed,
      error
    ]
  );
  return /* @__PURE__ */ React122__default.createElement(AudioContext.Provider, { value: context }, /* @__PURE__ */ React122__default.createElement(AudioTimeContext.Provider, { value: { currentTime } }, children));
}

// src/components/AudioPlayer/AudioPlayer.utils.ts
var colorsMapper = {
  green: "surface-interactive-primary",
  yellow: "surface-interactive-warning",
  default: "surface-interactive-secondary"
};

// src/components/AudioPlayer/components/AudioBar/components/AudioThumb/utils.ts
var convertPositionToSec = (mouseXPos, { width, left }, duration) => {
  if (!width || left === void 0)
    return 0;
  const relativePos = mouseXPos - left;
  const percentage = Math.max(0, Math.min(1, relativePos / width));
  return percentage * duration;
};
var getPercentage = (value, total) => total > 0 ? value * 100 / total : 0;

// src/components/AudioPlayer/components/AudioBar/hooks/useMouseMove.ts
function useMouseMove(isDragging, mouseRelativeToThumb, containerRef) {
  const { seek, duration } = useAudio();
  const containerDim = useRect(containerRef.current);
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isDragging && containerDim) {
        e.preventDefault();
        const mouseX = e.clientX - mouseRelativeToThumb.current;
        const position = convertPositionToSec(mouseX, containerDim, duration);
        seek(position);
      }
    };
    document.addEventListener("mousemove", handleMouseMove);
    return () => document.removeEventListener("mousemove", handleMouseMove);
  }, [isDragging, mouseRelativeToThumb, containerDim, seek, duration]);
}
function useThumbMouseUp(setIsDragging) {
  const { play, duration } = useAudio();
  const { currentTime } = useAudioTime();
  const isEnded = useRef();
  isEnded.current = currentTime === duration;
  useEffect(() => {
    const handleMouseUp = () => {
      setIsDragging((isDragging) => {
        if (!isDragging)
          return isDragging;
        if (!isEnded.current)
          play();
        return false;
      });
    };
    document.addEventListener("mouseup", handleMouseUp);
    return () => document.removeEventListener("mouseup", handleMouseUp);
  }, [play, setIsDragging, isEnded]);
}

// src/components/AudioPlayer/components/AudioBar/hooks/useThumbDragging.ts
var useThumbDragging = (containerRef) => {
  const mouseRelativeToThumb = useRef(0);
  const [isDragging, setIsDragging] = useState(false);
  useMouseMove(isDragging, mouseRelativeToThumb, containerRef);
  useThumbMouseUp(setIsDragging);
  const { pause } = useAudio();
  const handleMouseDown = useCallback(
    (e) => {
      if (e.button === 0) {
        pause();
        const elem = e.target;
        const { left, width } = elem.getBoundingClientRect();
        mouseRelativeToThumb.current = e.clientX - left - width / 2;
        setIsDragging(true);
      }
    },
    [pause, setIsDragging, mouseRelativeToThumb]
  );
  return { handleMouseDown };
};
var Thumb = styled54.div.attrs(({ value }) => ({
  style: {
    left: `calc(${value}%)`
  }
}))`
  z-index: 10;
  position: absolute;
  width: 16px;
  height: 16px;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: ew-resize;

  // Drawing the circle thumb
  &::before {
    content: '';
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 16px;
    z-index: 10;
    box-shadow: 1;
    ${({ color: color4 }) => css`
        background-color: ${color4};
        border: 2px solid ${getColor("icon-contrast-light")};
        border-radius: 50%;
      `}
  }

  // Drawing the cursor thumb
  &::after {
    height: ${({ height = "100%" }) => height};
    left: 50%;
    transform: translateX(-50%);
    content: '';
    position: absolute;
    border-left: 2px solid ${getColor("graphic-default")};
  }
`;

// src/components/AudioPlayer/components/AudioBar/components/AudioThumb/AudioThumb.tsx
function AudioThumb({ currentTime, children, height, color: color4, disabled }) {
  const containerRef = useRef(null);
  const { duration } = useAudio();
  const { handleMouseDown } = useThumbDragging(containerRef);
  const thumbPosition = getPercentage(currentTime, duration);
  return /* @__PURE__ */ React122__default.createElement(
    Box_default,
    {
      position: "relative",
      cursor: disabled ? "none" : "pointer",
      pointerEvents: disabled ? "none" : "auto",
      ref: containerRef
    },
    /* @__PURE__ */ React122__default.createElement(
      Thumb,
      {
        value: thumbPosition,
        onMouseDown: handleMouseDown,
        height,
        color: duration ? color4 : "graphic-disabled",
        "data-test": "audio-thumb"
      }
    ),
    children
  );
}
var Bar = styled54.div.attrs(
  ({ value, fillerColor, barColor }) => ({
    style: {
      backgroundImage: `linear-gradient(90deg, 
        ${fillerColor} ${value}%, ${barColor} ${value}%)`
    }
  })
)`
  width: 100%;
  height: 4px;
  border-radius: sm;
  position: relative;
  overflow: hidden;
`;

// src/components/AudioPlayer/components/AudioBar/AudioBar.tsx
var AudioBar = ({ height = "0px", color: color4 = "green", disabled }) => {
  const { duration, seek } = useAudio();
  const { currentTime } = useAudioTime();
  const computedColor = disabled ? "graphic-disabled" : colorsMapper[color4];
  const handleOnClick = (e) => {
    const { left, width } = e.currentTarget.getBoundingClientRect();
    const x5 = e.clientX - left;
    seek(x5 / width * duration);
  };
  const barColor = useColor("graphic-default");
  const fillColor = useColor(computedColor);
  return /* @__PURE__ */ React122__default.createElement(
    AudioThumb,
    {
      currentTime,
      height,
      color: computedColor,
      disabled: disabled || !duration
    },
    /* @__PURE__ */ React122__default.createElement(
      Bar,
      {
        barColor,
        fillerColor: fillColor,
        value: getPercentage(currentTime, duration),
        onClick: disabled ? void 0 : handleOnClick,
        "data-test": "bar"
      }
    )
  );
};

// src/components/AudioPlayer/utils.ts
var _getSeconds = (time) => {
  const s = Math.floor(time % 60);
  return s < 10 ? `0${s}` : `${s}`;
};
var _getMinutes = (time) => {
  const h = Math.floor(time / 3600);
  const m = Math.floor(time / 60 % 60);
  const needsZeroAppending = m < 10 && m > 0 || m === 0 && h > 0;
  return needsZeroAppending ? `0${m}` : `${m}`;
};
var _getHours = (time) => Math.floor(time / 3600);
var formatTime = (time) => {
  const result = `${_getMinutes(time)}:${_getSeconds(time)}`;
  const hours = _getHours(time);
  return hours > 0 ? `${hours}:${result}` : result;
};

// src/components/AudioPlayer/components/AudioCurrentTime.tsx
var AudioCurrentTime = () => {
  const { currentTime } = useAudioTime();
  return /* @__PURE__ */ React122__default.createElement(Typography_default, { variant: "supportingRegularS", color: currentTime ? "text-base" : "text-placeholder" }, formatTime(currentTime));
};
var AudioDuration = () => {
  const { duration } = useAudio();
  return /* @__PURE__ */ React122__default.createElement(Typography_default, { variant: "supportingRegularS", color: "text-placeholder" }, formatTime(duration));
};

// src/components/AudioPlayer/components/PlayButton/hooks/useAudioStatus.ts
var STATUS = {
  playing: "playing",
  paused: "paused",
  ended: "ended"
};
var useAudioStatus = () => {
  const { isPlaying, duration } = useAudio();
  const { currentTime } = useAudioTime();
  if (isPlaying)
    return STATUS.playing;
  const ended = currentTime === duration && duration !== 0;
  return ended ? STATUS.ended : STATUS.paused;
};
var Button2 = styled54(Flex_default)`
  position: relative;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: pointer;
  pointer-events: ${({ disabled }) => disabled ? "none" : "auto"};
  background-color: ${({ disabled, color: color4 }) => disabled ? getColor("surface-interactive-disabled") : getColor(color4)};
`;
var Transition = styled54(Flex_default)`
  position: absolute;
  pointer-events: none;
  transition: all 0.7s;
  transform: ${({ reverse }) => `rotate(${reverse ? 180 : -180}deg)`};
  opacity: 0;

  ${({ show }) => show && css`
      transform: rotate(0);
      opacity: 1;
    `};
`;

// src/components/AudioPlayer/components/PlayButton/PlayButton.tsx
var PlayButton = ({ color: color4 = "green", disabled = false, loading = false }) => {
  const { togglePlay, seek, duration } = useAudio();
  const status = useAudioStatus();
  const handleOnClick = () => __async(void 0, null, function* () {
    if (status === STATUS.ended)
      seek(0);
    yield togglePlay();
  });
  let buttonContents = /* @__PURE__ */ React122__default.createElement(React122__default.Fragment, null, /* @__PURE__ */ React122__default.createElement(Transition, { show: status === STATUS.paused, "data-test": STATUS.paused, reverse: true }, /* @__PURE__ */ React122__default.createElement(PlayFilled, { color: "icon-contrast-light" })), /* @__PURE__ */ React122__default.createElement(Transition, { show: status === STATUS.playing, "data-test": STATUS.playing }, /* @__PURE__ */ React122__default.createElement(PauseFilled, { color: "icon-contrast-light" })), /* @__PURE__ */ React122__default.createElement(Transition, { show: status === STATUS.ended, "data-test": STATUS.ended, reverse: true }, /* @__PURE__ */ React122__default.createElement(ReplayFilled, { color: "icon-contrast-light" })));
  if (disabled) {
    buttonContents = /* @__PURE__ */ React122__default.createElement(Transition, { show: true, "data-test": "disabled", reverse: true }, /* @__PURE__ */ React122__default.createElement(PlayFilled, { color: "icon-disabled" }));
  }
  if (loading) {
    buttonContents = /* @__PURE__ */ React122__default.createElement(
      Icon_default,
      {
        spin: true,
        component: LoadingRedoUndoOutlined,
        color: "icon-contrast-light",
        "data-test": "loading"
      }
    );
  }
  return /* @__PURE__ */ React122__default.createElement(Button2, { onClick: handleOnClick, color: colorsMapper[color4], disabled: disabled || !duration }, buttonContents);
};
var QuickAudioPlayer = ({ src, color: color4 = "green" }) => /* @__PURE__ */ React122__default.createElement(Audio2, { src }, /* @__PURE__ */ React122__default.createElement(Grid, { gridTemplateColumns: "auto 1fr", columnGap: "16px", w: "100%" }, /* @__PURE__ */ React122__default.createElement(PlayButton, { color: color4 }), /* @__PURE__ */ React122__default.createElement(Box_default, null, /* @__PURE__ */ React122__default.createElement(Flex_default, { justifyContent: "space-between", pb: "8px" }, /* @__PURE__ */ React122__default.createElement(AudioCurrentTime, null), /* @__PURE__ */ React122__default.createElement(AudioDuration, null)), /* @__PURE__ */ React122__default.createElement(AudioBar, { color: color4 }))));

// src/components/Avatar/constant.ts
var AVATAR_VARIANT_COLORS_MAP = {
  blue: {
    color: "informative-500",
    borderColor: "informative-500"
  },
  green: {
    color: "primary-500",
    borderColor: "primary-500"
  },
  yellow: {
    color: "warning-500",
    borderColor: "warning-500"
  },
  default: {
    color: "text-secondary",
    borderColor: "graphic-neutral"
  },
  purple: {
    color: "decorative1-600",
    borderColor: "decorative1-600"
  },
  peach: {
    color: "decorative2-700",
    borderColor: "decorative2-700"
  }
};

// src/components/Avatar/constants.ts
var avatarSizes = {
  small: "24px",
  regular: "32px",
  large: "48px",
  xLarge: "64px"
};
var iconSizes = {
  small: "16px",
  regular: "16px",
  large: "24px",
  xLarge: "32px"
};
var avatarVariants = ["green", "yellow", "blue"];

// src/components/Avatar/components/StyledAvatar/StyledAvatar.tsx
var makeAvatarSize = ({ size: size2 }) => {
  const avatarSize = avatarSizes[size2];
  return {
    width: avatarSize,
    height: avatarSize
  };
};
var makeAvatarColor = ({ disabled, variant: variant2 }) => {
  if (disabled) {
    return css`
      background-color: ${getColor("graphic-disabled")};
      color: ${getColor("text-disabled")};

      ::after {
        background-color: ${getColor(`surface-disabled`)};
      }
    `;
  }
  return css`
    background-color: ${getColor(AVATAR_VARIANT_COLORS_MAP[variant2].borderColor)};
    color: ${getColor(AVATAR_VARIANT_COLORS_MAP[variant2].color)};
    ::after {
      background-color: ${getColor("surface-default")};
    }
  `;
};
var StyledAvatar = styled(Flex_default)`
  position: relative;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  user-select: none;
  font-family: default;
  clip-path: url(#svgPath);
  ${makeAvatarSize}
  ${makeAvatarColor}

  &::after {
    --border-width: 1px;
    content: '';
    position: absolute;
    clip-path: url(#svgPath);
    /* this represents the 1px border around the squircle shape */
    top: var(--border-width, 1px);
    left: var(--border-width, 1px);
    right: var(--border-width, 1px);
    bottom: var(--border-width, 1px);
    z-index: -1;
    ${backgroundColor}
  }
`;
var AvatarContext = createContext(null);
var useAvatarContext = () => {
  return useContext(AvatarContext);
};

// src/components/Avatar/Avatar.tsx
var Avatar = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, size: size2 = "regular", disabled = false, variant: variant2 = "default" } = _b, rootProps = __objRest(_b, ["children", "size", "disabled", "variant"]);
    const [loadStatus, setLoadStatus] = useState(0 /* Idle */);
    const hasImage = loadStatus === 2 /* Load */;
    return /* @__PURE__ */ React122__default.createElement(AvatarContext.Provider, { value: { size: size2, loadStatus, setLoadStatus, disabled, variant: variant2 } }, /* @__PURE__ */ React122__default.createElement(
      StyledAvatar,
      __spreadValues(__spreadProps(__spreadValues({
        "data-test": "avatar",
        ref
      }, { size: size2, disabled, variant: variant2 }), {
        opacity: disabled && hasImage ? 0.5 : void 0
      }), rootProps),
      children
    ));
  }
);
var AvatarFallback = ({ children, delayMs }) => {
  const [canRender, setCanRender] = useState(delayMs === void 0);
  const { loadStatus } = useAvatarContext();
  useEffect(() => {
    if (delayMs === void 0) {
      return;
    }
    const timerId = window.setTimeout(() => setCanRender(true), delayMs);
    return () => window.clearTimeout(timerId);
  }, [delayMs]);
  if (loadStatus === 2 /* Load */ || !canRender) {
    return null;
  }
  return /* @__PURE__ */ React122__default.createElement(React122__default.Fragment, null, children);
};
var AvatarIcon = forwardRef(
  (_a, ref) => {
    var _b = _a, { icon } = _b, iconProps = __objRest(_b, ["icon"]);
    const { size: size2, disabled, variant: variant2 } = useAvatarContext();
    return /* @__PURE__ */ React122__default.createElement(
      Icon_default,
      __spreadValues({
        "data-test": "avatar-icon",
        ref,
        component: icon,
        size: iconSizes[size2],
        color: disabled ? "icon-disabled" : variant2 === "default" ? "icon-default" : AVATAR_VARIANT_COLORS_MAP[variant2].color
      }, iconProps)
    );
  }
);
AvatarIcon.displayName = "AvatarIcon";
var StyledImg = styled54(Box_default)`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
var AvatarImg = forwardRef(
  (_a, ref) => {
    var _b = _a, { src } = _b, imageProps = __objRest(_b, ["src"]);
    const { loadStatus, setLoadStatus } = useAvatarContext();
    useEffect(() => {
      setLoadStatus(1 /* Progress */);
      return () => {
        setLoadStatus(0 /* Idle */);
      };
    }, [src, setLoadStatus]);
    if (loadStatus === 3 /* Fail */) {
      return null;
    }
    return /* @__PURE__ */ React122__default.createElement(
      StyledImg,
      __spreadProps(__spreadValues({
        as: "img",
        "data-test": "avatar-img",
        ref,
        src
      }, imageProps), {
        onLoad: () => setLoadStatus(2 /* Load */),
        onError: () => setLoadStatus(3 /* Fail */)
      })
    );
  }
);
AvatarImg.displayName = "AvatarImg";

// src/components/Avatar/utils.ts
function getInitials(name) {
  return name.toUpperCase().split(" ").slice(0, 2).map((word) => word[0]).join("");
}
function getAvatarTextChildNode({
  initials,
  name
}) {
  return initials != null ? initials : name ? getInitials(name) : void 0;
}
var computeAvatarVariant = (initials) => {
  const variantIdx = (initials.charCodeAt(0) + (initials.charCodeAt(1) || 0)) % avatarVariants.length;
  return avatarVariants[variantIdx];
};

// src/components/Avatar/components/AvatarText/AvatarText.tsx
function getTextVariant(size2) {
  switch (size2) {
    case "small":
      return "supportingRegularXS";
    case "regular":
    case "large":
      return "bodyRegularM";
    case "xLarge":
      return "headingLightM";
  }
}
var AvatarText = forwardRef(
  (_a, ref) => {
    var _b = _a, { name, initials } = _b, textProps = __objRest(_b, ["name", "initials"]);
    const childNode = initials != null ? initials : name ? getInitials(name) : void 0;
    const { size: size2 } = useAvatarContext();
    const textVariant = getTextVariant(size2);
    return /* @__PURE__ */ React122__default.createElement(Typography_default, __spreadValues({ "data-test": "avatar-text", ref, variant: textVariant }, textProps), childNode);
  }
);
AvatarText.displayName = "AvatarText";
var QuickAvatar = (_a) => {
  var _b = _a, {
    icon,
    src,
    disabled = false,
    size: size2 = "regular",
    name,
    initials,
    variant: variant2
  } = _b, rootProps = __objRest(_b, [
    "icon",
    "src",
    "disabled",
    "size",
    "name",
    "initials",
    "variant"
  ]);
  const childNode = getAvatarTextChildNode({ name, initials });
  const avatarVariant = variant2 != null ? variant2 : childNode ? computeAvatarVariant(childNode) : "default";
  return /* @__PURE__ */ React122.createElement(Avatar, __spreadValues({ size: size2, disabled, variant: avatarVariant }, rootProps), src && /* @__PURE__ */ React122.createElement(AvatarImg, { src }), /* @__PURE__ */ React122.createElement(AvatarFallback, null, icon && /* @__PURE__ */ React122.createElement(AvatarIcon, { icon }), childNode && !icon && /* @__PURE__ */ React122.createElement(AvatarText, { initials: childNode })));
};
var offsetTop = style({
  prop: ["offsetTop"],
  themeGet: getInset,
  css: "top"
});
var offsetRight = style({
  prop: ["offsetRight"],
  themeGet: getInset,
  css: "right"
});

// src/components/Badge/constants.ts
var TAG_SIZES_MAP = {
  small: "13px",
  regular: "16px",
  large: "22px",
  xLarge: "28px"
};
var TAG_ICON_SIZES_MAP = {
  small: "6px",
  regular: "8px",
  large: "12px",
  xLarge: "14px"
};
var BADGE_VARIANT_COLORS_MAP = {
  primary: {
    color: "text-contrast-light",
    backgroundColor: "primary-500"
  },
  blue: {
    color: "text-contrast-light",
    backgroundColor: "informative-500"
  },
  red: {
    color: "text-contrast-light",
    backgroundColor: "critical-500"
  },
  yellow: {
    color: "text-contrast-light",
    backgroundColor: "warning-500"
  },
  grey: {
    color: "text-contrast-light",
    backgroundColor: "neutral-500"
  }
};

// src/components/Badge/components/StyledBadgeIndicator.tsx
var makeBadgeSize = ({ size: size2 }) => {
  var _a;
  const badgeSize = (_a = TAG_SIZES_MAP[size2]) != null ? _a : TAG_SIZES_MAP.regular;
  return css`
    min-width: ${badgeSize};
    height: ${badgeSize};
  `;
};
var makeBadgeIconSize = ({ size: size2 }) => {
  var _a;
  const iconSize = (_a = TAG_ICON_SIZES_MAP[size2]) != null ? _a : TAG_ICON_SIZES_MAP.regular;
  return css`
    svg {
      width: ${iconSize};
      height: ${iconSize};
    }
  `;
};
var makeBadgePosition = ({ hasChildren }) => {
  if (!hasChildren) {
    return;
  }
  return css`
    position: absolute;
    transform: translate(50%, -50%);
    transform-origin: 100% 0%;
  `;
};
var makeBadgeVariant = ({
  theme,
  badgeBg,
  badgeColor,
  variant: variant2
}) => {
  if (badgeBg) {
    const bgColor = getColor(badgeBg)({ theme });
    return css({
      backgroundColor: badgeBg,
      color: badgeColor || textColor(bgColor, "text-contrast-light", "text-contrast-dark")
    });
  }
  return css(variant2 && BADGE_VARIANT_COLORS_MAP[variant2] || BADGE_VARIANT_COLORS_MAP.primary);
};
var StyledBadgeIndicator = styled54(Box_default)`
  border-radius: full;
  border: 2px solid white;
  overflow: hidden;
  ${makeBadgePosition}
  ${makeBadgeSize}
  ${makeBadgeIconSize}
  ${makeBadgeVariant}
  ${offsetTop}
  ${offsetRight}
`;
var StyledBadgeIndicatorContent = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;

// src/components/Badge/Badge.tsx
var Badge = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      size: size2 = "regular",
      variant: variant2 = "primary",
      color: color4,
      bg,
      icon,
      offsetTop: offsetTop2 = 0,
      offsetRight: offsetRight2 = 0
    } = _b, remainingStyleProps = __objRest(_b, [
      "children",
      "size",
      "variant",
      "color",
      "bg",
      "icon",
      "offsetTop",
      "offsetRight"
    ]);
    return /* @__PURE__ */ React122__default.createElement(Flex_default, { display: "inline-flex", position: "relative", "data-test": "badge-container", ref }, children, /* @__PURE__ */ React122__default.createElement(
      StyledBadgeIndicator,
      __spreadValues(__spreadValues({
        "data-test": "badge-indicator",
        badgeBg: bg,
        badgeColor: color4,
        hasChildren: !!children
      }, { size: size2, variant: variant2, offsetTop: offsetTop2, offsetRight: offsetRight2 }), remainingStyleProps),
      /* @__PURE__ */ React122__default.createElement(StyledBadgeIndicatorContent, null, icon)
    ));
  }
);
Badge.displayName = "Badge";

// src/components/Spacer/utils.ts
var shouldForwardProp3 = (prop, defaultValidationFn) => !["direction"].includes(prop) && defaultValidationFn(prop);

// src/components/Spacer/Spacer.tsx
var Container = styled54(Flex_default).withConfig({ shouldForwardProp: shouldForwardProp3 })`
  vertical-align: top;
  ${({ reverse, direction }) => {
  const flexDirection = direction === "vertical" ? "column" : "row";
  return css`
      flex-direction: ${reverse ? `${flexDirection}-reverse` : flexDirection};
    `;
}}
`;
var Spacer = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      alignItems,
      justifyContent,
      flexWrap,
      space: space6 = "xxxs",
      direction = "horizontal",
      reverse = false,
      fluid,
      w,
      itemsSized = "auto"
    } = _b, otherStyleProps = __objRest(_b, [
      "children",
      "alignItems",
      "justifyContent",
      "flexWrap",
      "space",
      "direction",
      "reverse",
      "fluid",
      "w",
      "itemsSized"
    ]);
    const validChildren = React122__default.Children.toArray(children).filter(Boolean);
    return /* @__PURE__ */ React122__default.createElement(
      Container,
      __spreadValues({
        display: "inline-flex",
        ref,
        direction,
        alignItems,
        justifyContent,
        flexWrap,
        w: w != null ? w : fluid ? "100%" : void 0,
        reverse,
        gap: space6
      }, otherStyleProps),
      validChildren.map((child, childIdx) => /* @__PURE__ */ React122__default.createElement(Box_default, { key: childIdx, flex: itemsSized === "evenly-sized" ? "1 1 0" : void 0 }, child))
    );
  }
);
Spacer.displayName = "Spacer";

// src/components/Notification/components/NotificationSuffix.ts
var NotificationSuffix = styled54(Spacer).attrs({
  space: 2
})``;
NotificationSuffix.defaultProps = {
  "data-test": "notification-suffix"
};
var NotificationButton = (_a) => {
  var _b = _a, {
    children,
    mode = "link",
    variant: variant2 = "secondary"
  } = _b, otherButtonProps = __objRest(_b, [
    "children",
    "mode",
    "variant"
  ]);
  return /* @__PURE__ */ React122__default.createElement(Button, __spreadValues(__spreadValues({ size: "xSmall" }, { mode, variant: variant2 }), otherButtonProps), children);
};
var NotificationHeading = styled(Typography_default).attrs({
  textAlign: "left",
  variant: "bodyMediumS"
})``;
NotificationHeading.defaultProps = {
  "data-test": "notification-heading"
};
var NotificationParagraph = styled(Typography_default).attrs({
  textAlign: "left",
  variant: "supportingRegularS"
})``;
NotificationParagraph.defaultProps = {
  "data-test": "notification-paragraph"
};
var notificationIcons = {
  success: () => /* @__PURE__ */ React122.createElement(Icon_default, { component: TickCircleFilled }),
  info: () => /* @__PURE__ */ React122.createElement(Icon_default, { component: InformationFilled }),
  warning: () => /* @__PURE__ */ React122.createElement(Icon_default, { component: WarningFilled }),
  critical: () => /* @__PURE__ */ React122.createElement(Icon_default, { component: CloseCircleFilled })
};
var NotificationContext = React122.createContext(null);
var useNotificationContext = () => {
  return React122.useContext(NotificationContext);
};

// src/components/Notification/components/NotificationIcon.tsx
var StyledIcon = styled(Box_default).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop)
}).attrs(({ icon, variant: variant2 }) => {
  const IconComponent = notificationIcons[variant2];
  const iconNode = icon && (typeof icon === "boolean" ? /* @__PURE__ */ React122__default.createElement(IconComponent, null) : icon);
  return {
    children: iconNode
  };
})``;
var NotificationIcon = (_a) => {
  var _b = _a, {
    icon = true,
    alignSelf: alignSelf2 = "center"
  } = _b, iconProps = __objRest(_b, [
    "icon",
    "alignSelf"
  ]);
  const { variant: variant2 } = useNotificationContext();
  return /* @__PURE__ */ React122__default.createElement(
    StyledIcon,
    __spreadProps(__spreadValues({
      "data-test": "notification-icon"
    }, iconProps), {
      icon,
      variant: variant2,
      alignSelf: alignSelf2
    })
  );
};
var makeNotificationVariant = ({ variant: variant2 }) => {
  return css`
    background-color: ${getColor(`surface-${variant2}`)};

    ${NotificationHeading},
    ${NotificationParagraph} {
      color: ${getColor("text-contrast-dark")};
    }

    ${StyledIcon} svg {
      color: ${getColor(`icon-${variant2}`)};
    }

    ${NotificationSuffix} {
      svg {
        color: ${getColor("icon-contrast-dark")};
      }
    }
  `;
};

// src/components/Notification/components/NotificationRoot.tsx
var StyledRootContainer = styled54(Flex_default).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => defaultValidatorFn(prop)
})`
  padding: 4;
  user-select: none;
  align-items: center;
  ${makeNotificationVariant}
`;
var NotificationRoot = (_a) => {
  var _b = _a, {
    variant: variant2,
    children,
    "data-test": dataTest = "notification-root"
  } = _b, rootProps = __objRest(_b, [
    "variant",
    "children",
    "data-test"
  ]);
  return /* @__PURE__ */ React122__default.createElement(NotificationContext.Provider, { value: { variant: variant2 } }, /* @__PURE__ */ React122__default.createElement(StyledRootContainer, __spreadValues({ variant: variant2, "data-test": dataTest }, rootProps), children));
};

// src/components/Notification/Notification.tsx
var Notification = {
  Root: NotificationRoot,
  Icon: NotificationIcon,
  Heading: NotificationHeading,
  Paragraph: NotificationParagraph,
  Suffix: NotificationSuffix,
  Button: NotificationButton
};

// src/components/Banner/components/BannerIcon.tsx
var BannerIcon = (props) => {
  return /* @__PURE__ */ React122__default.createElement(Notification.Icon, __spreadValues({ gridArea: "icon", mr: 2, "data-test": "banner-icon" }, props));
};
var BannerHeading = styled54(Typography_default).attrs({
  variant: "bodyMediumS"
})`
  grid-area: heading;
`;
BannerHeading.defaultProps = {
  "data-test": "banner-heading"
};
var BannerParagraph = styled(Typography_default).attrs({ variant: "supportingRegularS" })`
  grid-area: paragraph;
`;
BannerParagraph.defaultProps = {
  "data-test": "banner-paragraph"
};
var BannerSuffix = styled54(Notification.Suffix)`
  grid-area: suffix;
`;

// src/components/Banner/components/BannerButton.tsx
var BannerButton = Notification.Button;
var BannerRoot = styled54(Notification.Root)`
  ${({ inline }) => inline ? css`
          border-radius: sm;
        ` : ""}
  padding: 3 4;
  width: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: auto 1fr auto;
  grid-template-areas:
    'icon heading suffix'
    '. paragraph suffix';
`;
var Banner = (_a) => {
  var _b = _a, { variant: variant2 } = _b, rest = __objRest(_b, ["variant"]);
  return /* @__PURE__ */ React122__default.createElement(BannerRoot, __spreadValues({ variant: variant2, "data-test": `banner-${variant2}` }, rest));
};
var BannerContext = createContext(null);
var useBanner = () => {
  return useContext(BannerContext);
};

// src/components/Banner/constants.ts
var TOPICS = {
  SHOW_BANNER: "SHOW_BANNER",
  REMOVE_BANNER: "REMOVE_BANNER"
};
var bannerVariant = {
  show: { height: "auto" },
  hide: { height: 0 }
};
var bannerTransition = { type: "tween", duration: 0.3 };
var AnimateBanner = ({ banner }) => {
  const { removeBanner } = useBanner();
  const _a = banner, { icon, variant: variant2, heading, paragraph, actions } = _a, bannerProps = __objRest(_a, ["icon", "variant", "heading", "paragraph", "actions"]);
  const handleDismiss = React122.useCallback(() => {
    removeBanner(banner.id);
  }, [removeBanner, banner.id]);
  const onActionClick = React122.useCallback(
    (handleClick) => {
      return () => {
        handleClick(handleDismiss);
      };
    },
    [handleDismiss]
  );
  return /* @__PURE__ */ React122.createElement(
    motion.div,
    {
      layout: true,
      style: { overflow: "hidden" },
      initial: "hide",
      animate: "show",
      exit: "hide",
      variants: bannerVariant,
      transition: bannerTransition
    },
    /* @__PURE__ */ React122.createElement(Banner, __spreadValues({ variant: variant2 }, bannerProps), icon && /* @__PURE__ */ React122.createElement(BannerIcon, { icon }), /* @__PURE__ */ React122.createElement(BannerHeading, null, heading), paragraph && /* @__PURE__ */ React122.createElement(BannerParagraph, null, paragraph), actions && actions.length > 0 && /* @__PURE__ */ React122.createElement(BannerSuffix, null, actions.map((action, actionIdx) => /* @__PURE__ */ React122.createElement(
      BannerButton,
      {
        key: actionIdx,
        "data-test": `banner-action-${actionIdx}`,
        onClick: onActionClick(action.onClick),
        variant: action.variant,
        mode: action.mode
      },
      action.children
    ))))
  );
};
var BannerList = () => {
  const { banners: banners2 } = useBanner();
  return /* @__PURE__ */ React122.createElement(Box_default, { "data-test": "banner-list", position: "relative" }, /* @__PURE__ */ React122.createElement(AnimatePresence, null, banners2.map((banner) => /* @__PURE__ */ React122.createElement(AnimateBanner, { key: banner.id, banner }))));
};

// src/components/Banner/components/BannerManager/BannerManager.tsx
var BannerManager = ({
  children,
  container = document.body
}) => {
  const [banners2, setBanners] = React122.useState([]);
  const removeBanner = React122.useCallback(
    (id) => setBanners((prevBanners) => prevBanners.filter((t) => t.id !== id)),
    []
  );
  const showBanner = React122.useCallback(
    (t) => {
      const banner = __spreadValues({ id: uniqueId() }, t);
      const cleanup = () => removeBanner(banner.id);
      setBanners((prevBanners) => {
        if (prevBanners.some(({ id }) => id === banner.id)) {
          return prevBanners;
        }
        return [banner, ...prevBanners];
      });
      return cleanup;
    },
    [removeBanner]
  );
  usePubSub(TOPICS.SHOW_BANNER, showBanner);
  usePubSub(TOPICS.REMOVE_BANNER, removeBanner);
  const containerNode = typeof container === "function" ? container() : container;
  return /* @__PURE__ */ React122.createElement(BannerContext.Provider, { value: { banners: banners2, showBanner, removeBanner } }, /* @__PURE__ */ React122.createElement(React122.Fragment, null, children, containerNode && createPortal(/* @__PURE__ */ React122.createElement(BannerList, null), containerNode)));
};
var banners = {
  showBanner: (banner) => {
    PubSub.publish(TOPICS.SHOW_BANNER, banner);
  },
  removeBanner: (id) => {
    PubSub.publish(TOPICS.REMOVE_BANNER, id);
  }
};
var ComboBoxContext = React122__default.createContext(null);
var useComboBox = () => {
  return React122__default.useContext(ComboBoxContext);
};
var ComboBoxProvider = ({
  disabled,
  children
}) => {
  const { selectedKeys, setSelectedKeys, selectionMode } = useMenu();
  const { open, setOpen } = usePopoverContext();
  const removeAll = useCallback(() => {
    setSelectedKeys([]);
  }, [setSelectedKeys]);
  const removeKey = useCallback(
    (key) => {
      const nextKeys = selectedKeys.filter((k) => k !== key);
      setSelectedKeys(nextKeys);
    },
    [selectedKeys, setSelectedKeys]
  );
  const onItemClicked = useCallback(() => {
    if (selectionMode === "single") {
      setOpen(false);
    }
  }, [selectionMode, setOpen]);
  const value = useMemo(
    () => ({
      onItemClicked,
      open,
      setOpen,
      selectedKeys,
      removeAll,
      removeKey,
      setSelectedKeys,
      disabled
    }),
    [onItemClicked, open, removeAll, removeKey, selectedKeys, setOpen, setSelectedKeys, disabled]
  );
  return /* @__PURE__ */ React122__default.createElement(ComboBoxContext.Provider, { value }, children);
};

// src/components/ComboBox/ComboBox.tsx
function ComboBox(_a) {
  var _b = _a, {
    children,
    selectionMode,
    size: size2 = "regular",
    onOpen,
    onClose,
    disabled = false,
    open,
    defaultOpen
  } = _b, props = __objRest(_b, [
    "children",
    "selectionMode",
    "size",
    "onOpen",
    "onClose",
    "disabled",
    "open",
    "defaultOpen"
  ]);
  const onOpenChange = useCallback(
    (open2) => {
      if (open2) {
        onOpen == null ? void 0 : onOpen();
      } else {
        onClose == null ? void 0 : onClose();
      }
    },
    [onClose, onOpen]
  );
  return /* @__PURE__ */ React122__default.createElement(MenuProvider, __spreadValues({ selectionMode, size: size2 }, props), /* @__PURE__ */ React122__default.createElement(Popover.Root, { onOpenChange, open, defaultOpen }, /* @__PURE__ */ React122__default.createElement(ComboBoxProvider, { disabled }, children)));
}
var ComboBoxTrigger = function Trigger(props) {
  const { toggleOpen } = usePopoverContext();
  const { disabled } = useComboBox();
  return /* @__PURE__ */ React122__default.createElement(Popover.Trigger, __spreadProps(__spreadValues({}, props), { onClick: disabled ? void 0 : toggleOpen }));
};
var ComboBoxContent = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122__default.createElement(
    Popover.Content,
    __spreadValues({
      flexDirection: "column",
      takeViewportHeight: true,
      align: "start",
      side: "bottom",
      sideOffset: 8,
      boxShadow: 1,
      overflow: "hidden",
      borderRadius: "sm",
      bg: "surface-interactive-default",
      takeTriggerWidth: true
    }, props),
    children
  );
};
var ComboBoxItem = forwardRef4((_a, ref) => {
  var _b = _a, { onClick } = _b, props = __objRest(_b, ["onClick"]);
  const { onItemClicked } = useComboBox();
  return /* @__PURE__ */ React122__default.createElement(MenuItem, __spreadValues({ ref, onClick: composeEventHandlers(onItemClicked, onClick) }, props));
});
var ComboBoxMenu = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122__default.createElement(StyledMenu, __spreadValues({ minWidth: "unset", overflowY: "auto" }, props), children);
};

// src/components/CounterBadge/constants.ts
var counterBadgeSize = {
  small: {
    minWidth: 16,
    height: 16,
    maxWidth: 24
  },
  regular: {
    minWidth: 20,
    height: 20,
    maxWidth: 32
  },
  large: {
    minWidth: 24,
    height: 24,
    maxWidth: 32
  }
};
var counterBadgeTypographyVariant = {
  small: "supportingMediumXS",
  regular: "supportingMediumS",
  large: "supportingMediumS"
};
var counterBadgeTypographyPadding = {
  small: "4px",
  regular: "8px",
  large: "8px"
};
var COUNTER_BADGE_VARIANT_COLORS_MAP = {
  primary: {
    color: "text-contrast-light",
    backgroundColor: "primary-500"
  },
  red: {
    color: "text-contrast-light",
    backgroundColor: "critical-500"
  },
  black: {
    color: "text-contrast-light",
    backgroundColor: "neutral-1000"
  }
};

// src/components/CounterBadge/components/StyledCounterBadgeIndicator.tsx
var makeBadgeSize2 = ({ size: size2 }) => {
  const { minWidth, maxWidth, height } = counterBadgeSize[size2];
  return {
    minWidth,
    maxWidth,
    height,
    borderRadius: height / 2
  };
};
var makeBadgePosition2 = ({
  hasChildren
}) => {
  if (!hasChildren) {
    return;
  }
  return css`
    position: absolute;
    transform: translate(50%, -50%);
    transform-origin: 100% 0%;
  `;
};
var makeBadgeVariant2 = ({
  theme,
  badgeBg,
  badgeColor,
  variant: variant2
}) => {
  if (badgeBg) {
    const bgColor = getColor(badgeBg)({ theme });
    return css({
      backgroundColor: badgeBg,
      color: badgeColor || textColor(bgColor, "text-contrast-light", "text-contrast-dark")
    });
  }
  return css(
    variant2 && COUNTER_BADGE_VARIANT_COLORS_MAP[variant2] || COUNTER_BADGE_VARIANT_COLORS_MAP.red
  );
};
var StyledCounterBadgeIndicator = styled54(Box_default)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  ${makeBadgePosition2}
  ${makeBadgeSize2}
  ${makeBadgeVariant2}
  ${offsetTop}
  ${offsetRight}
`;

// src/components/CounterBadge/CounterBadge.tsx
var CounterBadge = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      size: size2 = "regular",
      variant: variant2 = "red",
      bg,
      color: color4,
      count,
      maxCount = 99,
      offsetTop: offsetTop2 = 0,
      offsetRight: offsetRight2 = 0
    } = _b, otherStyleProps = __objRest(_b, [
      "children",
      "size",
      "variant",
      "bg",
      "color",
      "count",
      "maxCount",
      "offsetTop",
      "offsetRight"
    ]);
    if (count === 0) {
      return /* @__PURE__ */ React122__default.createElement(React122__default.Fragment, null, children);
    }
    return /* @__PURE__ */ React122__default.createElement(Flex_default, { display: "inline-flex", position: "relative", "data-test": "counter-badge-container", ref }, children, /* @__PURE__ */ React122__default.createElement(
      StyledCounterBadgeIndicator,
      __spreadValues(__spreadProps(__spreadValues({
        size: size2,
        hasChildren: !!children,
        badgeColor: color4,
        badgeBg: bg,
        variant: variant2
      }, { offsetTop: offsetTop2, offsetRight: offsetRight2 }), {
        "data-test": "counter-badge-indicator"
      }), otherStyleProps),
      /* @__PURE__ */ React122__default.createElement(
        Typography_default,
        {
          variant: counterBadgeTypographyVariant[size2],
          px: count >= 10 ? counterBadgeTypographyPadding[size2] : 0,
          userSelect: "none"
        },
        count <= maxCount ? count : `${maxCount}+`
      )
    ));
  }
);
CounterBadge.displayName = "CounterBadge";
var DatePickerContext = createContext({});

// src/components/DatePicker/DatePicker.hook.ts
var useDatePickerState = () => useContext(DatePickerContext);

// src/components/DatePicker/ArrowButton.tsx
var StyledButton = styled54.button`
  position: absolute;
  z-index: 1;
  overflow: hidden;
  top: 6px;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid ${getColor$1("graphic-interactive-default")};
  background-color: ${getColor$1("surface-interactive-default")};
  cursor: pointer;
  ${({ arrowDirection, displaced }) => arrowDirection === "prev" ? `left: ${displaced + 4}px;` : `right: ${displaced + 4}px`};
  &:hover {
    background-color: ${getColor$1("surface-interactive-default-hover")};
  }
`;
function ArrowButton({ direction, displaced = 8 }) {
  const { navigate } = useDatePickerState();
  return /* @__PURE__ */ React122__default.createElement(
    StyledButton,
    {
      arrowDirection: direction,
      displaced,
      onClick: () => navigate(direction),
      "data-test": `datepicker-${direction}`
    },
    direction === "prev" ? /* @__PURE__ */ React122__default.createElement(ChevronLeftOutlined, { size: "15px", color: "icon-interactive-default" }) : /* @__PURE__ */ React122__default.createElement(ChevronRightOutlined, { size: "15px", color: "icon-interactive-default" })
  );
}

// src/components/DatePicker/calculate_dimensions/calculate_dimensions.utility.ts
var PADDING_PROPERTIES = {
  ["vertical" /* VERTICAL */]: {
    start: "paddingTop",
    end: "paddingBottom"
  },
  ["horizontal" /* HORIZONTAL */]: {
    start: "paddingLeft",
    end: "paddingRight"
  }
};
var BORDER_PROPERTIES = {
  ["vertical" /* VERTICAL */]: {
    start: "borderTopWidth",
    end: "borderBottomWidth"
  },
  ["horizontal" /* HORIZONTAL */]: {
    start: "borderLeftWidth",
    end: "borderRightWidth"
  }
};
var calculateDimension = ({
  el
}) => {
  const style4 = window.getComputedStyle(el);
  const { offsetWidth, offsetHeight } = el;
  let horizontal = offsetWidth;
  let vertical = offsetHeight;
  horizontal -= parseFloat(style4[PADDING_PROPERTIES["horizontal" /* HORIZONTAL */].start]) + parseFloat(style4[PADDING_PROPERTIES["horizontal" /* HORIZONTAL */].end]) + parseFloat(style4[BORDER_PROPERTIES["horizontal" /* HORIZONTAL */].end]) + parseFloat(style4[BORDER_PROPERTIES["horizontal" /* HORIZONTAL */].end]);
  vertical -= parseFloat(style4[PADDING_PROPERTIES["vertical" /* VERTICAL */].start]) + parseFloat(style4[PADDING_PROPERTIES["vertical" /* VERTICAL */].end]) + parseFloat(style4[BORDER_PROPERTIES["vertical" /* VERTICAL */].end]) + parseFloat(style4[BORDER_PROPERTIES["vertical" /* VERTICAL */].end]);
  return { horizontal, vertical };
};
var getInitialMonth = ({
  numberOfMonths,
  initialDate,
  calendarDirection,
  minDate,
  maxDate
}) => {
  let date = initialDate;
  if (maxDate && isAfter(initialDate, endOfMonth(maxDate))) {
    date = maxDate;
  }
  if (minDate && isBefore(initialDate, startOfMonth(minDate))) {
    date = minDate;
  }
  if (numberOfMonths === 1 || calendarDirection === "past") {
    return startOfMonth(date);
  }
  return startOfMonth(add(date, { months: numberOfMonths - 1 }));
};
var months = (numberOfMonths) => [-1, ...Array(numberOfMonths + 1).keys()];
var getInitialMonths = ({
  numberOfMonths,
  initialDate,
  calendarDirection,
  minDate,
  maxDate
}) => {
  let date = initialDate;
  if (maxDate && isAfter(initialDate, endOfMonth(maxDate))) {
    date = maxDate;
  }
  if (minDate && isBefore(initialDate, startOfMonth(minDate))) {
    date = minDate;
  }
  if (calendarDirection === "past") {
    return months(numberOfMonths).map((val) => startOfMonth(sub(date, { months: val }))).reverse();
  }
  return months(numberOfMonths).map((val) => startOfMonth(add(date, { months: val })));
};
var monthFormat = (date) => format(date, "MMMM");
var longDate = (date) => format(date, "PPP");
var getMonthName = (date, locale = "en-US") => {
  return new Intl.DateTimeFormat(locale, { month: "long" }).format(date);
};
var getWeekdayName = (date, locale = "en-US") => {
  const l = locale.toLocaleLowerCase().includes("pt") ? "PT" : locale;
  return new Intl.DateTimeFormat(l, { weekday: "short" }).format(date);
};
var DayContainer = styled54.td`
  ${({ theme }) => css`
      ${theme.typography.bodyMediumS}
    `}
  opacity: 1;
`;
var Day = styled54.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: sm;
  ${({ daySize }) => css`
    width: ${daySize}px;
    height: ${daySize}px;
  `}
  color: ${getColor$1("text-base")};
  background-color: surface-default;
  border: none;
  cursor: default;
  ${({ isInMonth, disabled }) => isInMonth && !disabled && css`
      cursor: pointer;
    `}

  &:hover {
    ${({ disabled }) => !disabled && css`
        background-color: ${getColor$1("surface-interactive-default-hover")};
      `}
  }
  ${({ isBetweenDates }) => isBetweenDates && css`
      background: ${getColor$1("surface-interactive-default-active")} !important;
      color: ${getColor$1("text-interactive-primary")} !important;
    `}
  ${({ isBookendDate }) => isBookendDate && css`
      background: ${getColor$1("surface-interactive-primary")} !important;
      color: ${getColor$1("text-inverted")} !important;
      &:hover {
        background: ${getColor$1("surface-interactive-primary-hover")} !important;
      }
    `}
  ${({ today }) => today && css`
      border: 1px solid ${getColor$1("text-interactive-primary-active")};
    `}
  ${({ disabled }) => disabled && css`
      color: ${getColor$1("text-disabled")} !important;
      cursor: default;
    `}
`;
var datepickerDayAriaLabels = {
  start: "Picked starting date.",
  end: "Picked ending date.",
  highlight: "Highlighted dates",
  disabled: "This date is disabled"
};
function getAriaLabel(isStart, isEnd, isBetweenDates, disabled) {
  if (isStart) {
    return datepickerDayAriaLabels.start;
  }
  if (isEnd) {
    return datepickerDayAriaLabels.end;
  }
  if (isBetweenDates) {
    return datepickerDayAriaLabels.highlight;
  }
  if (disabled) {
    return datepickerDayAriaLabels.disabled;
  }
  return "";
}
function checkIsBetweenDates(startDate, hoveredDate, endDate, day) {
  return !!(startDate && isAfter(day, startDate) && (hoveredDate && (isBefore(day, hoveredDate) || isSameDay(day, hoveredDate)) && !endDate || endDate && isBefore(day, endDate)));
}
function DatePickerDay({ day, isInMonth }) {
  const {
    setHoveredDate,
    clickOnDay,
    disabledDay,
    startDate,
    endDate,
    hoveredDate,
    singleDate,
    daySize
  } = useDatePickerState();
  const isStart = !!(startDate && isSameDay(day, startDate));
  const isEnd = !!(endDate && isSameDay(day, endDate));
  const disabled = !!(disabledDay == null ? void 0 : disabledDay(day));
  const isBookendDate = isStart || isEnd;
  const isToday = isSameDay(day, /* @__PURE__ */ new Date());
  const isBetweenDates = checkIsBetweenDates(startDate, hoveredDate, endDate, day);
  return /* @__PURE__ */ React122__default.createElement(
    DayContainer,
    {
      disabled,
      onClick: disabled ? void 0 : () => {
        clickOnDay(day);
      }
    },
    isInMonth && /* @__PURE__ */ React122__default.createElement(
      Day,
      {
        type: "button",
        isInMonth,
        "aria-label": getAriaLabel(isStart, isEnd, isBetweenDates, disabled),
        title: longDate(day),
        daySize,
        disabled,
        today: isToday,
        isBetweenDates: !singleDate && isBetweenDates,
        onMouseEnter: disabled ? void 0 : () => setHoveredDate(day),
        isBookendDate
      },
      format(day, "d")
    )
  );
}

// src/components/DatePicker/Week.tsx
function Week({ weekStart, month }) {
  return /* @__PURE__ */ React122__default.createElement("tr", null, [...Array(7).keys()].map((_, index) => {
    const day = addDays(weekStart, index);
    const isInMonth = isSameMonth(day, month);
    return /* @__PURE__ */ React122__default.createElement(DatePickerDay, { day, key: `${day.getTime()}-day`, isInMonth });
  }));
}

// src/components/DatePicker/Month.tsx
var Table = styled54.table`
  border-spacing: 4px;
`;
var MonthContainer = styled54(Box_default)`
  display: inline-block;
  padding: 0 ${({ paddingX }) => paddingX}px;
  ${({ isVisible, transition }) => !isVisible && !transition && css`
      visibility: hidden !important;
    `}
  ${({ firstMonth, transition }) => firstMonth && transition !== "prev" && css`
      position: absolute !important;
      z-index: -1 !important;
      opacity: 0 !important;
      pointer-events: none !important;
      visibility: hidden !important;
    `}
  ${({ transition, monthSize, firstMonth }) => firstMonth && transition === "prev" && css`
      position: absolute !important;
      left: -${monthSize + 4}px;
    `}
  ${({ lastVisible, transition, firstVisible }) => (lastVisible && transition === "prev" || firstVisible && transition === "next") && css`
      opacity: 0;
      transition: opacity 200ms;
    `}
  ${({ lastMonth, transition, firstMonth }) => (lastMonth && transition !== "next" || firstMonth && transition === "next") && css`
      display: none !important;
    `}
`;
function Month({ month, paddingX, index, monthSize, isVisible }) {
  const { transition, currentMonths, locale } = useDatePickerState();
  const weeks = eachWeekOfInterval({ start: month, end: endOfMonth(month) }, { weekStartsOn: 1 });
  return /* @__PURE__ */ React122__default.createElement(
    MonthContainer,
    {
      "data-test": monthFormat(month),
      w: "fit-content",
      firstMonth: index === 0,
      paddingX,
      transition,
      monthSize,
      isVisible,
      firstVisible: index === 1,
      lastVisible: index === currentMonths.length - 2,
      lastMonth: index === currentMonths.length - 1
    },
    /* @__PURE__ */ React122__default.createElement(Flex_default, { paddingTop: "xxs", paddingBottom: "s", justifyContent: "center" }, /* @__PURE__ */ React122__default.createElement(Typography_default, { variant: "headingBoldS", color: "text-base" }, getMonthName(month, locale))),
    /* @__PURE__ */ React122__default.createElement(Table, null, /* @__PURE__ */ React122__default.createElement("thead", null, /* @__PURE__ */ React122__default.createElement("tr", null, [...Array(7).keys()].map((_, dayIndex) => {
      const day = addDays(weeks[0], dayIndex);
      const translatedDay = getWeekdayName(day, locale);
      return /* @__PURE__ */ React122__default.createElement("th", { key: `${day}-header` }, /* @__PURE__ */ React122__default.createElement(Typography_default, { color: "text-disabled", pb: "xxs", textAlign: "center" }, translatedDay));
    }))), /* @__PURE__ */ React122__default.createElement("tbody", null, weeks.map((week) => /* @__PURE__ */ React122__default.createElement(Week, { key: `${week}-week`, weekStart: week, month }))))
  );
}

// src/components/DatePicker/Calendar.tsx
var MonthsContainer = styled54(Box_default)`
  z-index: 0 !important;
  width: ${({ width }) => width}px;
  text-align: left !important;
  transform: ${({ transition, monthSize }) => css`
      translateX(${transition === "next" && "-"}${transition && monthSize}px)
    `};
  transition: transform ${({ transitionTime, transition }) => transition ? transitionTime : 0}ms;
  white-space: nowrap;
`;
var OuterContainer = styled54(Box_default)`
  background-color: ${getColor$1("surface-default")};
  transition: height ${({ transitionTime }) => transitionTime}ms;
`;
var MONTH_CONTAINER_PADDING_X = 8;
function DatePickerCalendar({
  maxDate,
  minDate,
  numberOfMonths,
  "data-test": dataTest
}) {
  const { currentMonth, transition, currentMonths, transitionTime, daySize } = useDatePickerState();
  const [containerHeight, setContainerHeight] = useState();
  const monthsContainer = useRef(null);
  useEffect(() => {
    const height = calculateDimension({ el: monthsContainer.current }).vertical;
    setContainerHeight(height);
  }, [containerHeight, transition]);
  const monthSize = (
    // the width of 7 days including left border and right border
    7 * (daySize + 2) + // 8 spacing border
    8 * 4 + // left padding and right padding
    MONTH_CONTAINER_PADDING_X * 2
  );
  const outerContainerWidth = numberOfMonths * monthSize;
  const sliderContainerWidth = (numberOfMonths + 1) * monthSize;
  const showNext = maxDate ? !(isAfter(currentMonth, maxDate) || isSameMonth(currentMonth, maxDate)) : true;
  const showPrev = minDate ? !isBefore(subMonths(currentMonth, numberOfMonths - 1), minDate) : true;
  return /* @__PURE__ */ React122__default.createElement(
    OuterContainer,
    {
      overflow: "hidden",
      w: outerContainerWidth,
      h: containerHeight != null ? containerHeight : "auto",
      position: "relative",
      backgroundColor: "white",
      transitionTime,
      "data-test": dataTest
    },
    showPrev && /* @__PURE__ */ React122__default.createElement(ArrowButton, { direction: "prev", displaced: MONTH_CONTAINER_PADDING_X }),
    showNext && /* @__PURE__ */ React122__default.createElement(ArrowButton, { direction: "next", displaced: MONTH_CONTAINER_PADDING_X }),
    /* @__PURE__ */ React122__default.createElement(
      MonthsContainer,
      {
        "data-test": transition ? `datepicker-transition-${transition}` : "datepicker-month-container",
        ref: monthsContainer,
        width: sliderContainerWidth,
        transition,
        transitionTime,
        monthSize
      },
      currentMonths.map((month, index) => /* @__PURE__ */ React122__default.createElement(
        Month,
        {
          paddingX: MONTH_CONTAINER_PADDING_X,
          index,
          isVisible: index > 0 && index < currentMonths.length - 1,
          monthSize,
          key: `${month}-month`,
          month
        }
      ))
    )
  );
}
function DatePickerProvider({
  children,
  numberOfMonths,
  initialDate,
  calendarDirection,
  minDate,
  maxDate,
  onChange,
  value,
  transitionTime,
  isDateDisabled,
  daySize,
  mode = "range",
  locale
}) {
  var _a, _b;
  const timeoutRef = useRef();
  const [hoveredDate, setHoveredDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(
    () => getInitialMonth({ numberOfMonths, initialDate, calendarDirection, minDate, maxDate })
  );
  const [transition, setTransition] = useState();
  const [currentMonths, setCurrentMonths] = useState(
    () => getInitialMonths({ numberOfMonths, initialDate, calendarDirection, minDate, maxDate })
  );
  const startDate = (_a = value == null ? void 0 : value.startDate) != null ? _a : null;
  const endDate = (_b = value == null ? void 0 : value.endDate) != null ? _b : null;
  const updateMonths = useCallback(
    (month) => {
      const monthsPlaceholder = [-1, ...Array(numberOfMonths + 1).keys()].map((val) => startOfMonth(sub(month, { months: val }))).reverse();
      setCurrentMonths(monthsPlaceholder);
      setTransition(void 0);
    },
    [numberOfMonths]
  );
  const memoizedContextValue = useMemo(() => {
    const navigate = (direction) => {
      setCurrentMonth(addMonths(currentMonth, direction === "next" ? 1 : -1));
      setTransition(direction);
    };
    const clickOnDay = (date) => {
      if (mode === "single") {
        onChange({ startDate: date, endDate: null });
        return;
      }
      const bothDatesSelected = startDate && endDate;
      const startDateSelectedOnly = startDate && !endDate;
      if (!startDate || bothDatesSelected || startDateSelectedOnly && isBefore(date, startDate)) {
        onChange({ startDate: date, endDate: null });
      } else {
        onChange({ startDate, endDate: date });
      }
    };
    const disabledDay = (day) => !!(isDateDisabled(day) || minDate && isBefore(day, startOfMonth(minDate)) || maxDate && isAfter(day, endOfMonth(maxDate)));
    return {
      initialized: true,
      hoveredDate,
      setHoveredDate,
      currentMonth,
      setCurrentMonth,
      currentMonths,
      setCurrentMonths,
      transition,
      setTransition,
      navigate,
      clickOnDay,
      startDate,
      endDate,
      mode,
      transitionTime,
      disabledDay,
      daySize,
      locale
    };
  }, [
    currentMonth,
    currentMonths,
    daySize,
    isDateDisabled,
    endDate,
    hoveredDate,
    maxDate,
    minDate,
    onChange,
    mode,
    startDate,
    transition,
    transitionTime,
    locale
  ]);
  useEffect(() => {
    const timeout = window.setTimeout(() => {
      updateMonths(currentMonth);
    }, transitionTime);
    timeoutRef.current = timeout;
  }, [numberOfMonths, currentMonth, transitionTime, updateMonths]);
  useEffect(() => clearTimeout(timeoutRef.current), []);
  return /* @__PURE__ */ React122__default.createElement(DatePickerContext.Provider, { value: memoizedContextValue }, children);
}

// src/components/DatePicker/DatePicker.tsx
var DAY_SIZE = 32;
function DatePicker({
  numberOfMonths = 1,
  initialDate = /* @__PURE__ */ new Date(),
  locale = "en-US",
  value,
  defaultValue,
  onChange,
  maxDate,
  minDate,
  mode = "range",
  calendarDirection = "past",
  transitionTime = 200,
  isDateDisabled = () => false,
  "data-test": dataTest
}) {
  const [datesValue, setDatesValue] = useControllableState({
    prop: value,
    defaultProp: defaultValue,
    onChange
  });
  return /* @__PURE__ */ React122__default.createElement(
    DatePickerProvider,
    {
      onChange: setDatesValue,
      initialDate,
      calendarDirection,
      value: datesValue,
      mode,
      transitionTime,
      isDateDisabled,
      daySize: DAY_SIZE,
      numberOfMonths,
      minDate,
      maxDate,
      locale
    },
    /* @__PURE__ */ React122__default.createElement(
      DatePickerCalendar,
      {
        numberOfMonths,
        minDate,
        maxDate,
        "data-test": dataTest
      }
    )
  );
}
var StyledModalBody = styled(Box_default)`
  padding: 5;
  background-color: ${getColor("surface-background")};
  min-height: 100px;
  overflow-y: auto;
`;
var ModalBody = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122.createElement(StyledModalBody, __spreadValues({ "data-test": "modal-body" }, boxProps), children);
};
var ModalContext = React122.createContext({
  onHide: noop
});
var useModalContext = () => React122.useContext(ModalContext);

// src/components/Modal/components/ModalClose.tsx
function ModalClose() {
  const { onHide } = useModalContext();
  return /* @__PURE__ */ React122.createElement(Box_default, { ml: "auto", px: 4 }, /* @__PURE__ */ React122.createElement(
    Button,
    {
      "data-test": "modal-close-icon",
      size: "small",
      variant: "secondary",
      mode: "ghost",
      shape: "circle",
      onClick: onHide
    },
    /* @__PURE__ */ React122.createElement(CloseOutlined, null)
  ));
}
var StyledModalFooter = styled(Flex_default)`
  position: sticky;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 2 4;
  border-top: 1px solid ${getColor("graphic-default")};
  background-color: ${getColor("surface-default")};
`;
var ModalFooter = (_a) => {
  var _b = _a, { children } = _b, flexProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122.createElement(StyledModalFooter, __spreadValues({}, flexProps), children);
};
ModalFooter.defaultProps = {
  "data-test": "modal-footer"
};
var StyledModalHeader = styled(Flex_default)`
  position: sticky;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: space-between;
  padding-left: 5;
  border-bottom: 1px solid ${getColor("graphic-default")};
  background-color: ${getColor("surface-default")};
`;
var ModalHeader = ({
  closeButton = true,
  children,
  "data-test": dataTest
}) => {
  return /* @__PURE__ */ React122.createElement(StyledModalHeader, { "data-test": dataTest }, /* @__PURE__ */ React122.createElement(Box_default, null, children), closeButton && /* @__PURE__ */ React122.createElement(ModalClose, null));
};
ModalHeader.defaultProps = {
  "data-test": "modal-header"
};
var ModalTitle = styled54(Typography_default).attrs({
  variant: "headingBoldXS",
  mt: 4,
  mb: 4
})``;
ModalTitle.defaultProps = {
  "data-test": "modal-title"
};

// src/components/Modal/constants.ts
var modal = {
  sizes: {
    xSmall: {
      width: { _: "100%", sm: "48%", md: "32%", lg: "24%" }
    },
    small: {
      width: { _: "100%", sm: "60%", md: "42%", lg: "36%" }
    },
    regular: {
      width: { _: "100%", sm: "84%", md: "60%", lg: "48%" }
    },
    large: {
      width: { _: "100%", sm: "96%", md: "84%", lg: "72%" }
    }
  }
};
var BODY_OVERFLOW_STOP_CLASS_NAME = "__body-overflow-stop";
var InjectGlobalStyle = createGlobalStyle`
  ${normalize}

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: default;
    ${({ theme }) => theme.typography.bodyRegularS};
    color: ${getColor("text-base")};
  }

  body.${BODY_OVERFLOW_STOP_CLASS_NAME} {
    overflow: hidden;
  }

  a {
    color: primary-500;
    background-color: transparent;
    text-decoration: none;
    outline: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    display: block;
    line-height: 0;
  }
`;

// src/components/Modal/hooks.ts
var useUpdateBodyClassName = (show) => {
  React122.useEffect(() => {
    if (show) {
      document.body.classList.add(BODY_OVERFLOW_STOP_CLASS_NAME);
    } else {
      document.body.classList.remove(BODY_OVERFLOW_STOP_CLASS_NAME);
    }
  }, [show]);
};

// src/components/Modal/components/Modal.tsx
var containerAnimation = {
  enter: {
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    transition: {
      delay: 0.25,
      duration: 0.25
    }
  }
};
var ModalContainer = styled54(MotionBox).attrs({
  variants: containerAnimation,
  initial: "exit",
  animate: "enter",
  exit: "exit"
})`
  position: fixed;
  inset: 0;
  overflow: auto;
`;
var ModalBackdrop = styled54.div`
  position: absolute;
  z-index: 0;
  inset: 0;
  background-color: ${getColor$1("surface-overlay")};
`;
var Modal = ({
  onHide,
  portalContainer = document.body,
  children,
  show,
  zIndex,
  rootClose = true,
  "data-test": dataTest
}) => {
  useCloseOnEscape(show, onHide);
  useUpdateBodyClassName(show);
  return /* @__PURE__ */ React122__default.createElement(ModalContext.Provider, { value: { onHide } }, /* @__PURE__ */ React122__default.createElement(Portal, { containerRef: { current: portalContainer }, zIndex }, /* @__PURE__ */ React122__default.createElement(AnimatePresence, { "data-test": "animatePresence" }, show && /* @__PURE__ */ React122__default.createElement(ModalContainer, { "data-test": dataTest }, /* @__PURE__ */ React122__default.createElement(ModalBackdrop, { "data-test": "modal-backdrop", onClick: !rootClose ? void 0 : onHide }), children))));
};

// src/components/Modal/components/ModalDialog.tsx
var dialogAnimation = {
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    y: 100,
    opacity: 0,
    transition: {
      duration: 0.25
    }
  }
};
var ModalDialogWrapper = styled54(Box_default)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // Prevents scrollbars from showing when ModalDialogContent exit animation runs
  overflow: hidden;
`;
var ModalDialogContent = styled54(MotionBox).attrs({
  variants: dialogAnimation
})`
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - (${getSpace$1("xxxl")} * 2));
`;
var ModalDialog = (_a) => {
  var _b = _a, {
    children,
    size: size2 = "regular",
    zIndex = 1e3
  } = _b, modalProps = __objRest(_b, [
    "children",
    "size",
    "zIndex"
  ]);
  return /* @__PURE__ */ React122.createElement(Modal, __spreadValues({ zIndex }, modalProps), /* @__PURE__ */ React122.createElement(ModalDialogWrapper, { px: { _: "2", md: "4" } }, /* @__PURE__ */ React122.createElement(
    ModalDialogContent,
    {
      "data-test": "modal-dialog-content",
      bg: "surface-background",
      overflow: "hidden",
      borderRadius: "sm",
      zIndex: 1,
      w: modal.sizes[size2].width
    },
    children
  )));
};

// src/components/Drawer/Drawer.tsx
var dialogAnimation2 = {
  left: {
    enter: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.25
      }
    },
    exit: {
      x: -100,
      opacity: 0,
      transition: {
        duration: 0.25
      }
    }
  },
  right: {
    enter: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.25
      }
    },
    exit: {
      x: 100,
      opacity: 0,
      transition: {
        duration: 0.25
      }
    }
  }
};
var DrawerWrapper = styled54(MotionBox)`
  height: 100%;
`;
var Drawer = (_a) => {
  var _b = _a, {
    side = "right",
    children,
    show,
    onHide,
    portalContainer,
    rootClose,
    "data-test": dataTest = "drawer-container",
    w = "480px",
    zIndex = 1e3
  } = _b, widthProps = __objRest(_b, [
    "side",
    "children",
    "show",
    "onHide",
    "portalContainer",
    "rootClose",
    "data-test",
    "w",
    "zIndex"
  ]);
  return /* @__PURE__ */ React122__default.createElement(
    Modal,
    {
      show,
      onHide,
      portalContainer,
      "data-test": dataTest,
      rootClose,
      zIndex
    },
    /* @__PURE__ */ React122__default.createElement(DrawerWrapper, { variants: dialogAnimation2[side] }, /* @__PURE__ */ React122__default.createElement(
      Flex_default,
      __spreadValues(__spreadProps(__spreadValues({
        "data-test": "drawer-dialog-content",
        bg: "surface-background",
        overflow: "hidden",
        flexDirection: "column",
        zIndex: 1,
        position: "absolute"
      }, side === "left" ? { left: 0 } : { right: 0 }), {
        w,
        h: "100%"
      }), widthProps),
      children
    ))
  );
};
var DrawerHeader = ModalHeader;
DrawerHeader.defaultProps = {
  "data-test": "drawer-header"
};
var DrawerTitle = ModalTitle;
DrawerTitle.defaultProps = {
  "data-test": "drawer-title"
};
var DrawerClose = ModalClose;
var StyledDrawerBody = styled(Box_default)`
  flex: 1;
  background-color: ${getColor("surface-background")};
  overflow-y: auto;
`;
var DrawerBody = (_a) => {
  var _b = _a, { children } = _b, boxProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122.createElement(StyledDrawerBody, __spreadValues({ "data-test": "drawer-body", p: 5 }, boxProps), children);
};
var StyledDrawerFooter = styled(Flex_default)`
  position: sticky;
  padding: 2 4;
  border-top: 1px solid ${"graphic-default"};
  background-color: ${getColor("surface-default")};
`;
var DrawerFooter = (_a) => {
  var _b = _a, { children } = _b, flexProps = __objRest(_b, ["children"]);
  return /* @__PURE__ */ React122.createElement(StyledDrawerFooter, __spreadValues({ "data-test": "drawer-footer" }, flexProps), children);
};
var shimmer = keyframes`
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
`;
var wave = keyframes`
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
`;
var ANIMATION_DELAY = "0.2s";
var makeSkeletonShape = ({ shape }) => {
  if (shape === "squircle") {
    return css`
      clip-path: url(#svgPath);
    `;
  }
  return css`
    border-radius: ${shape === "circle" ? "50%" : shape === "squareRounded" ? "default" : void 0};
  `;
};
var makeSkeletonAnimation = ({
  animation,
  animationDelay
}) => css`
  animation: ${animation === "shimmer" ? shimmer : "none"} 1.5s ease-in-out infinite;
  animation-delay: ${animation === "shimmer" && animationDelay ? ANIMATION_DELAY : void 0};

  &:after {
    display: ${animation === "wave" ? "block" : "none"};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: ${animation === "wave" ? wave : "none"} 1.5s ease-in-out infinite;
    animation-delay: ${animation === "wave" && animationDelay ? ANIMATION_DELAY : void 0};
    background-image: linear-gradient(
      90deg,
      transparent,
      ${th.color("skeleton-wave")},
      transparent
    );
  }
`;
var shouldForwardProp4 = (prop, defaultValidationFn) => !["shape"].includes(prop) && defaultValidationFn(prop);

// src/components/Skeleton/Skeleton.tsx
var SkeletonComponent = styled54(Box_default).withConfig({ shouldForwardProp: shouldForwardProp4 })`
  ${makeSkeletonShape}
  ${makeSkeletonAnimation}
  position: relative;
  overflow: hidden;
`;
var Skeleton = (_a) => {
  var _b = _a, {
    shape = "squareRounded",
    animation = "wave"
  } = _b, otherProps = __objRest(_b, [
    "shape",
    "animation"
  ]);
  return /* @__PURE__ */ React122__default.createElement(
    SkeletonComponent,
    __spreadValues({
      backgroundColor: "skeleton-base",
      shape,
      animation
    }, otherProps)
  );
};
var shouldForwardProp5 = (prop, defaultValidationFn) => !["size"].includes(prop) && defaultValidationFn(prop);
var IconContainer2 = styled54(Box_default).withConfig({
  shouldForwardProp: shouldForwardProp5
})`
  line-height: 0;
  ${space$1};
  > svg {
    ${size};
    ${color$1};
    ${opacity$1};
  }
`;

// src/components/FlagIcon/utils.ts
var COUNTRY_ISO_MAPPING = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AN: "ANT",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BA: "BIH",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "XKX",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
var getFlagComponent = (countryCode) => {
  const countryCodeISO3 = COUNTRY_ISO_MAPPING[countryCode.toUpperCase()];
  const ISO3 = countryCodeISO3 || "USA";
  return `Flag${ISO3.charAt(0).toUpperCase()}${ISO3.slice(1).toLowerCase()}`;
};

// src/components/FlagIcon/FlagIcon.tsx
var Flag = loadable(
  ({ component }) => import(`@aircall/icons/dist/${component}.mjs`),
  {
    cacheKey: (props) => props.component
  }
);
var FlagIcon = forwardRef(
  (_a, ref) => {
    var _b = _a, { countryCode, size: size2 = "24px" } = _b, otherStyleProps = __objRest(_b, ["countryCode", "size"]);
    const icon = getFlagComponent(countryCode);
    return /* @__PURE__ */ React122__default.createElement(IconContainer2, __spreadValues({ ref, size: size2 }, otherStyleProps), /* @__PURE__ */ React122__default.createElement(Flag, { component: icon, fallback: /* @__PURE__ */ React122__default.createElement(Skeleton, { w: size2, h: size2, shape: "squircle" }) }));
  }
);
var GaugeItem = styled54(Box_default)`
  transition: background-color 0.2s ease-in-out;
`;
var Gauge = React122.forwardRef(({ value, gauges = 8 }, ref) => {
  return /* @__PURE__ */ React122.createElement(Grid, { ref, w: "100%", columnGap: "12px", gridTemplateColumns: "8", "data-test": "input-gauge" }, range(gauges).map((_, index) => /* @__PURE__ */ React122.createElement(
    GaugeItem,
    {
      key: index,
      borderRadius: "sm",
      display: "block",
      h: "12px",
      backgroundColor: index < value ? "graphic-primary" : "graphic-default"
    }
  )));
});
var Gauge_default = Gauge;
var IconContainer3 = styled54(Icon_default)`
  position: relative;
  z-index: 2;
`;
var IconButtonContainer = styled54.button`
  margin: 0;
  padding: 0;
  border: none;
  position: relative;
  cursor: pointer;
  background: none;
  ${space}

  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: calc(100% + 8px);
    height: calc(100% + 8px);
    border-radius: 50%;
    transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
    transform: translate(-50%, -50%) scale(0.75);
    pointer-events: none;
    opacity: 0;
    z-index: 1;
  }

  &::before {
    background-color: ${({ discColor, theme }) => get(theme.colors, discColor || "interaction-standard-hover")};
  }

  &:hover {
    &::before {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  &:focus {
    outline: none;

    &::after {
      background-color: ${({ discColor, theme }) => get(theme.colors, discColor || "interaction-standard-hover")};
      opacity: 1;
      transform: translate(-50%, -50%);
    }
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;

    &::before,
    &::after {
      content: none;
    }
  }
`;
var IconButton = forwardRef(
  (_a, ref) => {
    var _b = _a, { disabled = false, onClick, discColor, size: size2, color: color4, component, spin } = _b, otherStyleProps = __objRest(_b, ["disabled", "onClick", "discColor", "size", "color", "component", "spin"]);
    return /* @__PURE__ */ React122__default.createElement(
      IconButtonContainer,
      __spreadValues({
        ref,
        onClick,
        discColor,
        disabled
      }, otherStyleProps),
      /* @__PURE__ */ React122__default.createElement(IconContainer3, { size: size2, component, color: color4, spin })
    );
  }
);
var IconButton_default = IconButton;

// src/components/Select/constants.ts
var selectSizesHeight = {
  small: "40px",
  regular: "48px",
  large: "56px"
};
var searchableDropdownMinHeight = {
  small: "80px",
  regular: "96px",
  large: "112px"
};
var SelectContext = React122.createContext(null);
var useSelect = () => React122.useContext(SelectContext);
var SelectProvider = ({
  size: size2,
  validationStatus,
  selectionMode,
  disabled,
  loading,
  loadingText,
  noOptionsLabel,
  getOptionLabel = (option) => option.label,
  getOptionValue = (option) => option.value,
  renderOption,
  children
}) => {
  const { selectedKeys } = useMenu();
  return /* @__PURE__ */ React122.createElement(
    SelectContext.Provider,
    {
      value: {
        componentSize: size2,
        componentStatus: validationStatus,
        selectedKeys,
        selectionMode,
        disabled,
        loading,
        loadingText,
        noOptionsLabel,
        getOptionLabel,
        getOptionValue,
        renderOption
      }
    },
    children
  );
};

// src/components/Select/components/SelectContent.tsx
var SelectContent = (_a) => {
  var _b = _a, {
    children,
    searchable,
    takeTriggerWidth = true
  } = _b, popoverContent = __objRest(_b, [
    "children",
    "searchable",
    "takeTriggerWidth"
  ]);
  const { componentSize } = useSelect();
  return /* @__PURE__ */ React122.createElement(
    Popover.Content,
    __spreadProps(__spreadValues({}, popoverContent), {
      flexDirection: "column",
      sideOffset: 8,
      boxShadow: 1,
      overflow: "hidden",
      borderRadius: "sm",
      bg: "surface-interactive-default",
      takeTriggerWidth,
      takeViewportHeight: true,
      minWidth: takeTriggerWidth ? "fit-content" : 220,
      minHeight: searchable ? searchableDropdownMinHeight[componentSize] : void 0,
      closeOnInsideClick: false,
      closeOnOutsideClick: true
    }),
    children
  );
};

// src/components/Select/utils.ts
function isGroupOption(element) {
  return element.options !== void 0;
}
var ClearButton = styled54(IconButton_default)`
  position: absolute;
  top: 50%;
  right: 16px;
  background-color: transparent;
  border: none;
  transform: translateY(-50%);
  ${(props) => props.clearIconStyle}
`;
var LeftIcon = styled54(Icon_default)`
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  pointer-events: none;
`;

// src/components/TextField/TextField.tsx
var TextFieldContainer = styled54.div`
  position: relative;
  width: 100%;
`;
function TextField({
  onClear,
  icon,
  children,
  clearIconStyle: clearIconStyle2,
  error,
  disabled
}) {
  const iconColor = disabled ? "icon-disabled" : "icon-default";
  return /* @__PURE__ */ React122__default.createElement(TextFieldContainer, null, icon && /* @__PURE__ */ React122__default.createElement(LeftIcon, { component: icon, color: iconColor }), React122__default.Children.only(children), !!onClear && /* @__PURE__ */ React122__default.createElement(
    ClearButton,
    {
      disabled,
      type: "button",
      size: 16,
      color: iconColor,
      component: CloseOutlined,
      onClick: onClear,
      clearIconStyle: clearIconStyle2,
      "data-test": "text-field-clear-button"
    }
  ));
}
var TextField_default = TextField;

// src/components/TextField/hooks/useTextField/useTextField.ts
var useTextField = ({
  icon,
  onClear,
  validationStatus,
  id,
  size: size2
}) => {
  const { componentStatus, componentId, componentSize, error } = useForm({
    id,
    validationStatus,
    size: size2
  });
  const hasLeftIcon = !!icon;
  const hasClearIcon = !!onClear;
  return {
    componentSize,
    componentStatus,
    componentId,
    error,
    hasLeftIcon,
    hasClearIcon
  };
};
var makeTextField = ({
  theme,
  hasLeftIcon,
  hasClearIcon
}) => css`
  background-color: ${getColor("surface-default")};
  border: 1px solid ${getColor("graphic-interactive-default")};
  border-radius: sm;
  width: 100%;
  padding-left: ${getSpace(hasLeftIcon ? 7 : 4)};
  padding-right: ${getSpace(hasClearIcon ? 7 : 4)};
  ${theme.typography.bodyMediumS};
  font-family: default;
  appearance: none;
  box-sizing: border-box;
  transition: default;
  outline: none;

  caret-color: ${getColor("text-base")};
  color: ${getColor("text-base")};

  ::placeholder {
    color: ${getColor("text-placeholder")};
  }

  :disabled {
    background-color: ${getColor("surface-disabled")};
    border-color: ${getColor("graphic-disabled")};
    color: ${getColor("text-disabled")};
  }

  :not(:disabled) {
    :hover {
      border-color: ${getColor("graphic-interactive-default-hover")};
    }

    :focus {
      border-color: ${getColor("graphic-interactive-default-active")};
    }
  }
`;
var makeTextFieldValidationStatus = ({
  validationStatus
}) => {
  if (validationStatus !== "error") {
    return;
  }
  return css`
    border-color: ${getColor("graphic-interactive-critical")};
    caret-color: ${getColor("text-critical")};

    :not(:disabled) {
      :hover {
        border-color: ${getColor("graphic-interactive-critical-hover")};
      }

      :focus {
        border-color: ${getColor("graphic-interactive-critical-active")};
      }
    }
  `;
};
var makeDefaultField = css`
  ${makeTextField}
  ${makeTextFieldValidationStatus}
`;

// src/components/TextInput/constants.ts
var TEXT_INPUT_SIZES = {
  small: "40px",
  regular: "48px",
  large: "56px"
};

// src/components/TextInput/utils.ts
var makeTextInputSize = ({ componentSize }) => {
  const size2 = TEXT_INPUT_SIZES[componentSize] || TEXT_INPUT_SIZES.regular;
  return css`
    height: ${size2};
  `;
};
var makeListVariantStyle = ({ variant: variant2 }) => variant2 === "list" && css`
    border: none;
    border-radius: 0px;
    border-bottom: 1px solid ${getColor("graphic-interactive-default")};

    :not(:disabled) {
      &:hover {
        border-bottom-color: ${getColor("graphic-interactive-default-hover")};
      }

      &:focus {
        border-bottom-color: ${getColor("graphic-interactive-default-active")};
      }
    }
  `;

// src/components/TextInput/TextInput.tsx
var TextInputComponent = styled54.input`
  ${makeTextInputSize}
  ${makeTextField}
  ${makeListVariantStyle}
  ${makeTextFieldValidationStatus}
`;
var TextInput = forwardRef((props, ref) => {
  const _a = props, {
    id,
    icon,
    size: size2,
    validationStatus,
    onClear,
    variant: variant2 = "input",
    type = "text",
    disabled
  } = _a, inputProps = __objRest(_a, [
    "id",
    "icon",
    "size",
    "validationStatus",
    "onClear",
    "variant",
    "type",
    "disabled"
  ]);
  const { componentStatus, componentId, componentSize, error, hasLeftIcon, hasClearIcon } = useTextField({
    id,
    validationStatus,
    icon,
    size: size2,
    onClear
  });
  return /* @__PURE__ */ React122__default.createElement(TextField_default, __spreadValues({}, { icon, onClear, error, disabled }), /* @__PURE__ */ React122__default.createElement(
    TextInputComponent,
    __spreadValues({
      ref,
      type,
      id: componentId,
      validationStatus: componentStatus,
      variant: variant2,
      componentSize,
      hasLeftIcon,
      hasClearIcon,
      disabled
    }, inputProps)
  ));
});

// src/components/Select/components/styled.ts
var CustomInput = styled54(TextInput)`
  border: none;
  ${({ side }) => side === "bottom" ? css`
          border-bottom: 1px solid ${getColor("graphic-default")};
        ` : css`
          border-top: 1px solid ${getColor("graphic-default")};
        `};
`;
var makeTriggerContainerStyle = ({
  validationStatus,
  triggerSize
}) => {
  return css`
    outline: 0;
    height: ${selectSizesHeight[triggerSize]};
  `;
};
var makeTriggerStates = ({
  validationStatus,
  disabled,
  triggerSize
}) => {
  const hasError = validationStatus === "error";
  if (disabled) {
    return css`
      background-color: ${getColor("surface-disabled")};
      border-color: ${getColor("graphic-disabled")};
      color: ${getColor("text-disabled")};
    `;
  }
  if (hasError) {
    return css`
      border-color: ${getColor("graphic-interactive-critical")};
    `;
  }
  return css`
    :not(:disabled) {
      :hover {
        border-color: ${getColor("graphic-interactive-default-hover")};
      }

      :focus {
        border-color: ${getColor("graphic-interactive-default-active")};
      }
    }
  `;
};
var makeDisabledTriggerContainerStyle = ({ disabled }) => {
  if (!disabled)
    return;
  return css`
    cursor: 'not-allowed';
    /* prevent all clicks event, and the dropdown menu won't open */
    pointer-events: none;
    background-color: input-deemphasized;
  `;
};
var TriggerContainer = styled54(Grid).attrs(() => ({
  gridTemplateColumns: "1fr auto",
  alignItems: "center",
  gap: "xxs",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "graphic-interactive-default",
  backgroundColor: "surface-default",
  cursor: "pointer",
  borderRadius: "sm",
  px: "s"
})).withConfig({
  shouldForwardProp: (prop, defaultValidator) => defaultValidator(prop)
})`
  text-align: left;
  ${makeTriggerContainerStyle}
  ${makeTriggerStates}
  ${makeDisabledTriggerContainerStyle}
`;
var EmptyShell = styled54(Flex_default)`
  ${({ theme }) => theme.typography.bodyMediumS};
  position: relative;
  align-items: center;
  height: 48px;
  padding: 3 4;
  color: ${getColor("text-default")};
  user-select: none;
  background-color: input-background-01;
  transition: default;
`;

// src/components/Select/components/Loading.tsx
var Loading = ({ loadingText }) => {
  return /* @__PURE__ */ React122__default.createElement(EmptyShell, null, /* @__PURE__ */ React122__default.createElement(Icon_default, { spin: true, component: LoadingRedoUndoOutlined, color: "icon-primary", size: "16px", mr: 2 }), loadingText);
};

// src/components/Select/components/SelectMenu.tsx
var SelectMenu = ({ options, "data-test": dataTest }) => {
  const { getOptionValue, loading, loadingText, noOptionsLabel } = useSelect();
  return /* @__PURE__ */ React122__default.createElement(
    StyledMenu,
    {
      "data-test": dataTest,
      minWidth: "unset",
      overflowY: "auto",
      py: 2
    },
    loading ? /* @__PURE__ */ React122__default.createElement(Loading, { loadingText }) : options.length === 0 ? /* @__PURE__ */ React122__default.createElement(EmptyShell, null, noOptionsLabel) : options.map(
      (option, optionIdx) => isGroupOption(option) ? /* @__PURE__ */ React122__default.createElement(
        SelectMenuGroup,
        {
          key: `option-group-${optionIdx}`,
          option,
          optionIdx
        }
      ) : /* @__PURE__ */ React122__default.createElement(SelectMenuItem, { key: getOptionValue(option), option })
    )
  );
};
var SelectMenuGroup = ({ option, optionIdx }) => {
  const { options, label } = option;
  const divider = optionIdx !== 0 && !label;
  return /* @__PURE__ */ React122__default.createElement(MenuItemGroup, { title: label, divider }, options.map((item) => /* @__PURE__ */ React122__default.createElement(SelectMenuItem, { key: item.value, option: item })));
};
var SelectMenuItem = ({ option }) => {
  const { toggleOpen } = usePopoverContext();
  const { getOptionLabel, getOptionValue, renderOption, selectionMode } = useSelect();
  const { prefix, suffix } = option;
  const itemKey = getOptionValue(option);
  const optionElement = renderOption ? renderOption(option) : getOptionLabel(option);
  const onItemClick = useCallback(() => {
    selectionMode === "single" && toggleOpen();
  }, [toggleOpen, selectionMode]);
  return /* @__PURE__ */ React122__default.createElement(MenuItem, { itemKey, "data-test": `select-option-item-${itemKey}`, onClick: onItemClick }, prefix && /* @__PURE__ */ React122__default.createElement(MenuItemPrefix, null, prefix), /* @__PURE__ */ React122__default.createElement(MenuItemLabel, null, optionElement), suffix && /* @__PURE__ */ React122__default.createElement(MenuItemSuffix, null, suffix));
};
var SearchInput = ({ onChange, value, side, size: size2 }) => {
  return /* @__PURE__ */ React122.createElement(
    CustomInput,
    {
      "data-test": "select-search-input",
      side,
      value,
      variant: "list",
      autoFocus: true,
      onChange: (event) => onChange(event.target.value),
      onClear: value ? () => onChange("") : void 0,
      icon: SearchOutlined,
      size: size2
    }
  );
};

// src/components/Select/components/SelectSearch.tsx
var SelectSearch = ({ onChange, size: size2, value }) => {
  const { side } = usePopoverPlacement();
  const handleChange = (value2) => {
    onChange == null ? void 0 : onChange(value2);
  };
  return /* @__PURE__ */ React122.createElement(Box_default, { order: side === "bottom" ? -1 : 1 }, /* @__PURE__ */ React122.createElement(
    SearchInput,
    {
      value,
      onChange: handleChange,
      size: size2,
      side
    }
  ));
};
var SelectTrigger = (_a) => {
  var triggerProps = __objRest(_a, []);
  const context = usePopoverContext();
  return /* @__PURE__ */ React122.createElement(Popover.Trigger, __spreadProps(__spreadValues({}, triggerProps), { onClick: context.toggleOpen }));
};
var ValueContainer = ({ selectedLabels }) => {
  if (selectedLabels.every((label) => typeof label === "string")) {
    return /* @__PURE__ */ React122__default.createElement(
      Typography_default,
      {
        color: "text-base",
        "data-test": "select-value-container",
        variant: "bodyRegularS",
        ellipsis: true
      },
      selectedLabels.join(",")
    );
  }
  return /* @__PURE__ */ React122__default.createElement(Spacer, { space: 1 }, selectedLabels);
};

// src/components/Select/components/SelectTriggerButton.tsx
var SelectTriggerButton = React122__default.forwardRef(
  (_a, ref) => {
    var _b = _a, { placeholder, options } = _b, triggerButtonProps = __objRest(_b, ["placeholder", "options"]);
    const {
      selectedKeys,
      disabled,
      componentSize,
      componentStatus,
      getOptionLabel,
      getOptionValue
    } = useSelect();
    const selectedLabels = useMemo(
      () => options.filter(
        (option) => isGroupOption(option) ? false : selectedKeys.includes(getOptionValue(option))
      ).map(getOptionLabel),
      [options, selectedKeys, getOptionLabel, getOptionValue]
    );
    return /* @__PURE__ */ React122__default.createElement(
      TriggerContainer,
      __spreadValues({
        triggerSize: componentSize,
        validationStatus: componentStatus,
        disabled,
        ref
      }, triggerButtonProps),
      selectedKeys.length === 0 ? /* @__PURE__ */ React122__default.createElement(Typography_default, { color: disabled ? "text-disabled" : "text-placeholder" }, placeholder) : /* @__PURE__ */ React122__default.createElement(ValueContainer, { selectedLabels }),
      /* @__PURE__ */ React122__default.createElement(Icon_default, { color: disabled ? "icon-disabled" : "icon-default", component: ChevronDownOutlined })
    );
  }
);

// src/components/Select/Select.tsx
var Select = ({
  options,
  size: size2 = "regular",
  selectionMode = "single",
  defaultSelectedKeys = [],
  selectedKeys,
  onItemSelected: onSelect,
  onItemDeselected: onDeselect,
  onSelectionChange,
  side = "bottom",
  align = "start",
  disabled = false,
  placeholder,
  validationStatus,
  getOptionLabel,
  getOptionValue,
  renderOption,
  trigger,
  w = "100%",
  loading,
  loadingText = "Loading results",
  noOptionsLabel = "No options",
  searchable = false,
  "data-test": dataTest,
  onBlur,
  takeTriggerWidth,
  takeViewportHeight,
  open,
  defaultOpen = false,
  searchOptions
}) => {
  const [searchText, setSearchText] = useState(void 0);
  const [innerOptions, setInnerOptions] = useState(options);
  const searchOptionsRef = useLatest(searchOptions);
  const { componentSize, componentStatus } = useForm({ size: size2, validationStatus });
  const selectTrigger = trigger != null ? trigger : /* @__PURE__ */ React122__default.createElement(SelectTriggerButton, { placeholder, options, w });
  const triggerTestId = dataTest || "select-trigger-container";
  const menuTestId = dataTest ? `${dataTest}-dropdown-menu` : "select-dropdown-menu";
  const contentTestId = dataTest ? `${dataTest}-content` : "select-dropdown-container";
  useEffect(() => {
    if (searchText === void 0 || !(searchOptionsRef == null ? void 0 : searchOptionsRef.current))
      return;
    const filter = () => __async(void 0, null, function* () {
      const filteredOptions = yield searchOptionsRef.current(searchText);
      setInnerOptions(filteredOptions);
    });
    filter();
  }, [searchText, searchOptionsRef]);
  useEffect(() => {
    setInnerOptions(options);
  }, [options]);
  return /* @__PURE__ */ React122__default.createElement(
    MenuProvider,
    {
      selectionMode,
      size: componentSize,
      selectedKeys,
      defaultSelectedKeys,
      onSelect,
      onDeselect,
      onSelectionChange,
      disabled
    },
    /* @__PURE__ */ React122__default.createElement(
      SelectProvider,
      {
        size: componentSize,
        validationStatus: componentStatus,
        selectionMode,
        loading,
        loadingText,
        disabled,
        noOptionsLabel,
        getOptionLabel,
        getOptionValue,
        renderOption
      },
      /* @__PURE__ */ React122__default.createElement(Popover.Root, { open, defaultOpen }, /* @__PURE__ */ React122__default.createElement(SelectTrigger, { tabIndex: 0, "data-test": triggerTestId, onBlur }, selectTrigger), /* @__PURE__ */ React122__default.createElement(
        SelectContent,
        __spreadProps(__spreadValues({}, { align, side, searchable, takeTriggerWidth, takeViewportHeight }), {
          "data-test": contentTestId
        }),
        searchable && /* @__PURE__ */ React122__default.createElement(SelectSearch, { onChange: setSearchText, size: size2, value: searchText }),
        /* @__PURE__ */ React122__default.createElement(SelectMenu, { options: innerOptions, "data-test": menuTestId })
      ))
    )
  );
};

// src/components/Pagination/constants.ts
var PAGE_SIZE_OPTIONS = [
  { value: 25, label: "25" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 200, label: "200" }
];
var ELLIPSIS_MARKER = void 0;
var INITIAL_PAGE = 1;

// src/components/Pagination/pagesBuilder.ts
var buildPages = (totalPages, activePage, ellipsisMarker) => {
  if (totalPages <= 6) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  } else {
    if (activePage <= 4) {
      return [1, 2, 3, 4, 5, ellipsisMarker, totalPages];
    } else if (activePage >= 5 && activePage <= totalPages - 4) {
      return [
        1,
        ellipsisMarker,
        activePage - 1,
        activePage,
        activePage + 1,
        ellipsisMarker,
        totalPages
      ];
    } else if (activePage >= totalPages - 3) {
      return [
        1,
        ellipsisMarker,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages
      ];
    } else {
      throw new Error("Unhandled pagination criteria");
    }
  }
};

// src/components/Pagination/Pagination.tsx
var Pagination = (_a) => {
  var _b = _a, {
    activePage: activePageProp,
    defaultActivePage = INITIAL_PAGE,
    onPageChange,
    recordsTotalCount,
    pageSizeOptions = PAGE_SIZE_OPTIONS,
    pageSize: pageSizeProp,
    defaultPageSize = pageSizeOptions[0].value,
    onPageSizeChange
  } = _b, styleProps = __objRest(_b, [
    "activePage",
    "defaultActivePage",
    "onPageChange",
    "recordsTotalCount",
    "pageSizeOptions",
    "pageSize",
    "defaultPageSize",
    "onPageSizeChange"
  ]);
  const [pageSize = defaultPageSize, setPageSize] = useControllableState({
    prop: pageSizeProp,
    defaultProp: defaultPageSize,
    onChange: onPageSizeChange
  });
  const [activePage = defaultActivePage, setActivePage] = useControllableState({
    prop: activePageProp,
    defaultProp: defaultActivePage,
    onChange: onPageChange
  });
  const incrementPage = React122.useCallback(() => {
    setActivePage(activePage + 1);
  }, [setActivePage, activePage]);
  const decrementPage = React122.useCallback(() => {
    setActivePage(activePage - 1);
  }, [setActivePage, activePage]);
  const totalPages = Math.ceil(recordsTotalCount / pageSize);
  const pages = React122.useMemo(
    () => buildPages(totalPages, activePage, ELLIPSIS_MARKER),
    [activePage, totalPages]
  );
  return /* @__PURE__ */ React122.createElement(Spacer, __spreadValues({ space: "s", justifyContent: "flex-end", fluid: true }, styleProps), /* @__PURE__ */ React122.createElement(
    Select,
    {
      options: pageSizeOptions,
      side: "bottom",
      align: "start",
      selectionMode: "single",
      selectedKeys: [pageSize],
      takeTriggerWidth: true,
      onSelectionChange: (selectedKeys) => setPageSize(selectedKeys[0]),
      size: "small"
    }
  ), /* @__PURE__ */ React122.createElement(Spacer, { space: 1, justifyContent: "flex-end", fluid: true }, /* @__PURE__ */ React122.createElement(
    Button,
    {
      size: "small",
      onClick: decrementPage,
      disabled: activePage === 1,
      "data-test": "pagination-left",
      variant: "secondary",
      mode: "ghost"
    },
    /* @__PURE__ */ React122.createElement(ChevronLeftOutlined, null)
  ), pages.map(
    (page, index) => page !== ELLIPSIS_MARKER ? /* @__PURE__ */ React122.createElement(
      Button,
      {
        size: "small",
        key: page,
        "data-test": `pagination-page-${page}`,
        variant: "secondary",
        mode: activePage === page ? "fill" : "outline",
        onClick: () => setActivePage(page)
      },
      page
    ) : /* @__PURE__ */ React122.createElement(Button, { key: `ellipsis${index}`, variant: "secondary", mode: "ghost", size: "small", readOnly: true }, "...")
  ), /* @__PURE__ */ React122.createElement(
    Button,
    {
      onClick: incrementPage,
      disabled: activePage === totalPages,
      "data-test": "pagination-right",
      size: "small",
      variant: "secondary",
      mode: "ghost"
    },
    /* @__PURE__ */ React122.createElement(ChevronRightOutlined, null)
  )));
};
var RadioLabel = styled(Typography_default).attrs({
  as: "span",
  "data-test": "radio-label"
})`
  grid-area: label;
  align-self: center;
  user-select: none;
  margin-left: 2;
`;
RadioLabel.displayName = "RadioLabel";

// src/components/Radio/constants.ts
var RADIO_SIZES = {
  small: "16px",
  regular: "24px",
  large: "32px"
};
var RADIO_INDICATOR_SIZES = {
  small: "8px",
  regular: "12px",
  large: "16px"
};

// src/components/Radio/components/StyledRadioContainer.tsx
var makeRadioSize = ({ size: size2 }) => {
  const radioSize = RADIO_SIZES[size2];
  return css`
    height: ${radioSize};
    width: ${radioSize};
  `;
};
var StyledRadioContainer = styled54.div`
  position: relative;
  display: block;
  box-sizing: border-box;
  border: 1.5px solid transparent;
  ${makeRadioSize}
  transition: border-color 300ms;
  outline: 0;
  flex-shrink: 0;
  user-select: none;
  border-radius: full;

  input {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;
var makeRadioIndicatorSize = ({ size: size2, checked }) => {
  if (!checked) {
    return null;
  }
  const indicatorSize = RADIO_INDICATOR_SIZES[size2];
  return css`
    height: ${indicatorSize};
    width: ${indicatorSize};
  `;
};
var StyledRadioIndicator = styled54.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;

  &:after {
    display: block;
    content: '';
    border-radius: full;
    transform: scale(0);
    transition: background 300ms, transform 150ms;
    transform-origin: center;
    ${makeRadioIndicatorSize}
    ${({ checked }) => checked && "transform: scale(1);"}
  }
`;
var RadioDescription = styled(Typography_default).attrs({
  as: "span",
  "data-test": "radio-description"
})`
  grid-area: description;
  margin-top: 2;
  margin-left: 2;
  user-select: none;
`;
RadioDescription.displayName = "RadioDescription";

// src/components/Radio/components/StyledRadioLayout.tsx
var makeRadioTypography = ({
  size: size2,
  disabled,
  theme
}) => {
  return css`
    ${RadioLabel} {
      ${size2 === "small" ? theme.typography.bodyRegularS : theme.typography.bodyRegularM};
      color: ${getColor$1(disabled ? "text-disabled" : "text-base")};
    }

    ${RadioDescription} {
      ${theme.typography.supportingRegularS};
      color: ${getColor$1(disabled ? "text-disabled" : "text-secondary")};
    }
  `;
};
var makeRadioColor = ({
  checked,
  disabled,
  readOnly,
  error
}) => {
  if (disabled) {
    return css`
      ${StyledRadioContainer} {
        background-color: ${getColor$1("surface-disabled")};
        border-color: ${getColor$1("graphic-disabled")};
      }

      ${StyledRadioIndicator}:after {
        background-color: ${getColor$1("surface-interactive-disabled")};
      }
    `;
  }
  if (error) {
    return css`
      ${StyledRadioContainer} {
        border-color: ${getColor$1("graphic-interactive-critical")};
      }

      ${StyledRadioIndicator}:after {
        background-color: ${getColor$1("surface-interactive-critical")};
      }

      ${!readOnly && `
        &:hover {
          ${StyledRadioContainer} {
            border-color: ${getColor$1("graphic-interactive-critical-hover")};
          }

          ${StyledRadioIndicator}:after {
            background-color: ${getColor$1("surface-interactive-critical-hover")};
          }
        }

        /* Using focus-within because the one receiving focus is the input, not the div. */
        &:focus-within,
        &:active {
          ${StyledRadioContainer} {
            border-color: ${getColor$1("graphic-interactive-critical-active")};
          }

          ${StyledRadioIndicator}:after {
            background-color: ${getColor$1("surface-interactive-critical-active")};
          }
        }
      `}
    `;
  }
  if (checked) {
    return css`
      ${StyledRadioContainer} {
        border-color: ${getColor$1("graphic-interactive-primary")};
      }

      ${StyledRadioIndicator}:after {
        background-color: ${getColor$1("surface-interactive-primary")};
      }

      ${!readOnly && css`
        &:hover {
          ${StyledRadioContainer} {
            border-color: ${getColor$1("graphic-interactive-primary-hover")};
          }

          ${StyledRadioIndicator}:after {
            background-color: ${getColor$1("surface-interactive-primary-hover")};
          }
        }

        &:focus-within,
        &:active {
          ${StyledRadioContainer} {
            border-color: ${getColor$1("graphic-interactive-primary-active")};
          }

          ${StyledRadioIndicator}:after {
            background-color: ${getColor$1("surface-interactive-primary-active")};
          }
        }
      `}
    `;
  }
  return css`
    ${StyledRadioContainer} {
      background-color: ${getColor$1("surface-interactive-default")};
      border-color: ${getColor$1("graphic-interactive-default")};
    }

    ${!readOnly && css`
      &:hover {
        ${StyledRadioContainer} {
          background-color: ${getColor$1("surface-interactive-default-hover")};
          border-color: ${getColor$1("graphic-interactive-default-hover")};
        }
      }

      &:focus-within,
      &:active {
        ${StyledRadioContainer} {
          background-color: ${getColor$1("surface-interactive-default-active")};
          border-color: ${getColor$1("graphic-interactive-default-active")};
        }
      }
    `}
  `;
};
var StyledRadioLayout = styled54(Grid)`
  display: inline-grid;
  grid-template-areas:
    'icon label'
    '. description';
  grid-template-rows: 1fr auto;
  justify-content: flex-start;
  align-items: center;

  &,
  input {
    cursor: ${({ disabled, readOnly }) => disabled || readOnly ? void 0 : "pointer"};
  }

  ${makeRadioTypography}
  ${makeRadioColor}
`;
var RadioGroupContext = React122__default.createContext(null);
var useRadioGroupContext = () => React122__default.useContext(RadioGroupContext);

// src/components/Radio/hooks/useRadio.ts
function useRadio(props = {}) {
  var _a, _b, _c;
  const {
    defaultChecked = false,
    checked: checkedProp,
    disabled: disabledProp,
    readOnly: readOnlyProp,
    size: sizeProps,
    validationStatus,
    onChange: onChangeProp,
    name,
    value,
    id: idProp
  } = props;
  const radioGroupProps = useRadioGroupContext();
  const uuid = `radio-${useId()}`;
  const { componentId, componentSize, error } = useForm({
    validationStatus,
    size: sizeProps,
    id: uuid
  });
  const id = idProp != null ? idProp : componentId;
  const [checked = defaultChecked, setChecked] = useControllableState({
    prop: (checkedProp != null ? checkedProp : radioGroupProps) ? (radioGroupProps == null ? void 0 : radioGroupProps.checkedValue) === value : void 0,
    defaultProp: defaultChecked
  });
  const size2 = (_a = sizeProps != null ? sizeProps : radioGroupProps == null ? void 0 : radioGroupProps.size) != null ? _a : componentSize;
  const readOnly = (_b = readOnlyProp != null ? readOnlyProp : radioGroupProps == null ? void 0 : radioGroupProps.readOnly) != null ? _b : false;
  const disabled = (_c = disabledProp != null ? disabledProp : radioGroupProps == null ? void 0 : radioGroupProps.disabled) != null ? _c : false;
  const invalid = !!error;
  const onChange = composeEventHandlers(onChangeProp, radioGroupProps == null ? void 0 : radioGroupProps.onChange);
  const handleChange = useCallback(
    (event) => {
      if (readOnly || disabled) {
        event.preventDefault();
        return;
      }
      setChecked(event.target.checked);
      onChange == null ? void 0 : onChange(event);
    },
    [disabled, readOnly, onChange, setChecked]
  );
  const getInputProps = useCallback(
    () => ({
      value,
      id,
      name,
      checked,
      disabled,
      onChange: handleChange,
      "aria-checked": checked,
      "aria-disabled": disabled,
      "aria-hidden": true
    }),
    [checked, disabled, value, id, name, handleChange]
  );
  const getLayoutProps = useCallback(
    () => ({
      id,
      size: size2,
      invalid,
      disabled,
      readOnly,
      checked
    }),
    [id, checked, disabled, invalid, readOnly, size2]
  );
  return {
    name,
    getLayoutProps,
    getInputProps
  };
}

// src/components/Radio/Radio.tsx
var Radio = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, "data-test": dataTest } = _b, useRadioProps = __objRest(_b, ["children", "data-test"]);
    const { getLayoutProps, getInputProps } = useRadio(useRadioProps);
    const { id, disabled, size: size2, checked, invalid, readOnly } = getLayoutProps();
    const childNode = typeof children === "string" ? /* @__PURE__ */ React122__default.createElement(RadioLabel, null, children) : children;
    return /* @__PURE__ */ React122__default.createElement(
      StyledRadioLayout,
      __spreadValues({
        as: "label",
        htmlFor: id,
        error: invalid,
        "data-test": dataTest
      }, { checked, size: size2, disabled, readOnly }),
      /* @__PURE__ */ React122__default.createElement(StyledRadioContainer, __spreadValues({}, { size: size2 }), /* @__PURE__ */ React122__default.createElement("input", __spreadValues({ ref, "data-test": "radio", type: "radio" }, getInputProps())), /* @__PURE__ */ React122__default.createElement(StyledRadioIndicator, __spreadValues({}, { size: size2, checked }))),
      childNode
    );
  }
);
Radio.displayName = "Radio";
var RadioGroup = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      defaultValue,
      value: checkedProp,
      readOnly,
      disabled,
      validationStatus,
      onChange,
      size: size2,
      space: space6 = "s"
    } = _b, spacerProps = __objRest(_b, [
      "children",
      "defaultValue",
      "value",
      "readOnly",
      "disabled",
      "validationStatus",
      "onChange",
      "size",
      "space"
    ]);
    const formContext = useFormContext();
    const formItemContext = useFormItemContext();
    const [checked = defaultValue, setChecked] = useControllableState({
      prop: checkedProp,
      defaultProp: defaultValue,
      onChange
    });
    const radioSize = size2 || (formContext == null ? void 0 : formContext.size) || "regular";
    const inputStatus = validationStatus || (formItemContext == null ? void 0 : formItemContext.validationStatus);
    const handleOnChange = useCallback(
      (event) => {
        setChecked(event.target.value);
      },
      [setChecked]
    );
    return /* @__PURE__ */ React122__default.createElement(
      RadioGroupContext.Provider,
      {
        value: {
          checkedValue: checked,
          onChange: handleOnChange,
          size: radioSize,
          readOnly,
          disabled,
          validationStatus: inputStatus
        }
      },
      /* @__PURE__ */ React122__default.createElement(Spacer, __spreadValues({ ref, space: space6, "data-test": "radio-group" }, spacerProps), children)
    );
  }
);
RadioGroup.displayName = "RadioGroup";
var SliderRange = styled54.input`
  appearance: none;
  width: 100%;
  height: 4px;
  background-color: graphic-default;
  border-radius: 16px;
  outline: none;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 24px;
    height: 24px;
    background-color: graphic-primary;
    border: 4px solid ${th.color("neutral-0")};
    box-shadow: ${th.shadow(1)};
    border-radius: 50%;
    cursor: pointer;
  }
`;
var Slider = forwardRef(
  ({ id, min, max, value, onChange, defaultValue }, ref) => /* @__PURE__ */ React122__default.createElement(
    SliderRange,
    {
      ref,
      type: "range",
      min,
      max,
      value,
      defaultValue,
      id,
      onChange: (e) => onChange(e.target.value, e)
    }
  )
);
var invariant = function(condition, errMsg) {
  if (errMsg === void 0) {
    throw new Error("Invariant requires an error message argument.");
  }
  if (!condition) {
    const finalErrorMessage = errMsg === void 0 ? "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings." : `Invariant Violation: ${errMsg}`;
    throw new Error(finalErrorMessage);
  }
};
var TabContext = createContext({
  activeTabId: void 0,
  onTabClick: noop
});

// src/components/Tab/components/TabContainer.tsx
var TabContainer = memo(
  forwardRef(
    (_a, ref) => {
      var _b = _a, { defaultActiveTabId, activeTabId, onChange, children } = _b, styleProps = __objRest(_b, ["defaultActiveTabId", "activeTabId", "onChange", "children"]);
      const controlled = typeof activeTabId !== "undefined";
      const uncontrolled = typeof defaultActiveTabId !== "undefined";
      invariant(
        !(controlled && uncontrolled),
        "Tab component can be either controlled or uncontrolled at a time: use either 'defaultActiveTabId' or 'activeTabId'."
      );
      const [internalActiveTabId, setInternalActiveTabId] = useState(defaultActiveTabId);
      const handleTabClick = useCallback(
        (clickedTab) => {
          setInternalActiveTabId(clickedTab);
          onChange == null ? void 0 : onChange(clickedTab);
        },
        [setInternalActiveTabId, onChange]
      );
      return /* @__PURE__ */ React122__default.createElement(
        TabContext.Provider,
        {
          value: { activeTabId: activeTabId != null ? activeTabId : internalActiveTabId, onTabClick: handleTabClick }
        },
        /* @__PURE__ */ React122__default.createElement(
          Flex_default,
          __spreadValues({
            ref,
            h: "100%",
            alignItems: "stretch",
            flexDirection: "column",
            "data-test": "tab-container"
          }, styleProps),
          children
        )
      );
    }
  )
);
TabContainer.displayName = "Tab.Container";
var animationVariants2 = {
  entry: {
    opacity: 1,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.25
    }
  }
};
var TabItem = memo(
  forwardRef((_a, ref) => {
    var _b = _a, { id, children } = _b, styleProps = __objRest(_b, ["id", "children"]);
    const { activeTabId } = useContext(TabContext);
    const isActive = activeTabId === id;
    return /* @__PURE__ */ React122__default.createElement(AnimatePresence, null, isActive && /* @__PURE__ */ React122__default.createElement(
      MotionBox,
      __spreadValues({
        position: "absolute",
        "z-index": 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        overflow: "auto",
        padding: "l",
        bg: "neutral-100",
        ref,
        variants: animationVariants2,
        initial: "exit",
        animate: "entry",
        exit: "exit",
        "data-test": `tab-item-${id}`
      }, styleProps),
      children
    ));
  })
);
TabItem.displayName = "Tab.Item";

// src/components/Tab/components/TabContent.tsx
var TabContentWrapper = styled54.div`
  position: relative;
  width: 100%;
  height: 100%;
  flex-shrink: 1;
`;
var TabContent = memo(
  forwardRef((_a, ref) => {
    var _b = _a, { children } = _b, styleProps = __objRest(_b, ["children"]);
    useChildrenValidation(children, "TabContent", TabItem);
    return /* @__PURE__ */ React122__default.createElement(TabContentWrapper, __spreadProps(__spreadValues({}, styleProps), { "data-test": "tab-content", ref }), children);
  })
);
TabContent.displayName = "TabContent";
var TabMenuItemWrapper = styled54(Flex_default).attrs({
  py: "s"
})`
  position: relative;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  ${() => css`
      ${th("typography.bodyMediumM")}
    `};
  transition: font-weight 0.25s ease;
  color: text-base;
  ${({ isActive }) => !isActive && css`
      &:hover {
        &::after {
          opacity: 1;
          background-color: ${getColor$1("graphic-interactive-default-hover")};
        }
      }
    `}

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    opacity: ${({ isActive }) => isActive ? 1 : 0};
    transition: opacity 0.25s ease;
    border-radius: 2px;
    ${({ activeTabColor }) => activeTabColor && css`
        background-color: ${activeTabColor};
      `};
  }
`;
var TabMenuItem = memo(
  forwardRef(
    (_a, ref) => {
      var _b = _a, { children, activeTabColor = "graphic-interactive-default-active", id } = _b, styleProps = __objRest(_b, ["children", "activeTabColor", "id"]);
      const { activeTabId, onTabClick } = useContext(TabContext);
      const isActive = activeTabId === id;
      const handleClick = useCallback(() => {
        onTabClick(id);
      }, [onTabClick, id]);
      return /* @__PURE__ */ React122__default.createElement(
        TabMenuItemWrapper,
        __spreadValues({
          ref,
          isActive,
          onClick: handleClick,
          activeTabColor: isActive ? activeTabColor : void 0,
          "data-test": `tab-menu-item-${id}`
        }, styleProps),
        children
      );
    }
  )
);
TabMenuItem.displayName = "TabMenuItem";

// src/components/Tab/components/TabMenu.tsx
var TabMenu = memo(
  forwardRef(
    (_a, ref) => {
      var _b = _a, { children, variant: variant2 = "auto", space: space6 = "s" } = _b, styleProps = __objRest(_b, ["children", "variant", "space"]);
      useChildrenValidation(children, "TabMenu", TabMenuItem);
      return /* @__PURE__ */ React122__default.createElement(Box_default, __spreadValues({ ref }, styleProps), /* @__PURE__ */ React122__default.createElement(Spacer, { space: space6, fluid: true, itemsSized: variant2, "data-test": "tab-menu" }, children));
    }
  )
);
TabMenu.displayName = "TabMenu";
var useElementEdgeInView = (elementEdge, element, scrollableContainer) => {
  const isElementInView = useCallback(() => {
    const containerPosition = element == null ? void 0 : element.getBoundingClientRect();
    const scrollableContainerPosition = scrollableContainer == null ? void 0 : scrollableContainer.getBoundingClientRect();
    if (!containerPosition) {
      return false;
    }
    switch (elementEdge) {
      case "bottom" /* Bottom */:
        return containerPosition.bottom >= 0 && containerPosition.bottom <= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.bottom) || window.innerHeight || document.documentElement.clientHeight) && containerPosition.bottom >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.top) || 0);
      case "top" /* Top */:
        return containerPosition.top >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.top) || 0);
      case "left" /* Left */:
        return containerPosition.left >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.left) || 0);
      case "right" /* Right */:
        return containerPosition.right >= 0 && containerPosition.right <= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.width) || window.innerWidth || document.documentElement.clientWidth) && containerPosition.right >= ((scrollableContainerPosition == null ? void 0 : scrollableContainerPosition.right) || 0);
      default:
        return true;
    }
  }, [element, elementEdge, scrollableContainer]);
  const [elementInView, setElementInView] = useState();
  useLayoutEffect(() => {
    setElementInView(isElementInView());
    const handleScrollPositionChange = () => {
      setElementInView(isElementInView());
    };
    window.addEventListener("resize", handleScrollPositionChange);
    scrollableContainer == null ? void 0 : scrollableContainer.addEventListener("scroll", handleScrollPositionChange);
    return () => {
      window.removeEventListener("resize", handleScrollPositionChange);
      scrollableContainer == null ? void 0 : scrollableContainer.removeEventListener("scroll", handleScrollPositionChange);
    };
  }, [element, scrollableContainer, isElementInView]);
  return elementInView;
};
var useElementPosition = (element) => {
  const getElementPosition = useCallback(() => {
    const pos = (element == null ? void 0 : element.getBoundingClientRect()) || { width: 0, left: 0 };
    return {
      width: pos.width,
      left: pos.left
    };
  }, [element]);
  const [position, setPosition] = useState(getElementPosition());
  const handleWindowResize = useCallback(() => {
    setPosition(getElementPosition());
  }, [setPosition, getElementPosition]);
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);
  useEffect(() => {
    setPosition(getElementPosition());
  }, [element, setPosition, getElementPosition]);
  return position;
};
var StyledActionBarContainer = styled54(Flex_default).withConfig({
  shouldForwardProp: (prop, defaultShouldForwardProp) => defaultShouldForwardProp(prop)
})`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: background-02;
  z-index: 2;
  position: sticky;
  left: 0;
  width: 100%;
  height: 64px;
  padding: 3 4;
  box-sizing: border-box;

  ${({ elementBottomEdgeInView, left, width }) => !elementBottomEdgeInView && css`
      position: fixed;
      border-right: 1px solid;
      border-right-color: border-base;
      border-left: 1px solid;
      border-left-color: border-base;
      bottom: 0;
      left: ${left}px;
      width: ${width}px;
      box-shadow: 3;
    `}
`;

// src/components/Table/components/ActionBar/ActionBar.tsx
var ActionBar = ({
  nonVerticallyScrollingParent,
  actions,
  selectedRows,
  verticalScrollingParent,
  cancelBtnText = "Cancel",
  selectedItemsText = "selected items",
  onCancel,
  onStickyChange
}) => {
  const elementBottomEdgeInView = useElementEdgeInView(
    "bottom" /* Bottom */,
    nonVerticallyScrollingParent.current,
    verticalScrollingParent.current
  );
  const { left, width } = useElementPosition(nonVerticallyScrollingParent.current);
  const styleProps = __spreadValues({}, elementBottomEdgeInView === false ? {
    left,
    width
  } : {});
  const renderSecondActionIfNeeded = useCallback(() => {
    if (actions && Array.isArray(actions) && actions.length === 2) {
      const secondAction = actions[1];
      const ActionRenderer = secondAction.renderer;
      return ActionRenderer ? /* @__PURE__ */ React122__default.createElement(ActionRenderer, { rowsData: selectedRows }) : /* @__PURE__ */ React122__default.createElement(
        Button,
        {
          size: "small",
          mode: "outline",
          onClick: (event) => secondAction.onExecute(selectedRows, event)
        },
        secondAction.label
      );
    }
    return null;
  }, [actions, selectedRows]);
  const renderFirstActionIfNeeded = useCallback(() => {
    if (actions && Array.isArray(actions) && actions.length <= 2) {
      const firstAction = actions[0];
      const ActionRenderer = firstAction.renderer;
      return ActionRenderer ? /* @__PURE__ */ React122__default.createElement(ActionRenderer, { rowsData: selectedRows }) : /* @__PURE__ */ React122__default.createElement(
        Button,
        {
          mode: "fill",
          size: "small",
          onClick: (event) => firstAction.onExecute(selectedRows, event)
        },
        firstAction.label
      );
    }
    return null;
  }, [actions, selectedRows]);
  const renderMultipleActionsIfNeeded = useCallback(
    () => actions && (Array.isArray(actions) && actions.length > 2 || typeof actions === "function") && /* @__PURE__ */ React122__default.createElement(Box_default, { marginLeft: "s" }, typeof actions === "function" ? actions(selectedRows) : /* @__PURE__ */ React122__default.createElement(Dropdown, { trigger: /* @__PURE__ */ React122__default.createElement(DropdownButton, null, "Actions"), align: "end" }, /* @__PURE__ */ React122__default.createElement(Menu, { selectionMode: "none" }, actions.map((action) => {
      const ActionRenderer = action.renderer;
      return ActionRenderer ? /* @__PURE__ */ React122__default.createElement(ActionRenderer, { key: action.label, rowsData: selectedRows }) : /* @__PURE__ */ React122__default.createElement(
        MenuItem,
        {
          key: action.label,
          onClick: (event) => action.onExecute(selectedRows, event)
        },
        action.label
      );
    })))),
    [actions, selectedRows]
  );
  useEffect(() => {
    onStickyChange == null ? void 0 : onStickyChange(!!elementBottomEdgeInView);
  }, [elementBottomEdgeInView, onStickyChange]);
  return /* @__PURE__ */ React122__default.createElement(StyledActionBarContainer, __spreadValues({ elementBottomEdgeInView: !!elementBottomEdgeInView }, styleProps), /* @__PURE__ */ React122__default.createElement(Flex_default, { alignItems: "center" }, /* @__PURE__ */ React122__default.createElement(CounterBadge, { count: Object.keys(selectedRows).length, size: "large", bg: "primary-500" }), /* @__PURE__ */ React122__default.createElement(Typography_default, { ml: 2, color: "black" }, selectedItemsText)), /* @__PURE__ */ React122__default.createElement(Spacer, { space: "s", alignItems: "center" }, /* @__PURE__ */ React122__default.createElement(Button, { size: "small", variant: "secondary", mode: "link", onClick: onCancel }, cancelBtnText), /* @__PURE__ */ React122__default.createElement(Spacer, { space: "s", alignItems: "center" }, renderSecondActionIfNeeded(), renderFirstActionIfNeeded(), renderMultipleActionsIfNeeded())));
};

// src/components/Table/Table.decl.ts
var StickTo = /* @__PURE__ */ ((StickTo2) => {
  StickTo2["Left"] = "left";
  StickTo2["Right"] = "right";
  return StickTo2;
})(StickTo || {});
var RowActionType = /* @__PURE__ */ ((RowActionType2) => {
  RowActionType2["Inline"] = "Inline";
  RowActionType2["Dropdown"] = "Dropdown";
  return RowActionType2;
})(RowActionType || {});
var ColumnTextAlign = /* @__PURE__ */ ((ColumnTextAlign2) => {
  ColumnTextAlign2["Left"] = "left";
  ColumnTextAlign2["Center"] = "center";
  ColumnTextAlign2["Right"] = "right";
  return ColumnTextAlign2;
})(ColumnTextAlign || {});
var useHorizontalScrollAtEnd = (stickTo, scrollableContainer, contentLoading) => {
  const isHorizontalScrollAtEnd = useCallback(() => {
    if (scrollableContainer) {
      if (stickTo === "left" /* Left */) {
        return scrollableContainer.scrollLeft === 0;
      } else {
        return scrollableContainer.scrollLeft + scrollableContainer.offsetWidth >= scrollableContainer.scrollWidth;
      }
    }
    return void 0;
  }, [stickTo, scrollableContainer]);
  const [scrollAtEnd, setScrollAtEnd] = useState(true);
  useEffect(() => {
    setScrollAtEnd(isHorizontalScrollAtEnd());
    const handleScrollPositionChange = () => {
      setScrollAtEnd(isHorizontalScrollAtEnd());
    };
    window.addEventListener("resize", handleScrollPositionChange);
    scrollableContainer == null ? void 0 : scrollableContainer.addEventListener("scroll", handleScrollPositionChange);
    return () => {
      window.removeEventListener("resize", handleScrollPositionChange);
      scrollableContainer == null ? void 0 : scrollableContainer.removeEventListener("scroll", handleScrollPositionChange);
    };
  }, [stickTo, scrollableContainer, contentLoading, isHorizontalScrollAtEnd]);
  return scrollAtEnd;
};
function useSelectionHelper(selectMode, rowsData, recordAttributeIdentifier, onSelectionChange) {
  const [selectedRows, setSelectedRows] = useState({});
  const selectedCount = Object.keys(selectedRows).length;
  const columnSelected = rowsData.length && rowsData.every((node) => !!selectedRows[node[recordAttributeIdentifier]]);
  const clearSelection = useCallback(() => {
    setSelectedRows({});
  }, [setSelectedRows]);
  const toggleRecord = useCallback(
    (record, rowSelected) => {
      setSelectedRows((oldSelectedRows) => {
        var _a;
        if (rowSelected) {
          return __spreadProps(__spreadValues({}, oldSelectedRows), { [record[recordAttributeIdentifier]]: record });
        } else {
          const _b = oldSelectedRows, { [_a = record[recordAttributeIdentifier]]: recordToDelete } = _b, newSelectedRows = __objRest(_b, [__restKey(_a)]);
          return newSelectedRows;
        }
      });
    },
    [recordAttributeIdentifier]
  );
  const toggleAllRecordsFromCurrentPage = useCallback(
    (checked) => {
      setSelectedRows((oldSelectedRows) => {
        const newSelectedRows = __spreadValues({}, oldSelectedRows);
        rowsData.forEach((node) => {
          if (checked) {
            newSelectedRows[node[recordAttributeIdentifier]] = node;
          } else {
            delete newSelectedRows[node[recordAttributeIdentifier]];
          }
        });
        return newSelectedRows;
      });
    },
    [recordAttributeIdentifier, rowsData]
  );
  useEffect(() => {
    selectMode && clearSelection();
  }, [selectMode, clearSelection]);
  useEffect(
    () => onSelectionChange == null ? void 0 : onSelectionChange(Object.values(selectedRows), selectedCount),
    [onSelectionChange, selectedRows, selectedCount, rowsData]
  );
  return {
    selectedRows,
    columnSelected,
    selectedCount,
    toggleRecord,
    toggleAllRecordsFromCurrentPage,
    clearSelection
  };
}
var TableRootContext = createContext({
  horizontallyScrollableContainerRef: void 0,
  loading: false,
  recordAttributeIdentifier: "id",
  scrollAtEnd: {
    ["left" /* Left */]: void 0,
    ["right" /* Right */]: void 0
  }
});
var TableWrapper = styled54(Box_default)`
  width: 100%;
  overflow-x: auto;
  border: 1px solid;
  border-color: graphic-default;
  border-radius: sm;
  background-color: surface-interactive-default;
`;

// src/components/Table/components/TableRoot/TableRoot.tsx
var TableRoot = (_a) => {
  var _b = _a, {
    loading,
    recordAttributeIdentifier = "id",
    children
  } = _b, styleProps = __objRest(_b, [
    "loading",
    "recordAttributeIdentifier",
    "children"
  ]);
  const tableWrapperRef = useRef();
  const isScrollAtLeftEnd = useHorizontalScrollAtEnd("left" /* Left */, tableWrapperRef == null ? void 0 : tableWrapperRef.current);
  const isScrollAtRightEnd = useHorizontalScrollAtEnd("right" /* Right */, tableWrapperRef == null ? void 0 : tableWrapperRef.current);
  return /* @__PURE__ */ React122__default.createElement(TableWrapper, __spreadValues({ ref: tableWrapperRef }, styleProps), /* @__PURE__ */ React122__default.createElement(
    TableRootContext.Provider,
    {
      value: {
        horizontallyScrollableContainerRef: tableWrapperRef,
        loading,
        recordAttributeIdentifier,
        scrollAtEnd: {
          ["left" /* Left */]: isScrollAtLeftEnd,
          ["right" /* Right */]: isScrollAtRightEnd
        }
      }
    },
    children
  ));
};
var NoDataMessage = ({ message }) => /* @__PURE__ */ React122.createElement(Box_default, { as: "tr", position: "relative" }, /* @__PURE__ */ React122.createElement("td", null, /* @__PURE__ */ React122.createElement(Box_default, { pt: "m", position: "absolute", left: "0", right: "0" }, ["string", "undefined"].indexOf(typeof message) >= 0 ? /* @__PURE__ */ React122.createElement(Typography_default, { textAlign: "center", variant: "bodyMediumS", color: "text-base" }, message || "No records available for this category or filter criteria") : message)));
var IconButtonContainer2 = styled54(Flex_default).attrs({
  justifyContent: "center",
  alignItems: "center"
})`
  box-sizing: border-box;
  cursor: pointer;
  height: 40px;
  width: 40px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
  }
`;
var InlineAction = ({
  action,
  rowData
}) => {
  const ActionRenderer = action.renderer;
  return ActionRenderer || action.icon ? /* @__PURE__ */ React122__default.createElement(IconButtonContainer2, { onClick: (event) => action.onExecute(rowData, event), title: action.label }, ActionRenderer ? /* @__PURE__ */ React122__default.createElement(ActionRenderer, { rowData }) : /* @__PURE__ */ React122__default.createElement(IconButton_default, { component: action.icon, size: 16, discColor: "input-background-02" })) : /* @__PURE__ */ React122__default.createElement(Button, { mode: "link", size: "small", onClick: (event) => action.onExecute(rowData, event) }, action.label);
};

// src/components/Table/components/InlineActions/InlineActionsList.tsx
var InlineActionsList = ({
  actions,
  rowData
}) => {
  return /* @__PURE__ */ React122__default.createElement(Flex_default, null, actions.map((action, index) => /* @__PURE__ */ React122__default.createElement(InlineAction, { action, key: index, rowData })));
};

// src/components/Table/components/InlineActions/InlineActions.tsx
var InlineActions = ({
  data,
  actionsType,
  actions
}) => {
  if (actionsType === "Dropdown" /* Dropdown */) {
    return /* @__PURE__ */ React122.createElement(React122.Fragment, null, /* @__PURE__ */ React122.createElement(
      Dropdown,
      {
        onVisibilityChange: (flyoutVisibility) => {
          if (flyoutVisibility) {
            if (typeof actions === "function") {
              actions(data);
            }
          }
        },
        trigger: /* @__PURE__ */ React122.createElement(
          Button,
          {
            mode: "ghost",
            variant: "secondary",
            size: "xSmall",
            shape: "circle",
            "data-test": "table-action-dropdown-button"
          },
          /* @__PURE__ */ React122.createElement(MenuVerticalFilled, null)
        ),
        align: "end"
      },
      typeof actions === "function" ? actions(data) : /* @__PURE__ */ React122.createElement(Menu, { selectionMode: "none" }, actions.map((action, index) => {
        const ActionRenderer = action.renderer;
        return ActionRenderer ? /* @__PURE__ */ React122.createElement(ActionRenderer, { key: index, rowData: data }) : /* @__PURE__ */ React122.createElement(MenuItem, { key: action.label, onClick: (event) => action.onExecute(data, event) }, action.label);
      }))
    ));
  } else if (typeof actions === "function") {
    return actions(data);
  }
  return /* @__PURE__ */ React122.createElement(InlineActionsList, { actions, rowData: data });
};
var computeStickyStyle = ({ selected, stickTo, scrolledToEdge }) => {
  if (!stickTo) {
    return;
  }
  return css(__spreadValues(__spreadValues({
    position: "sticky",
    zIndex: 0,
    backgroundColor: selected ? (
      /* FIXME */
      "primary-100"
    ) : "surface-interactive-default"
  }, stickTo === "left" /* Left */ ? { left: 0 } : { right: 0 }), scrolledToEdge === false ? stickTo === "left" /* Left */ ? { borderRight: "1px solid", borderRightColor: "graphic-default" } : { borderLeft: "1px solid", borderLeftColor: "graphic-default" } : void 0));
};
var StyledTableData = styled54(Box_default).withConfig({
  shouldForwardProp: (prop, defaultShouldForwardProp) => defaultShouldForwardProp(prop)
}).attrs({ as: "td" })`
    display: table-cell;
    padding: 0 4;
    height: 40px;
    border-bottom: 1px solid;
    border-bottom-color: graphic-default;
    white-space: nowrap;
    ${computeStickyStyle}

    label {
      margin-bottom: 0;
    }
  `;

// src/components/Table/components/TableData/TableData.tsx
var TableData = (_a) => {
  var _b = _a, {
    children,
    stickTo,
    textAlign = "left" /* Left */
  } = _b, otherProps = __objRest(_b, [
    "children",
    "stickTo",
    "textAlign"
  ]);
  const { scrollAtEnd } = React122.useContext(TableRootContext);
  const stylingProps = __spreadValues({}, stickTo ? { stickTo, scrolledToEdge: scrollAtEnd[stickTo] } : {});
  return /* @__PURE__ */ React122.createElement(StyledTableData, __spreadValues(__spreadValues({}, stylingProps), otherProps), /* @__PURE__ */ React122.createElement(Flex_default, { justifyContent: textAlign }, children));
};
var TextCell = (_a) => {
  var _b = _a, {
    children,
    textAlign = "left",
    disabled = false
  } = _b, otherProps = __objRest(_b, [
    "children",
    "textAlign",
    "disabled"
  ]);
  return /* @__PURE__ */ React122__default.createElement(
    Typography_default,
    __spreadProps(__spreadValues({
      variant: "bodyMediumS",
      textAlign
    }, otherProps), {
      color: disabled ? "text-disabled" : "text-base"
    }),
    children
  );
};
var TableRow = styled54(Box_default).withConfig({
  shouldForwardProp: (prop, defaultShouldForwardProp) => defaultShouldForwardProp(prop)
}).attrs({ as: "tr" })(
  ({ disabled, clickable }) => css`
    display: table-row;
    ${computeRowBackground}
    ${disabled && css`
      pointer-events: none;
      color: text-disabled;
      cursor: default;
    `}
    ${clickable && css`
      cursor: pointer;
    `}
  `
);
var computeRowBackground = ({ selected }) => {
  if (selected) {
    return css`
      /* FIXME */
      background-color: primary-100;
    `;
  }
  return css`
    background-color: surface-interactive-default;
    &:hover,
    &:hover td {
      background-color: surface-interactive-default-hover;
    }
  `;
};
var ActionsTableData = styled54(TableData)`
  padding: 0 1;
  width: 40px;
`;

// src/components/Table/components/Row/Row.tsx
var Row = ({
  data,
  columns,
  actions,
  actionsType,
  disabled,
  selectable,
  selectDisabled,
  selected = false,
  onSelectChange,
  onClick
}) => {
  const { loading, recordAttributeIdentifier } = useContext(TableRootContext);
  const hasActions = typeof actions === "function" || !!(actions && actions.length);
  const renderCell = useCallback(
    (col, data2, index) => {
      const value = get(data2, col.id);
      if (col.renderer) {
        return col.renderer(data2, value, index);
      }
      return /* @__PURE__ */ React122__default.createElement(TextCell, { disabled }, value);
    },
    [disabled]
  );
  const handleRowClick = useCallback(
    (event) => {
      var _a;
      const currentSelection = (_a = window.getSelection()) == null ? void 0 : _a.toString();
      if (!currentSelection) {
        onClick == null ? void 0 : onClick(data, event);
      }
    },
    [onClick, data]
  );
  const preventRowClick = useCallback((evt) => {
    evt.stopPropagation();
  }, []);
  return /* @__PURE__ */ React122__default.createElement(
    TableRow,
    {
      key: data[recordAttributeIdentifier],
      selected,
      disabled,
      clickable: !!onClick,
      onClick: handleRowClick
    },
    selectable && /* @__PURE__ */ React122__default.createElement(TableData, { stickTo: "left" /* Left */, selected, w: "48px", onClick: preventRowClick }, /* @__PURE__ */ React122__default.createElement(
      Checkbox,
      {
        checked: selected,
        disabled: selectDisabled || disabled,
        onChange: (checked) => onSelectChange(data, checked),
        size: "small"
      }
    )),
    columns.map((column, index) => /* @__PURE__ */ React122__default.createElement(TableData, { key: column.id, selected, textAlign: column.textAlign }, loading ? /* @__PURE__ */ React122__default.createElement(Box_default, { flex: 1 }, /* @__PURE__ */ React122__default.createElement(Skeleton, null)) : renderCell(column, data, index))),
    hasActions && /* @__PURE__ */ React122__default.createElement(ActionsTableData, { stickTo: "right" /* Right */, selected, onClick: preventRowClick }, loading ? /* @__PURE__ */ React122__default.createElement(Skeleton, null) : /* @__PURE__ */ React122__default.createElement(InlineActions, { data, actions, actionsType }))
  );
};
var MemoizedRow = React122__default.memo(Row);
var computeStickyStyle2 = ({ stickTo, scrolledToEdge }) => {
  if (!stickTo) {
    return;
  }
  return css(__spreadValues(__spreadValues({
    position: "sticky",
    zIndex: 0
  }, stickTo === "left" /* Left */ ? { left: 0 } : { right: 0 }), scrolledToEdge === false ? stickTo === "left" /* Left */ ? { borderRight: "1px solid", borderRightColor: "graphic-default" } : { borderLeft: "1px solid", borderLeftColor: "graphic-default" } : void 0));
};
var StyledHeader = styled54.th`
  display: table-cell;
  padding: 0 4;
  height: 40px;
  text-align: left;
  border-bottom: 1px solid;
  background-color: surface-interactive-default;
  border-bottom-color: graphic-default;
  white-space: nowrap;
  ${computeStickyStyle2}
`;

// src/components/Table/components/TableHeader/TableHeader.tsx
var TableHeader = (_a) => {
  var _b = _a, {
    children,
    stickTo,
    textAlign = "left" /* Left */
  } = _b, restProps = __objRest(_b, [
    "children",
    "stickTo",
    "textAlign"
  ]);
  const { scrollAtEnd } = React122.useContext(TableRootContext);
  const stylingProps = __spreadValues({}, stickTo ? { stickTo, scrolledToEdge: scrollAtEnd[stickTo] } : {});
  return /* @__PURE__ */ React122.createElement(StyledHeader, __spreadValues(__spreadValues({}, stylingProps), restProps), /* @__PURE__ */ React122.createElement(Flex_default, { justifyContent: textAlign }, children));
};

// src/components/Table/constants.ts
var OrderDirection = /* @__PURE__ */ ((OrderDirection2) => {
  OrderDirection2["Asc"] = "ASC";
  OrderDirection2["Desc"] = "DESC";
  return OrderDirection2;
})(OrderDirection || {});
var DEFAULT_PAGE_SIZE = 50;

// src/components/Table/components/TableHeaders/OrderArrow.tsx
var OrderArrow = ({ orderDirection, active = false }) => {
  return /* @__PURE__ */ React122.createElement(
    Icon_default,
    {
      ml: "xxxs",
      component: orderDirection === "DESC" /* Desc */ || !active ? ArrowDownFilled : ArrowUpFilled,
      size: 14,
      color: active ? "icon-interactive-default-active" : "graphic-interactive-default"
    }
  );
};
var ActionsHeader = styled54(TableHeader)(
  ({ theme: { space: space6 } }) => css`
    padding: 0 ${space6.xxs}px;
  `
);

// src/components/Table/components/TableHeaders/TableHeaders.tsx
var TableHeaders = ({
  selectable,
  hasActions,
  selectColumnDisabled,
  selectColumnChecked,
  columns,
  order: order2,
  onSelectionChange,
  onOrderChange
}) => /* @__PURE__ */ React122__default.createElement(
  Box_default,
  {
    as: "thead",
    display: "table-header-group",
    top: 0,
    zIndex: 1,
    position: "sticky",
    backgroundColor: "surface-interactive-default"
  },
  /* @__PURE__ */ React122__default.createElement(TableRow, null, selectable && /* @__PURE__ */ React122__default.createElement(TableHeader, { stickTo: "left" /* Left */ }, /* @__PURE__ */ React122__default.createElement(
    Checkbox,
    {
      checked: !!selectColumnChecked,
      disabled: selectColumnDisabled,
      onChange: onSelectionChange,
      size: "small"
    }
  )), columns.map((column, index) => {
    const isSortingDisabledExplicitly = column.sortable === false;
    const columnSortable = !!order2 && !!onOrderChange && !isSortingDisabledExplicitly;
    const isSorting = columnSortable && (order2 == null ? void 0 : order2.field) === column.id;
    return /* @__PURE__ */ React122__default.createElement(TableHeader, { key: index, textAlign: column.textAlign }, /* @__PURE__ */ React122__default.createElement(
      Flex_default,
      {
        onClick: () => columnSortable && (onOrderChange == null ? void 0 : onOrderChange(column.id)),
        cursor: columnSortable ? "pointer" : "default",
        alignItems: "center"
      },
      /* @__PURE__ */ React122__default.createElement(
        Typography_default,
        {
          variant: "supportingSemiboldS",
          ellipsis: true,
          color: isSorting ? "text-highlight" : "text-placeholder"
        },
        column.label
      ),
      columnSortable && /* @__PURE__ */ React122__default.createElement(OrderArrow, { active: isSorting, orderDirection: order2 == null ? void 0 : order2.direction })
    ));
  }), hasActions && /* @__PURE__ */ React122__default.createElement(ActionsHeader, { stickTo: "right" /* Right */ }))
);
var MemoizedTableHeaders = React122__default.memo(TableHeaders);
var StyledTable = styled54(Box_default).attrs({ as: "table" })`
  display: table;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  tr:last-of-type > td {
    border-bottom: none;
  }
`;

// src/components/Table/components/Table/TableInner.tsx
var Table2 = ({
  data,
  columns,
  footer,
  disableRow,
  noDataMessage,
  verticalScrollingParent,
  pageSize = 50,
  order: order2,
  rowActions,
  rowActionsType = "Dropdown" /* Dropdown */,
  bulkActions,
  unselectableRowCondition,
  hideActionBar,
  onRowClick,
  onOrderChange,
  onSelectionChange
}, ref) => {
  const { horizontallyScrollableContainerRef, loading, recordAttributeIdentifier } = useContext(TableRootContext);
  const [actionBarPositionSticky, setActionBarPositionSticky] = useState();
  const rowsData = useMemo(
    () => loading ? new Array(pageSize).fill({}) : data,
    [data, loading, pageSize]
  );
  const rowsSelectable = useMemo(() => !!(bulkActions && bulkActions.length), [bulkActions]);
  const {
    selectedRows,
    columnSelected,
    selectedCount,
    toggleRecord,
    toggleAllRecordsFromCurrentPage,
    clearSelection
  } = useSelectionHelper(
    rowsSelectable,
    rowsData,
    recordAttributeIdentifier,
    rowsSelectable ? onSelectionChange : void 0
  );
  useImperativeHandle(ref, () => ({
    clearSelection
  }));
  const handleStickyChange = useCallback((stuck) => {
    setActionBarPositionSticky(stuck);
  }, []);
  const hasActions = typeof rowActions === "function" || !!(rowActions && rowActions.length);
  const tableHasNoData = !loading && rowsData.length === 0;
  const needSpaceForActionBar = selectedCount && !actionBarPositionSticky && !hideActionBar;
  return /* @__PURE__ */ React122__default.createElement(React122__default.Fragment, null, /* @__PURE__ */ React122__default.createElement(StyledTable, { pb: needSpaceForActionBar || tableHasNoData ? 8 : 0 }, /* @__PURE__ */ React122__default.createElement(
    MemoizedTableHeaders,
    {
      onSelectionChange: toggleAllRecordsFromCurrentPage,
      selectColumnDisabled: !!unselectableRowCondition || !!disableRow,
      selectColumnChecked: !!columnSelected,
      columns,
      onOrderChange,
      selectable: rowsSelectable,
      hasActions: hasActions && !selectedCount,
      order: order2
    }
  ), /* @__PURE__ */ React122__default.createElement(Box_default, { as: "tbody", display: "table-row-group" }, rowsData.map((record, index) => {
    var _a;
    return /* @__PURE__ */ React122__default.createElement(
      MemoizedRow,
      {
        key: index,
        data: record,
        columns,
        actions: selectedCount > 0 ? void 0 : rowActions,
        actionsType: rowActionsType,
        disabled: typeof disableRow === "function" ? disableRow(record) : disableRow,
        onClick: onRowClick,
        selectable: rowsSelectable,
        selectDisabled: (_a = unselectableRowCondition == null ? void 0 : unselectableRowCondition(record)) != null ? _a : false,
        onSelectChange: toggleRecord,
        selected: !!selectedRows[record[recordAttributeIdentifier]]
      }
    );
  })), tableHasNoData && /* @__PURE__ */ React122__default.createElement(Box_default, { as: "tfoot", display: "table-footer-group" }, /* @__PURE__ */ React122__default.createElement(NoDataMessage, { message: noDataMessage })), footer), selectedCount > 0 && !hideActionBar && /* @__PURE__ */ React122__default.createElement(
    ActionBar,
    {
      actions: bulkActions,
      nonVerticallyScrollingParent: horizontallyScrollableContainerRef,
      verticalScrollingParent,
      onStickyChange: handleStickyChange,
      onCancel: clearSelection,
      selectedRows: Object.values(selectedRows)
    }
  ));
};
var TableInner = React122__default.forwardRef(Table2);

// src/components/Table/components/Table/Table.tsx
var WrappedTable = (_a, ref) => {
  var _b = _a, {
    data,
    columns,
    loading = false,
    disableRow,
    noDataMessage,
    verticalScrollingParent,
    pageSize = 50,
    recordAttributeIdentifier = "id",
    order: order2,
    rowActions,
    rowActionsType = "Dropdown" /* Dropdown */,
    bulkActions,
    unselectableRowCondition,
    hideActionBar,
    onRowClick,
    onOrderChange,
    onSelectionChange,
    footer
  } = _b, styleProps = __objRest(_b, [
    "data",
    "columns",
    "loading",
    "disableRow",
    "noDataMessage",
    "verticalScrollingParent",
    "pageSize",
    "recordAttributeIdentifier",
    "order",
    "rowActions",
    "rowActionsType",
    "bulkActions",
    "unselectableRowCondition",
    "hideActionBar",
    "onRowClick",
    "onOrderChange",
    "onSelectionChange",
    "footer"
  ]);
  return /* @__PURE__ */ React122__default.createElement(
    TableRoot,
    __spreadValues({
      loading,
      recordAttributeIdentifier
    }, styleProps),
    /* @__PURE__ */ React122__default.createElement(
      TableInner,
      {
        ref,
        data,
        columns,
        disableRow,
        noDataMessage,
        verticalScrollingParent,
        pageSize,
        order: order2,
        rowActions,
        rowActionsType,
        bulkActions,
        unselectableRowCondition,
        hideActionBar,
        onRowClick,
        onOrderChange,
        onSelectionChange,
        footer
      }
    )
  );
};
var Table3 = React122__default.forwardRef(WrappedTable);
var TagContext = createContext(null);
var useTagContext = () => {
  return useContext(TagContext);
};

// src/components/Tag/components/TagLabel.tsx
var TagLabel = (_a) => {
  var _b = _a, { children, color: color4 } = _b, typographyProps = __objRest(_b, ["children", "color"]);
  const { size: size2 } = useTagContext();
  return /* @__PURE__ */ React122__default.createElement(
    Typography_default,
    __spreadProps(__spreadValues({
      as: "span",
      ellipsis: true,
      color: color4
    }, typographyProps), {
      variant: size2 === "xSmall" || size2 === "small" ? "supportingMediumS" : "bodyMediumS"
    }),
    children
  );
};

// src/components/Tag/constants.ts
var TAG_SIZES_MAP2 = {
  xSmall: "16px",
  small: "24px",
  regular: "26px",
  large: "34px"
};
var TAG_ICON_SIZES_MAP2 = {
  xSmall: "12px",
  small: "12px",
  regular: "16px",
  large: "16px"
};
var TAG_VARIANT_COLORS_MAP = {
  blue: {
    color: "informative-700",
    backgroundColor: "informative-100"
  },
  darkBlue: {
    color: "text-contrast-light",
    backgroundColor: "informative-700"
  },
  red: {
    color: "critical-700",
    backgroundColor: "critical-100"
  },
  darkRed: {
    color: "text-contrast-light",
    backgroundColor: "critical-700"
  },
  yellow: {
    color: "warning-800",
    backgroundColor: "warning-100"
  },
  darkYellow: {
    color: "text-contrast-light",
    backgroundColor: "warning-700"
  },
  grey: {
    color: "text-secondary",
    backgroundColor: "neutral-200"
  },
  darkGrey: {
    color: "text-contrast-light",
    backgroundColor: "neutral-500"
  },
  white: {
    color: "neutral-400",
    backgroundColor: "neutral-0"
  },
  secondary: {
    color: "text-contrast-light",
    backgroundColor: "secondary-500"
  },
  darkSecondary: {
    color: "text-contrast-light",
    backgroundColor: "secondary-700"
  },
  lightSecondary: {
    color: "secondary-700",
    backgroundColor: "secondary-100"
  },
  primary: {
    color: "text-contrast-light",
    backgroundColor: "primary-500"
  },
  darkPrimary: {
    color: "text-contrast-light",
    backgroundColor: "primary-700"
  },
  lightPrimary: {
    color: "primary-700",
    backgroundColor: "primary-100"
  },
  purple: {
    color: "decorative1-700",
    backgroundColor: "decorative1-100"
  },
  darkPurple: {
    color: "text-contrast-light",
    backgroundColor: "decorative1-700"
  },
  green: {
    color: "success-500",
    backgroundColor: "success-100"
  },
  darkGreen: {
    color: "text-contrast-light",
    backgroundColor: "success-700"
  }
};

// src/components/Tag/utils.ts
var makeTagVariant = ({
  theme,
  tagBg,
  tagColor,
  tagVariant
}) => {
  if (tagBg) {
    const bgColor = getColor$1(tagBg)({ theme });
    return css({
      backgroundColor: tagBg,
      color: tagColor || textColor(bgColor, "text-contrast-light", "text-contrast-dark")
    });
  }
  return css(tagVariant && TAG_VARIANT_COLORS_MAP[tagVariant] || TAG_VARIANT_COLORS_MAP.white);
};
var makeTagMode = ({ tagVariant, tagMode }) => {
  if (tagMode === "outline")
    return css`
      border: 1px solid ${getColor$1(TAG_VARIANT_COLORS_MAP[tagVariant].color)};
      background: transparent;
    `;
  return css``;
};
var makeTagSize = ({ tagSize }) => {
  const height = TAG_SIZES_MAP2[tagSize] || TAG_SIZES_MAP2.regular;
  return css({
    height
  });
};
var shouldForwardProp6 = (prop) => !["tagSize", "tagBg", "tagColor", "tagVariant"].includes(prop);

// src/components/Tag/Tag.tsx
var Container2 = styled54(Flex_default).withConfig({ shouldForwardProp: shouldForwardProp6 })`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2;
  min-width: 32px;
  max-width: 100%;
  border-radius: full;
  padding-left: 2;
  padding-right: 2;
  ${makeTagVariant}
  ${makeTagSize}
  ${makeTagMode}
`;
var Tag = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      size: size2 = "regular",
      onClick,
      variant: variant2,
      color: color4,
      bg,
      maxW,
      maxWidth,
      mode = "fill"
    } = _b, remainingStyleProps = __objRest(_b, [
      "children",
      "size",
      "onClick",
      "variant",
      "color",
      "bg",
      "maxW",
      "maxWidth",
      "mode"
    ]);
    const childNode = typeof children === "string" ? /* @__PURE__ */ React122__default.createElement(TagLabel, __spreadValues({}, { maxW, maxWidth }), children) : children;
    return /* @__PURE__ */ React122__default.createElement(TagContext.Provider, { value: { size: size2 } }, /* @__PURE__ */ React122__default.createElement(
      Container2,
      __spreadValues({
        "data-test": "tag",
        ref,
        onClick,
        cursor: onClick ? "pointer" : "default",
        tagSize: size2,
        tagVariant: variant2,
        tagColor: color4,
        tagBg: bg,
        tagMode: mode
      }, remainingStyleProps),
      childNode
    ));
  }
);
Tag.displayName = "Tag";
var TagDeleteIcon = ({
  icon = CloseOutlined,
  onClick,
  color: color4,
  "data-test": dataTest
}) => {
  const { size: size2 } = useTagContext();
  const height = TAG_ICON_SIZES_MAP2[size2] || TAG_ICON_SIZES_MAP2.regular;
  return /* @__PURE__ */ React122__default.createElement(Box_default, { "data-test": dataTest, cursor: onClick ? "pointer" : "default", onClick }, /* @__PURE__ */ React122__default.createElement(Icon_default, { component: icon, "area-role": "button", size: height, color: color4 }));
};
var TextareaComponent = styled54.textarea`
  ${makeDefaultField}
  min-height: 108px;
  padding-top: s;
  padding-bottom: s;
  resize: ${({ resizable }) => resizable ? "vertical" : "none"};
`;
var clearIconStyle = css`
  top: 16px;
  right: 16px;
  transform: none;
`;
var Textarea = forwardRef((props, ref) => {
  const _a = props, { id, validationStatus, resizable = false, onClear } = _a, textareaProps = __objRest(_a, ["id", "validationStatus", "resizable", "onClear"]);
  const { componentStatus, componentId, error, hasLeftIcon, hasClearIcon } = useTextField({
    id,
    validationStatus,
    onClear
  });
  return /* @__PURE__ */ React122__default.createElement(TextField_default, { error, clearIconStyle, onClear }, /* @__PURE__ */ React122__default.createElement(
    TextareaComponent,
    __spreadValues({
      ref,
      "data-test": "textarea",
      resizable,
      id: componentId,
      validationStatus: componentStatus,
      hasLeftIcon,
      hasClearIcon
    }, textareaProps)
  ));
});
var Textarea_default = Textarea;
var ToastMessage = styled(Notification.Heading).attrs({ "data-test": "toast-message" })`
  flex: 1;
`;

// src/components/Toast/components/Toast.tsx
var ToastRoot = styled54(Notification.Root)`
  ${({ takeContainerWidth }) => css`
    box-shadow: 5;
    border-radius: sm;
    margin-bottom: 2;
    gap: 2;
    max-width: ${takeContainerWidth ? "auto" : "calc(100vw - 24px * 2)"};
    min-height: 40px;
    width: ${takeContainerWidth ? "100%" : "344px"};
  `}
`;
var Toast = (_a) => {
  var _b = _a, { variant: variant2, children } = _b, rest = __objRest(_b, ["variant", "children"]);
  const childNode = typeof children === "string" ? /* @__PURE__ */ React122.createElement(ToastMessage, null, children) : children;
  return /* @__PURE__ */ React122.createElement(ToastRoot, __spreadValues({ variant: variant2, "data-test": `toast-${variant2}` }, rest), childNode);
};

// src/components/Toast/components/ToastButton.tsx
var ToastButton = Notification.Button;
var ToastIcon = (props) => {
  return /* @__PURE__ */ React122.createElement(Notification.Icon, __spreadValues({ "data-test": "toast-icon" }, props));
};
var progress = keyframes`
  from {
    stroke-dashoffset: -82px;
  }

  to {
    stroke-dashoffset: -164px;
  }
`;
var SVGContainer = styled54.svg`
  overflow: visible;
  position: absolute;
  transform: rotate(-90deg);
`;
var IndicatorCircle = styled54.circle`
  fill: transparent;
  stroke-dasharray: 82px;
  stroke-width: 1px;
  stroke: currentColor;
  opacity: 0.4;
  stroke-dashoffset: 0;
  transition: stroke 0.2s ease-in-out;

  ${SVGContainer}:hover & {
    opacity: 1;
  }

  ${SVGContainer}:active & {
    fill: rgb(255, 255, 255, 0.1);
  }
`;
var ProgressCircle = styled54.circle(
  ({ dismissIn }) => css`
    fill: transparent;
    stroke-dasharray: 82px;
    stroke-width: 1px;
    animation-delay: 0.5s;
    animation-name: ${progress};
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    animation-duration: ${dismissIn}ms;
    stroke: currentColor;
    stroke-dashoffset: ${dismissIn === 0 ? "-164px" : "-82px"};
    stroke-linecap: round;
  `
);
var ToastCloseIcon = ({ onClick, dismissIn = 0 }) => {
  return /* @__PURE__ */ React122__default.createElement(
    Flex_default,
    {
      position: "relative",
      "data-test": "toast-close",
      cursor: "pointer",
      flexShrink: 0,
      alignItems: "center",
      justifyContent: "center",
      onClick,
      w: 24,
      h: 24
    },
    /* @__PURE__ */ React122__default.createElement(SVGContainer, { width: "24", height: "24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React122__default.createElement(IndicatorCircle, { r: "9", cx: "12", cy: "12" }), /* @__PURE__ */ React122__default.createElement(ProgressCircle, { dismissIn, r: "9", cx: "12", cy: "12" })),
    /* @__PURE__ */ React122__default.createElement(CloseOutlined, { size: 12 })
  );
};

// src/components/Toast/constants.ts
var TOPICS2 = {
  SHOW_TOAST: "SHOW_TOAST",
  REMOVE_TOAST: "REMOVE_TOAST",
  SHOW_BANNER: "SHOW_BANNER",
  REMOVE_BANNER: "REMOVE_BANNER"
};
var ToastContext = createContext(null);
var useToast = () => {
  return useContext(ToastContext);
};
var ToastConfigContext = createContext(null);
var useToastConfig = () => {
  return useContext(ToastConfigContext);
};

// src/components/Toast/utils.ts
var isDismissable = (dismissIn = 0) => Number.isFinite(dismissIn) && dismissIn > 0;
var AnimatedToast = ({ toast }) => {
  const { takeContainerWidth } = useToastConfig();
  const { removeToast } = useToast();
  const _a = toast, { id, icon, variant: variant2, message, action, onClick, dismissIn } = _a, toastProps = __objRest(_a, ["id", "icon", "variant", "message", "action", "onClick", "dismissIn"]);
  const handleDismiss = useCallback(() => {
    removeToast(id);
  }, [removeToast, id]);
  const onBodyClicked = useCallback(() => {
    onClick == null ? void 0 : onClick(handleDismiss);
  }, [onClick, handleDismiss]);
  const onActionClick = useCallback(
    (handleClick) => {
      return () => {
        handleClick(handleDismiss);
      };
    },
    [handleDismiss]
  );
  return /* @__PURE__ */ React122__default.createElement(
    motion.div,
    {
      key: toast.id,
      layout: true,
      initial: "hide",
      animate: "show",
      exit: "hide",
      transition: { ease: [0, 0, 0, 1], duration: 0.3 },
      variants: {
        hide: { opacity: 0, y: -50 },
        show: { opacity: 1, y: 0 }
      }
    },
    /* @__PURE__ */ React122__default.createElement(
      Toast,
      __spreadValues({
        onClick: onBodyClicked,
        cursor: onClick && "pointer",
        variant: variant2,
        takeContainerWidth
      }, toastProps),
      icon && /* @__PURE__ */ React122__default.createElement(ToastIcon, { icon }),
      /* @__PURE__ */ React122__default.createElement(ToastMessage, null, message),
      action ? /* @__PURE__ */ React122__default.createElement(ToastButton, { onClick: onActionClick(action.onClick), mode: action.mode }, action.children) : /* @__PURE__ */ React122__default.createElement(ToastCloseIcon, { onClick: handleDismiss, dismissIn })
    )
  );
};
var ToastList = () => {
  const { takeContainerWidth, position } = useToastConfig();
  const { toasts: toasts2 } = useToast();
  return /* @__PURE__ */ React122__default.createElement(
    Box_default,
    {
      "data-test": "toast-list",
      position,
      top: 2,
      left: takeContainerWidth ? 2 : "auto",
      right: 2,
      zIndex: 1009
    },
    /* @__PURE__ */ React122__default.createElement(AnimatePresence, null, toasts2.map((toast) => /* @__PURE__ */ React122__default.createElement(AnimatedToast, { key: toast.id, toast })))
  );
};

// src/components/Toast/components/ToastManager/ToastManager.tsx
var ToastManager = ({
  children,
  container = document.body,
  takeContainerWidth = false,
  position = "fixed"
}) => {
  const [toasts2, setToasts] = React122.useState([]);
  const removeToast = React122.useCallback(
    (id) => setToasts((prevToasts) => prevToasts.filter((t) => t.id !== id)),
    []
  );
  const showToast = React122.useCallback(
    (t) => {
      const toast = __spreadValues({ dismissIn: 0, id: uniqueId() }, t);
      const cleanup = () => removeToast(toast.id);
      setToasts((prevToasts) => {
        if (prevToasts.some(({ id }) => id === toast.id)) {
          return prevToasts;
        }
        return [...prevToasts, toast];
      });
      if (isDismissable(toast.dismissIn)) {
        const timeoutIdx = window.setTimeout(() => {
          cleanup();
          window.clearTimeout(timeoutIdx);
        }, toast.dismissIn);
      }
      return cleanup;
    },
    [removeToast]
  );
  usePubSub(TOPICS2.SHOW_TOAST, showToast);
  usePubSub(TOPICS2.REMOVE_TOAST, removeToast);
  const containerNode = typeof container === "function" ? container() : container;
  return /* @__PURE__ */ React122.createElement(ToastConfigContext.Provider, { value: { takeContainerWidth, position } }, /* @__PURE__ */ React122.createElement(ToastContext.Provider, { value: { toasts: toasts2, showToast, removeToast } }, /* @__PURE__ */ React122.createElement(React122.Fragment, null, children, containerNode && createPortal(/* @__PURE__ */ React122.createElement(ToastList, null), containerNode))));
};
var toasts = {
  showToast: (toast) => {
    PubSub.publish(TOPICS2.SHOW_TOAST, toast);
  },
  removeToast: (id) => {
    PubSub.publish(TOPICS2.REMOVE_TOAST, id);
  }
};

// src/components/Toggle/constants.ts
var toggle = {
  sizes: {
    xSmall: {
      width: "24px",
      height: "16px",
      borderRadius: "10px",
      padding: "1px"
    },
    small: {
      width: "40px",
      height: "24px",
      borderRadius: "100px",
      padding: "3px"
    },
    regular: {
      width: "48px",
      height: "32px",
      borderRadius: "100px",
      padding: "4px"
    },
    large: {
      width: "72px",
      height: "48px",
      borderRadius: "100px",
      padding: "6px"
    }
  },
  circleSizes: {
    xSmall: {
      width: "12px",
      height: "12px"
    },
    small: {
      width: "16px",
      height: "16px"
    },
    regular: {
      width: "24px",
      height: "24px"
    },
    large: {
      width: "36px",
      height: "36px"
    }
  }
};

// src/components/Toggle/components/StyledToggleContainer.tsx
var makeToggleSize = ({ size: size2, checked }) => {
  const toggleSize = toggle.sizes[size2];
  const circleSize = toggle.circleSizes[size2];
  return __spreadProps(__spreadValues({}, toggleSize), {
    ":after": __spreadProps(__spreadValues({}, circleSize), {
      left: checked ? `calc(100% - ${circleSize.width} - ${toggleSize.padding})` : toggleSize.padding
    })
  });
};
var StyledToggleContainer = styled54(Flex_default)`
  position: relative;
  display: block;
  user-select: none;
  box-sizing: border-box;
  border: 1.5px solid transparent;
  ${makeToggleSize}
  transition: background 300ms ease-in-out;

  input {
    // We can't focus on a hidden element. So we use opacity:0 instead of display: none here.
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  &::after {
    display: block;
    content: '';
    position: absolute;
    bottom: 0;
    top: 0;
    margin: auto;
    border-radius: 50%;
    transition: left 230ms ease-in-out;
  }
`;
var ToggleDescription = styled(Typography_default).attrs({
  as: "span",
  "data-test": "toggle-description"
})`
  grid-area: description;
  margin-top: 2;
  user-select: none;
`;
ToggleDescription.displayName = "ToggleDescription";
var ToggleLabel = styled(Typography_default).attrs({
  as: "span",
  "data-test": "toggle-label"
})`
  grid-area: label;
  align-self: center;
  user-select: none;
`;
ToggleLabel.displayName = "ToggleLabel";

// src/components/Toggle/components/StyledToggleLayout.tsx
var makeToggleTypography = ({
  size: size2,
  disabled,
  theme
}) => {
  return css`
    ${ToggleLabel} {
      ${size2 === "small" ? theme.typography.bodyRegularS : theme.typography.bodyRegularM};
      color: ${getColor$1(disabled ? "text-disabled" : "text-base")};
    }

    ${ToggleDescription} {
      ${theme.typography.supportingRegularS};
      color: ${getColor$1(disabled ? "text-disabled" : "text-secondary")};
    }
  `;
};
var makeToggleColor = ({
  checked,
  disabled,
  error
}) => {
  if (disabled) {
    return css`
      ${StyledToggleContainer} {
        background-color: ${getColor$1("surface-interactive-disabled")};
        border-color: ${getColor$1("graphic-disabled")};

        :after {
          background-color: ${getColor$1("icon-disabled")};
        }
      }
    `;
  }
  if (error) {
    if (checked) {
      return css`
        ${StyledToggleContainer} {
          background-color: ${getColor$1("surface-interactive-critical")};

          :after {
            background-color: ${getColor$1("icon-contrast-light")};
          }
        }

        :hover {
          ${StyledToggleContainer} {
            background-color: ${getColor$1("surface-interactive-critical-hover")};
          }
        }

        :focus-within,
        :active {
          ${StyledToggleContainer} {
            background-color: ${getColor$1("surface-interactive-critical-active")};
          }
        }
      `;
    }
    return css`
      ${StyledToggleContainer} {
        background-color: ${getColor$1("surface-critical")};

        :after {
          background-color: ${getColor$1("icon-contrast-light")};
        }
      }
    `;
  }
  if (checked) {
    return css`
      ${StyledToggleContainer} {
        background-color: ${getColor$1("surface-interactive-primary")};

        :after {
          background-color: ${getColor$1("icon-contrast-light")};
        }
      }

      :hover {
        ${StyledToggleContainer} {
          background-color: ${getColor$1("surface-interactive-primary-hover")};
        }
      }

      :focus-within,
      :active {
        ${StyledToggleContainer} {
          background-color: ${getColor$1("surface-interactive-primary-active")};
        }
      }
    `;
  }
  return css`
    ${StyledToggleContainer} {
      background-color: ${getColor$1("graphic-interactive-default")};

      :after {
        background-color: ${getColor$1("icon-contrast-light")};
      }
    }

    :hover {
      ${StyledToggleContainer} {
        background-color: ${getColor$1("graphic-interactive-default-hover")};
      }
    }

    :focus-within,
    :active {
      ${StyledToggleContainer} {
        background-color: ${getColor$1("graphic-interactive-default-active")};
      }
    }
  `;
};
var makeToggleSide = ({ side }) => {
  if (side === "right") {
    return css`
      grid-template-areas:
        'label icon'
        'description .';
      grid-template-rows: auto 1fr;
    `;
  }
  return css`
    grid-template-areas:
      'icon label'
      '. description';
    grid-template-rows: 1fr auto;
  `;
};
var StyledToggleLayout = styled54(Grid)`
  display: inline-grid;
  justify-content: flex-start;
  align-items: center;
  pointer-events: ${({ readOnly }) => readOnly ? "none" : "all"};

  :not(:has(> *:only-child)) {
    column-gap: 2;
  }

  &,
  input {
    cursor: ${({ disabled, readOnly }) => disabled || readOnly ? void 0 : "pointer"};
  }

  ${makeToggleSide}
  ${makeToggleTypography}
  ${makeToggleColor}
`;

// src/components/Toggle/Toggle.tsx
var Toggle = React122.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      name,
      id,
      size: size2,
      side = "left",
      checked: checkedProp,
      defaultChecked = false,
      disabled = false,
      readOnly = false,
      autoFocus = false,
      onChange,
      validationStatus,
      children
    } = _b, otherStyleProps = __objRest(_b, [
      "name",
      "id",
      "size",
      "side",
      "checked",
      "defaultChecked",
      "disabled",
      "readOnly",
      "autoFocus",
      "onChange",
      "validationStatus",
      "children"
    ]);
    const { componentId, componentSize, error } = useForm({ validationStatus, id, size: size2 });
    const [checked = defaultChecked, setChecked] = useControllableState({
      prop: checkedProp,
      defaultProp: defaultChecked,
      onChange
    });
    const handleOnChange = React122.useCallback(
      (event) => {
        if (!disabled) {
          const { checked: checked2 } = event.target;
          setChecked(checked2);
        }
      },
      [disabled, setChecked]
    );
    const childNode = typeof children === "string" ? /* @__PURE__ */ React122.createElement(ToggleLabel, null, children) : children;
    return /* @__PURE__ */ React122.createElement(
      StyledToggleLayout,
      __spreadValues({
        as: "label",
        htmlFor: componentId
      }, { checked, disabled, readOnly, error, size: componentSize, side }),
      /* @__PURE__ */ React122.createElement(StyledToggleContainer, { checked, size: componentSize }, /* @__PURE__ */ React122.createElement(
        "input",
        __spreadProps(__spreadValues(__spreadValues({
          "data-test": "toggle",
          type: "checkbox",
          id: componentId
        }, { ref, autoFocus, checked, disabled, name }), otherStyleProps), {
          onChange: handleOnChange
        })
      )),
      childNode
    );
  }
);
Toggle.displayName = "Toggle";

// src/components/TabToggle/constants.ts
var TAB_TOGGLE_SIZES = {
  small: {
    height: "40px",
    padding: "0px 16px"
  },
  regular: {
    height: "48px",
    padding: "0px 24px"
  },
  large: {
    height: "56px",
    padding: "0px 32px"
  }
};

// src/components/TabToggle/components/StyledTabToggleButton.ts
var makeButtonVariant2 = ({
  disabled,
  type,
  readOnly,
  checked
}) => {
  if (disabled) {
    return css`
      background-color: ${getColor("surface-interactive-disabled")};
      border-color: ${getColor("graphic-disabled")};
      color: ${getColor("text-disabled")};
    `;
  }
  if (!checked) {
    return css`
      background-color: ${getColor("surface-interactive-default")};
      border-color: ${getColor("graphic-interactive-default")};
      color: ${getColor("text-base")};

      ${!readOnly && css`
        :hover {
          background-color: ${getColor("surface-interactive-default-hover")};
          border-color: ${getColor("graphic-interactive-default-hover")};
        }

        :focus-within,
        :active {
          background-color: ${getColor("surface-interactive-default-active")};
          border-color: ${getColor("graphic-interactive-default-active")};
        }
      `}
    `;
  }
  if (type === "unchecked") {
    return css`
      background-color: ${getColor("surface-interactive-critical")};
      border-color: ${getColor("graphic-interactive-critical")};
      color: ${getColor("text-contrast-light")};

      ${!readOnly && css`
        :hover {
          background-color: ${getColor("surface-interactive-critical-hover")};
          border-color: ${getColor("graphic-interactive-critical-hover")};
        }

        :focus-within,
        :active {
          background-color: ${getColor("surface-interactive-critical-active")};
          border-color: ${getColor("graphic-interactive-critical-active")};
        }
      `}
    `;
  }
  return css`
    background-color: ${getColor("surface-interactive-primary")};
    border-color: ${getColor("graphic-interactive-primary")};
    color: ${getColor("text-contrast-light")};
    ${!readOnly && css`
      :hover {
        background-color: ${getColor("surface-interactive-primary-hover")};
        border-color: ${getColor("graphic-interactive-primary-hover")};
      }

      :focus-within,
      :active {
        background-color: ${getColor("surface-interactive-primary-active")};
        border-color: ${getColor("graphic-interactive-primary-active")};
      }
    `}
  `;
};
var makeTabToggleBlockSize = ({ size: size2 }) => {
  const tabToggleSize = TAB_TOGGLE_SIZES[size2];
  return css`
    height: ${tabToggleSize.height};
    padding: ${tabToggleSize.padding};
  `;
};
var StyledTabToggleButton = styled(Flex_default)`
  align-items: center;
  justify-content: center;
  cursor: ${({ readOnly, disabled }) => disabled ? "not-allowed" : readOnly ? "normal" : "pointer"};
  border: 1px solid transparent;
  ${({ theme }) => theme.typography.bodyMediumM};
  transition: default;

  ${makeButtonVariant2}
  ${makeTabToggleBlockSize}

  &:first-of-type {
    flex: 1;
    border-radius: sm 0 0 sm;
    border-right: none;
  }

  &:last-of-type {
    flex: 1;
    border-radius: 0 sm sm 0;
    border-left: none;
  }
`;
var StyledTabToggleContainer = styled.label`
  display: flex;
  align-items: center;
  user-select: none;

  input {
    display: none;
  }
`;

// src/components/TabToggle/TabToggle.tsx
var TabToggle = memo(
  forwardRef(
    (_a, ref) => {
      var _b = _a, {
        checked: checkedProp,
        defaultChecked = false,
        disabled = false,
        readOnly = false,
        size: size2,
        onChange,
        name,
        id,
        checkedLabel,
        uncheckedLabel,
        "data-test": dataTest = "tab-toggle"
      } = _b, otherStyleProps = __objRest(_b, [
        "checked",
        "defaultChecked",
        "disabled",
        "readOnly",
        "size",
        "onChange",
        "name",
        "id",
        "checkedLabel",
        "uncheckedLabel",
        "data-test"
      ]);
      const formContext = useFormContext();
      const inputSize = size2 || (formContext == null ? void 0 : formContext.size) || "regular";
      const [checked = defaultChecked, setChecked] = useControllableState({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange
      });
      const handleChange = useCallback(
        (event) => {
          if (disabled || readOnly) {
            return;
          }
          const { checked: checked2 } = event.target;
          setChecked(checked2);
        },
        [disabled, readOnly, setChecked]
      );
      return /* @__PURE__ */ React122__default.createElement(StyledTabToggleContainer, __spreadProps(__spreadValues({ htmlFor: id }, otherStyleProps), { "data-test": dataTest }), /* @__PURE__ */ React122__default.createElement(
        StyledTabToggleButton,
        {
          size: inputSize,
          checked,
          type: "checked",
          "data-test": `${dataTest}-checked`,
          disabled,
          readOnly
        },
        checkedLabel
      ), /* @__PURE__ */ React122__default.createElement(
        StyledTabToggleButton,
        {
          size: inputSize,
          checked: !checked,
          type: "unchecked",
          "data-test": `${dataTest}-unchecked`,
          disabled,
          readOnly
        },
        uncheckedLabel
      ), /* @__PURE__ */ React122__default.createElement(
        "input",
        {
          ref,
          id,
          name,
          type: "checkbox",
          "data-test": `${dataTest}-checkbox`,
          checked,
          disabled,
          onChange: handleChange
        }
      ));
    }
  )
);
TabToggle.displayName = "TabToggle";
var TooltipContext = React122.createContext(null);
var useTooltip = () => React122.useContext(TooltipContext);
var StyledArrow = styled54(Box_default)`
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid ${getColor("surface-inverted")};
`;
var TooltipArrow = () => {
  return /* @__PURE__ */ React122.createElement(Popover.Arrow, { offset: 12 }, /* @__PURE__ */ React122.createElement(StyledArrow, null));
};

// src/components/Tooltip/components/TooltipContent.tsx
var TooltipContent = (_a) => {
  var _b = _a, { children } = _b, popoverContent = __objRest(_b, ["children"]);
  const { cancelClose, close } = useTooltip();
  return /* @__PURE__ */ React122.createElement(
    Popover.Content,
    __spreadValues({
      "data-test": "tooltip-content",
      backgroundColor: "surface-inverted",
      color: "text-inverted",
      borderRadius: "sm",
      p: 2,
      boxShadow: 1,
      sideOffset: 8,
      onMouseEnter: cancelClose,
      onMouseLeave: close
    }, popoverContent),
    children,
    /* @__PURE__ */ React122.createElement(TooltipArrow, null)
  );
};
var TooltipRoot = (_a) => {
  var _b = _a, {
    children,
    mouseEnterDelay,
    mouseLeaveDelay,
    open: openProp,
    onVisibilityChange
  } = _b, popoverProps = __objRest(_b, [
    "children",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "open",
    "onVisibilityChange"
  ]);
  const [open, setIsOpen] = useControllableState({
    prop: openProp,
    defaultProp: false,
    onChange: onVisibilityChange
  });
  const handleClose = React122.useMemo(
    () => debounce(() => {
      setIsOpen(false);
    }, mouseLeaveDelay),
    [setIsOpen, mouseLeaveDelay]
  );
  const handleOpen = React122.useMemo(
    () => debounce(() => {
      handleClose.cancel();
      setIsOpen(true);
    }, mouseEnterDelay),
    [mouseEnterDelay, handleClose, setIsOpen]
  );
  return /* @__PURE__ */ React122.createElement(
    TooltipContext.Provider,
    {
      value: {
        open: handleOpen,
        close: handleClose,
        cancelClose: handleClose.cancel
      }
    },
    /* @__PURE__ */ React122.createElement(Popover.Root, __spreadProps(__spreadValues({}, popoverProps), { open, "data-test": "tooltip" }), children)
  );
};
var TooltipTrigger = (_a) => {
  var _b = _a, {
    onMouseEnter,
    onMouseLeave
  } = _b, triggerProps = __objRest(_b, [
    "onMouseEnter",
    "onMouseLeave"
  ]);
  const { open, close } = useTooltip();
  return /* @__PURE__ */ React122.createElement(
    Popover.Trigger,
    __spreadProps(__spreadValues({}, triggerProps), {
      onMouseEnter: composeEventHandlers(onMouseEnter, open),
      onMouseLeave: composeEventHandlers(onMouseLeave, close)
    })
  );
};

// src/components/Tooltip/Tooltip.tsx
var Tooltip = (_a) => {
  var _b = _a, {
    title,
    content,
    side = "top",
    align = "center",
    mouseEnterDelay = 0,
    mouseLeaveDelay = 100,
    maxW = "250px",
    visible,
    children,
    onVisibilityChange,
    arrowPointsAtCenter = false
  } = _b, popoverContent = __objRest(_b, [
    "title",
    "content",
    "side",
    "align",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "maxW",
    "visible",
    "children",
    "onVisibilityChange",
    "arrowPointsAtCenter"
  ]);
  return /* @__PURE__ */ React122__default.createElement(TooltipRoot, __spreadValues({}, { open: visible, mouseEnterDelay, mouseLeaveDelay, onVisibilityChange }), /* @__PURE__ */ React122__default.createElement(TooltipTrigger, null, React122__default.Children.only(children)), /* @__PURE__ */ React122__default.createElement(TooltipContent, __spreadValues({}, __spreadValues({ side, align, maxW, arrowPointsAtCenter }, popoverContent)), title ? /* @__PURE__ */ React122__default.createElement(Typography_default, { color: "text-inverted", "data-test": "tooltip-title" }, title) : content));
};
var StyledListRoot = styled54(Box_default)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ fluid }) => fluid ? "100%" : "fit-content"};
  background-color: background-02;
  overflow: hidden;
  border: 1px solid ${th.color("graphic-default")};
  border-radius: sm;
`;
var List = ({
  children,
  fluid,
  "data-test": dataTest = "list-root"
}) => {
  return /* @__PURE__ */ React122.createElement(StyledListRoot, { fluid, "data-test": dataTest }, children);
};

// src/components/List/utils/scroll.utils.ts
function isScrollAtBottom(element) {
  return element.scrollHeight - element.scrollTop === element.clientHeight;
}
function isScrollAtTop(element) {
  return element.scrollTop === 0;
}

// src/components/List/components/ListView/ListView.tsx
var StyledListView = styled54.ul`
  ${maxHeight}
  padding: 0;
  margin: 0;
  overflow: auto;
  list-style-type: none;
  transition: 500ms box-shadow;
  ${({ hasBottomShadow, hasTopShadow }) => {
  const shadows2 = [
    ...hasTopShadow ? [`inset 0 19px 20px -31px grey`] : [],
    ...hasBottomShadow ? [`inset 0 -19px 20px -31px grey`] : []
  ];
  return `box-shadow: ${shadows2.join(",")};`;
}}
`;
function ListViewBase(_a, ref) {
  var _b = _a, { children, "data-test": dataTest = "list-view" } = _b, rest = __objRest(_b, ["children", "data-test"]);
  const localRef = React122.useRef(null);
  const combinedRef = useComposedRefs(localRef, ref);
  const [hasBottomShadow, setBottomShadow] = React122.useState(false);
  const [hasTopShadow, setTopShadow] = React122.useState(false);
  const setScrollShadow = React122.useCallback((el) => {
    const atBottom = isScrollAtBottom(el);
    const atTop = isScrollAtTop(el);
    setBottomShadow(!atBottom);
    setTopShadow(!atTop);
  }, []);
  React122.useEffect(() => {
    setScrollShadow(localRef.current);
  }, [localRef, setScrollShadow]);
  const handleScroll = React122.useCallback(
    (event) => {
      setScrollShadow(event.currentTarget);
    },
    [setScrollShadow]
  );
  return /* @__PURE__ */ React122.createElement(
    StyledListView,
    __spreadProps(__spreadValues({}, rest), {
      ref: combinedRef,
      onScroll: handleScroll,
      hasBottomShadow,
      hasTopShadow,
      "data-test": dataTest
    }),
    children
  );
}
var ListView = React122.forwardRef(ListViewBase);
var StyledListItem = styled54(Box_default).attrs({ as: "li" })`
  border-bottom: 1px solid ${getColor("graphic-default")};
  color: ${getColor("text-base")};

  &:last-child {
    border-bottom: none;
  }
`;
function ListItem(_a) {
  var _b = _a, {
    children,
    "data-test": dataTest = "list-item"
  } = _b, rest = __objRest(_b, [
    "children",
    "data-test"
  ]);
  return /* @__PURE__ */ React122.createElement(StyledListItem, __spreadValues({ "data-test": dataTest }, rest), children);
}
function ListFooter({
  children,
  "data-test": dataTest = "list-sticky-footer"
}) {
  return /* @__PURE__ */ React122.createElement(
    Box_default,
    {
      "data-test": dataTest,
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      borderTopColor: "graphic-default"
    },
    children
  );
}

// src/styles/animation.ts
var timingFunctions = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var transitionProperties = {
  default: [
    "background-color",
    "border-color",
    "color",
    "fill",
    "stroke",
    "opacity",
    "box-shadow",
    "transform"
  ],
  colors: ["background-color", "border-color", "color", "fill", "stroke"],
  opacity: ["opacity"],
  shadow: ["box-shadow"],
  transform: ["transform"]
};
var transitions = Object.keys(transitionProperties).reduce(
  (obj, key) => {
    obj[key] = transitionProperties[key].map((property) => `${property} ${timingFunctions["ease-in-out"]} 150ms`).join(",");
    return obj;
  },
  {}
);
var animations = {
  spin: "x-spin 1s linear infinite",
  ping: "x-ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
  pulse: "x-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
  bounce: "x-bounce 1s infinite"
};

// src/styles/color.ts
var colorPalette = {
  "primary-900": "#002B20",
  "primary-800": "#004736",
  "primary-700": "#006B51",
  "primary-600": "#008F6D",
  "primary-500": "#00b388",
  "primary-300": "#66D1B8",
  "primary-100": "#C9EDE4",
  "primary-50": "#F1FAF8",
  "neutral-1000": "#000000",
  "neutral-800": "#121212",
  "neutral-700": "#232323",
  "neutral-600": "#2E2E2E",
  "neutral-500": "#383838",
  // darker: "#595952"
  // dark "#86867C"
  // text.dark: "#707479"
  "neutral-400": "#6B6B6B",
  "neutral-300": "#A0A0A0",
  // base: "#D9D9D6"
  "neutral-200": "#E0E0E0",
  "neutral-100": "#F7F7F7",
  "neutral-0": "#FFFFFF",
  "secondary-900": "#0B1F28",
  "secondary-800": "#253942",
  "secondary-700": "#3E525B",
  "secondary-600": "#586C75",
  "secondary-500": "#71858E",
  "secondary-400": "#8A9EA7",
  "secondary-300": "#A8B7BE",
  "secondary-200": "#C5CFD3",
  "secondary-100": "#E2E7E4",
  "secondary-50": "#EEF4F6",
  "informative-800": "#0D3260",
  "informative-700": "#144B90",
  "informative-600": "#2766B5",
  "informative-500": "#307FE2",
  "informative-300": "#83B2EE",
  "informative-100": "#D3E2F6",
  "success-800": "#002B24",
  "success-700": "#004036",
  "success-500": "#006C5B",
  "success-300": "#66A79D",
  "success-100": "#C9DFDB",
  "warning-800": "#8F6401",
  "warning-700": "#D69702",
  "warning-600": "#E1AB29",
  "warning-500": "#FCBB26",
  "warning-300": "#FEE4A8",
  "warning-100": "#FCF3DF",
  "critical-950": "#2B0700",
  "critical-900": "#570F00",
  "critical-800": "#7C1600",
  "critical-700": "#BB2100",
  "critical-600": "#E14220",
  "critical-500": "#FF5C39",
  "critical-300": "#FF9D88",
  "critical-100": "#FCDBD4",
  "decorative1-800": "#312A5B",
  "decorative1-700": "#493F89",
  "decorative1-600": "#6254B6",
  "decorative1-300": "#AFA5EF",
  "decorative1-100": "#E4E1FA",
  "decorative2-800": "#A53500",
  "decorative2-700": "#FF854C",
  "decorative2-600": "#FFBE9F",
  "decorative2-300": "#FFD8C5",
  "decorative2-100": "#FCEFE9"
};
var getColor11 = getColor;
var lightColorTokens = {
  // Text
  "text-highlight": getColor11("neutral-800"),
  "text-base": getColor11("neutral-600"),
  "text-secondary": getColor11("neutral-400"),
  "text-placeholder": getColor11("neutral-300"),
  "text-disabled": getColor11("neutral-300"),
  "text-info": getColor11("informative-500"),
  "text-success": getColor11("success-800"),
  "text-warning": getColor11("warning-800"),
  "text-critical": getColor11("critical-800"),
  "text-inverted": getColor11("neutral-0"),
  "text-contrast-light": getColor11("neutral-0"),
  "text-contrast-dark": getColor11("neutral-600"),
  "text-interactive-neutral": getColor11("neutral-400"),
  "text-interactive-neutral-hover": getColor11("neutral-500"),
  "text-interactive-neutral-active": getColor11("neutral-700"),
  "text-interactive-primary": getColor11("primary-500"),
  "text-interactive-primary-hover": getColor11("primary-700"),
  "text-interactive-primary-active": getColor11("primary-800"),
  "text-interactive-primary-ghost": getColor11("text-interactive-primary"),
  "text-interactive-secondary": getColor11("secondary-700"),
  "text-interactive-secondary-hover": getColor11("secondary-800"),
  "text-interactive-secondary-active": getColor11("secondary-900"),
  "text-interactive-secondary-ghost": getColor11("text-interactive-secondary"),
  "text-interactive-critical": getColor11("critical-700"),
  "text-interactive-critical-hover": getColor11("critical-800"),
  "text-interactive-critical-active": getColor11("critical-900"),
  "text-interactive-critical-ghost": getColor11("text-interactive-critical"),
  // End Text
  // Surface
  "surface-background": getColor11("neutral-100"),
  "surface-default": getColor11("neutral-0"),
  "surface-overlay": "rgba(0, 0, 0, 0.5)",
  "surface-disabled": getColor11("neutral-100"),
  "surface-info": getColor11("informative-100"),
  "surface-success": getColor11("success-100"),
  "surface-warning": getColor11("warning-100"),
  "surface-critical": getColor11("critical-100"),
  "surface-inverted": getColor11("neutral-1000"),
  "surface-interactive-default": getColor11("neutral-0"),
  "surface-interactive-default-hover": getColor11("neutral-100"),
  "surface-interactive-default-active": getColor11("primary-50"),
  "surface-interactive-primary": getColor11("primary-500"),
  "surface-interactive-primary-hover": getColor11("primary-700"),
  "surface-interactive-primary-active": getColor11("primary-800"),
  "surface-interactive-secondary": getColor11("secondary-700"),
  "surface-interactive-secondary-hover": getColor11("secondary-800"),
  "surface-interactive-secondary-active": getColor11("secondary-900"),
  "surface-interactive-neutral": getColor11("neutral-200"),
  "surface-interactive-neutral-hover": getColor11("neutral-300"),
  "surface-interactive-neutral-active": getColor11("neutral-400"),
  "surface-interactive-informative": getColor11("informative-500"),
  "surface-interactive-informative-hover": getColor11("informative-700"),
  "surface-interactive-informative-active": getColor11("informative-800"),
  "surface-interactive-warning": getColor11("warning-500"),
  "surface-interactive-warning-hover": getColor11("warning-700"),
  "surface-interactive-warning-active": getColor11("warning-800"),
  "surface-interactive-critical": getColor11("critical-500"),
  "surface-interactive-critical-hover": getColor11("critical-600"),
  "surface-interactive-critical-active": getColor11("critical-300"),
  "surface-interactive-primary-ghost": "transparent",
  "surface-interactive-primary-ghost-hover": getColor11("neutral-100"),
  "surface-interactive-primary-ghost-active": getColor11("primary-50"),
  "surface-interactive-secondary-ghost": "transparent",
  "surface-interactive-secondary-ghost-hover": getColor11("secondary-50"),
  "surface-interactive-secondary-ghost-active": getColor11("secondary-100"),
  "surface-interactive-warning-ghost": "transparent",
  "surface-interactive-warning-ghost-hover": getColor11("warning-100"),
  "surface-interactive-warning-ghost-active": getColor11("warning-300"),
  "surface-interactive-critical-ghost": "transparent",
  "surface-interactive-critical-ghost-hover": getColor11("critical-100"),
  "surface-interactive-critical-ghost-active": getColor11("critical-300"),
  "surface-interactive-disabled": getColor11("neutral-200"),
  // End Surface
  // Graphic
  "graphic-default": getColor11("neutral-200"),
  "graphic-neutral": getColor11("neutral-300"),
  "graphic-primary": getColor11("primary-300"),
  "graphic-primary-strong": getColor11("primary-500"),
  "graphic-info": getColor11("informative-300"),
  "graphic-info-strong": getColor11("informative-500"),
  "graphic-success": getColor11("success-300"),
  "graphic-success-strong": getColor11("success-500"),
  "graphic-warning": getColor11("warning-300"),
  "graphic-warning-strong": getColor11("warning-500"),
  "graphic-critical": getColor11("critical-300"),
  "graphic-critical-strong": getColor11("critical-500"),
  "graphic-disabled": getColor11("neutral-200"),
  "graphic-disabled-strong": getColor11("neutral-400"),
  "graphic-inverted": getColor11("neutral-800"),
  "graphic-contrast-dark": getColor11("neutral-800"),
  "graphic-contrast-light": getColor11("neutral-0"),
  "graphic-interactive-default": getColor11("neutral-200"),
  "graphic-interactive-default-hover": getColor11("neutral-300"),
  "graphic-interactive-default-active": getColor11("neutral-400"),
  "graphic-interactive-primary": getColor11("primary-500"),
  "graphic-interactive-primary-hover": getColor11("primary-700"),
  "graphic-interactive-primary-active": getColor11("primary-800"),
  "graphic-interactive-secondary": getColor11("secondary-700"),
  "graphic-interactive-secondary-hover": getColor11("secondary-800"),
  "graphic-interactive-secondary-active": getColor11("secondary-900"),
  "graphic-interactive-critical": getColor11("critical-500"),
  "graphic-interactive-critical-hover": getColor11("critical-600"),
  "graphic-interactive-critical-active": getColor11("critical-300"),
  "graphic-interactive-warning": getColor11("warning-500"),
  "graphic-interactive-warning-hover": getColor11("warning-700"),
  "graphic-interactive-warning-active": getColor11("warning-800"),
  "graphic-interactive-primary-ghost": "transparent",
  "graphic-interactive-primary-hover-ghost": getColor11("neutral-100"),
  "graphic-interactive-primary-active-ghost": getColor11("neutral-200"),
  "graphic-interactive-critical-ghost": "transparent",
  "graphic-interactive-critical-hover-ghost": getColor11("critical-100"),
  "graphic-interactive-critical-active-ghost": getColor11("critical-300"),
  "graphic-interactive-secondary-ghost": "transparent",
  "graphic-interactive-secondary-hover-ghost": getColor11("secondary-50"),
  "graphic-interactive-secondary-active-ghost": getColor11("secondary-100"),
  // End Graphic
  // Icon
  "icon-default": getColor11("neutral-400"),
  "icon-highlight": getColor11("neutral-800"),
  "icon-base": getColor11("neutral-600"),
  "icon-primary": getColor11("primary-500"),
  "icon-secondary": getColor11("secondary-300"),
  "icon-disabled": getColor11("neutral-300"),
  "icon-info": getColor11("informative-500"),
  "icon-success": getColor11("success-700"),
  "icon-warning": getColor11("warning-700"),
  "icon-critical": getColor11("critical-700"),
  "icon-inverted": getColor11("neutral-0"),
  "icon-contrast-light": getColor11("neutral-0"),
  "icon-contrast-dark": getColor11("neutral-800"),
  "icon-interactive-default": getColor11("neutral-400"),
  "icon-interactive-default-hover": getColor11("neutral-500"),
  "icon-interactive-default-active": getColor11("neutral-700"),
  "icon-interactive-primary": getColor11("primary-500"),
  "icon-interactive-primary-hover": getColor11("primary-700"),
  "icon-interactive-primary-active": getColor11("primary-800"),
  "icon-interactive-secondary": getColor11("secondary-700"),
  "icon-interactive-secondary-hover": getColor11("secondary-800"),
  "icon-interactive-secondary-active": getColor11("secondary-900"),
  "icon-interactive-critical": getColor11("critical-700"),
  "icon-interactive-critical-hover": getColor11("critical-800"),
  "icon-interactive-critical-active": getColor11("critical-900"),
  // End Icon
  // Call type
  "call-assigned": getColor11("primary-700"),
  "call-answered": getColor11("primary-500"),
  "call-missed": getColor11("critical-500"),
  "call-callback": getColor11("informative-500"),
  "call-abandoned": getColor11("neutral-400"),
  "call-voicemail": getColor11("warning-500"),
  // End Call type
  "skeleton-base": "rgba(0, 0, 0, 0.11)",
  "skeleton-wave": "rgba(0, 0, 0, 0.04)"
};
var darkColorTokens = {
  // Text
  "text-highlight": getColor11("neutral-0"),
  "text-base": getColor11("neutral-100"),
  "text-secondary": getColor11("neutral-200"),
  "text-placeholder": getColor11("neutral-300"),
  "text-disabled": getColor11("neutral-300"),
  "text-info": getColor11("informative-500"),
  "text-success": getColor11("success-500"),
  "text-warning": getColor11("warning-500"),
  "text-critical": getColor11("critical-500"),
  "text-inverted": getColor11("neutral-800"),
  "text-contrast-light": getColor11("neutral-0"),
  "text-contrast-dark": getColor11("neutral -800"),
  "text-interactive-neutral": getColor11("neutral-300"),
  "text-interactive-neutral-hover": getColor11("neutral-200"),
  "text-interactive-neutral-active": getColor11("neutral-100"),
  "text-interactive-primary": getColor11("primary-500"),
  "text-interactive-primary-hover": getColor11("primary-500"),
  "text-interactive-primary-active": getColor11("primary-300"),
  "text-interactive-primary-ghost": getColor11("text-interactive-primary"),
  "text-interactive-secondary": getColor11("secondary-300"),
  "text-interactive-secondary-hover": getColor11("secondary-200"),
  "text-interactive-secondary-active": getColor11("secondary-100"),
  "text-interactive-secondary-ghost": getColor11("text-interactive-secondary"),
  "text-interactive-critical": getColor11("critical-700"),
  "text-interactive-critical-hover": getColor11("critical-500"),
  "text-interactive-critical-active": getColor11("critical-300"),
  "text-interactive-critical-ghost": getColor11("text-interactive-critical"),
  // End Text
  // Surface
  "surface-background": getColor11("neutral-800"),
  "surface-default": getColor11("neutral-600"),
  "surface-overlay": "rgba(0, 0, 0, 0.5)",
  "surface-disabled": getColor11("neutral-800"),
  "surface-info": getColor11("informative-100"),
  "surface-success": getColor11("success-100"),
  "surface-warning": getColor11("warning-100"),
  "surface-critical": getColor11("critical-100"),
  "surface-inverted": getColor11("neutral-0"),
  "surface-interactive-default": getColor11("neutral-600"),
  "surface-interactive-default-hover": getColor11("neutral-500"),
  "surface-interactive-default-active": getColor11("primary-900"),
  "surface-interactive-primary": getColor11("primary-500"),
  "surface-interactive-primary-hover": getColor11("primary-600"),
  "surface-interactive-primary-active": getColor11("primary-300"),
  "surface-interactive-secondary": getColor11("secondary-500"),
  "surface-interactive-secondary-hover": getColor11("secondary-600"),
  "surface-interactive-secondary-active": getColor11("secondary-300"),
  "surface-interactive-neutral": getColor11("neutral-200"),
  "surface-interactive-neutral-hover": getColor11("neutral-300"),
  "surface-interactive-neutral-active": getColor11("neutral-400"),
  "surface-interactive-informative": getColor11("informative-500"),
  "surface-interactive-informative-hover": getColor11("informative-600"),
  "surface-interactive-informative-active": getColor11("informative-300"),
  "surface-interactive-warning": getColor11("warning-500"),
  "surface-interactive-warning-hover": getColor11("warning-600"),
  "surface-interactive-warning-active": getColor11("warning-300"),
  "surface-interactive-critical": getColor11("critical-500"),
  "surface-interactive-critical-hover": getColor11("critical-600"),
  "surface-interactive-critical-active": getColor11("critical-300"),
  "surface-interactive-primary-ghost": "transparent",
  "surface-interactive-primary-ghost-hover": getColor11("neutral-600"),
  "surface-interactive-primary-ghost-active": getColor11("primary-900"),
  "surface-interactive-secondary-ghost": "transparent",
  "surface-interactive-secondary-ghost-hover": getColor11("secondary-800"),
  "surface-interactive-secondary-ghost-active": getColor11("secondary-700"),
  "surface-interactive-warning-ghost": "transparent",
  "surface-interactive-warning-ghost-hover": getColor11("warning-800"),
  "surface-interactive-warning-ghost-active": getColor11("warning-700"),
  "surface-interactive-critical-ghost": "transparent",
  "surface-interactive-critical-ghost-hover": getColor11("critical-900"),
  "surface-interactive-critical-ghost-active": getColor11("critical-950"),
  "surface-interactive-disabled": getColor11("neutral-500"),
  // End Surface
  // Graphic
  "graphic-default": getColor11("neutral-500"),
  "graphic-neutral": getColor11("neutral-300"),
  "graphic-primary": getColor11("primary-300"),
  "graphic-primary-strong": getColor11("primary-500"),
  "graphic-info": getColor11("informative-300"),
  "graphic-info-strong": getColor11("informative-500"),
  "graphic-success": getColor11("success-300"),
  "graphic-success-strong": getColor11("success-500"),
  "graphic-warning": getColor11("warning-300"),
  "graphic-warning-strong": getColor11("warning-500"),
  "graphic-critical": getColor11("critical-300"),
  "graphic-critical-strong": getColor11("critical-500"),
  "graphic-disabled": getColor11("neutral-500"),
  "graphic-disabled-strong": getColor11("neutral-400"),
  "graphic-inverted": getColor11("neutral-0 "),
  "graphic-contrast-dark": getColor11("neutral-800"),
  "graphic-contrast-light": getColor11("neutral-0"),
  "graphic-interactive-default": getColor11("neutral-200"),
  "graphic-interactive-default-hover": getColor11("neutral-300"),
  "graphic-interactive-default-active": getColor11("neutral-200"),
  "graphic-interactive-primary": getColor11("primary-500"),
  "graphic-interactive-primary-hover": getColor11("primary-600"),
  "graphic-interactive-primary-active": getColor11("primary-300"),
  "graphic-interactive-secondary": getColor11("secondary-500"),
  "graphic-interactive-secondary-hover": getColor11("secondary-600"),
  "graphic-interactive-secondary-active": getColor11("secondary-300"),
  "graphic-interactive-critical": getColor11("critical-500"),
  "graphic-interactive-critical-hover": getColor11("critical-600"),
  "graphic-interactive-critical-active": getColor11("critical-300"),
  "graphic-interactive-warning": getColor11("warning-500"),
  "graphic-interactive-warning-hover": getColor11("warning-600"),
  "graphic-interactive-warning-active": getColor11("warning-300"),
  "graphic-interactive-primary-ghost": "transparent",
  "graphic-interactive-primary-hover-ghost": getColor11("neutral-600"),
  "graphic-interactive-primary-active-ghost": getColor11("primary-900"),
  "graphic-interactive-secondary-ghost": "transparent",
  "graphic-interactive-secondary-hover-ghost": getColor11("secondary-800"),
  "graphic-interactive-secondary-active-ghost": getColor11("secondary-700"),
  "graphic-interactive-critical-ghost": "transparent",
  "graphic-interactive-critical-hover-ghost": getColor11("critical-100"),
  "graphic-interactive-critical-active-ghost": getColor11("critical-300"),
  // End Graphic
  // Icon
  "icon-default": getColor11("neutral-200"),
  "icon-highlight": getColor11("neutral-0"),
  "icon-base": getColor11("neutral-200"),
  "icon-primary": getColor11("primary-500"),
  "icon-secondary": getColor11("secondary-700"),
  "icon-disabled": getColor11("neutral-400"),
  "icon-info": getColor11("informative-500"),
  "icon-success": getColor11("success-700"),
  "icon-warning": getColor11("warning-700"),
  "icon-critical": getColor11("critical-700"),
  "icon-inverted": getColor11("neutral-800"),
  "icon-contrast-light": getColor11("neutral-0"),
  "icon-contrast-dark": getColor11("neutral-800"),
  "icon-interactive-default": getColor11("neutral-200"),
  "icon-interactive-default-hover": getColor11("neutral-200"),
  "icon-interactive-default-active": getColor11("neutral-100"),
  "icon-interactive-primary": getColor11("primary-500"),
  "icon-interactive-primary-hover": getColor11("primary-600"),
  "icon-interactive-primary-active": getColor11("primary-500"),
  "icon-interactive-secondary": getColor11("secondary-300"),
  "icon-interactive-secondary-hover": getColor11("secondary-200"),
  "icon-interactive-secondary-active": getColor11("secondary-100"),
  "icon-interactive-critical": getColor11("critical-700"),
  "icon-interactive-critical-hover": getColor11("critical-600"),
  "icon-interactive-critical-active": getColor11("critical-5 00"),
  // End Icon
  // Call type
  "call-assigned": getColor11("primary-700"),
  "call-answered": getColor11("primary-500"),
  "call-missed": getColor11("critical-500"),
  "call-callback": getColor11("informative-500"),
  "call-abandoned": getColor11("neutral-400"),
  "call-voicemail": getColor11("warning-500"),
  // End Call type
  "skeleton-base": "rgba(255, 255, 255, 0.11)",
  "skeleton-wave": "rgba(255, 255, 255, 0.04)"
};
var colors = __spreadProps(__spreadValues(__spreadValues({}, colorPalette), lightColorTokens), {
  modes: {
    dark: darkColorTokens
  }
});

// src/styles/duration.ts
var durations = {
  instant: "100ms",
  "fast-in": "250ms",
  "fast-out": "200ms",
  "slow-in": "300ms",
  "slow-out": "250ms"
};

// src/styles/font.ts
var fonts = {
  default: [
    "Fellix",
    "-apple-system",
    "BlinkMacSystemFont",
    "Helvetica Neue",
    "Arial",
    "sans-serif"
  ].join(", ")
};

// src/styles/grid.ts
var gridTemplateColumns = {
  1: "repeat(1, minmax(0, 1fr))",
  2: "repeat(2, minmax(0, 1fr))",
  3: "repeat(3, minmax(0, 1fr))",
  4: "repeat(4, minmax(0, 1fr))",
  5: "repeat(5, minmax(0, 1fr))",
  6: "repeat(6, minmax(0, 1fr))",
  7: "repeat(7, minmax(0, 1fr))",
  8: "repeat(8, minmax(0, 1fr))",
  9: "repeat(9, minmax(0, 1fr))",
  10: "repeat(10, minmax(0, 1fr))",
  11: "repeat(11, minmax(0, 1fr))",
  12: "repeat(12, minmax(0, 1fr))"
};
var gridTemplateRows = {
  1: "repeat(1, minmax(0, 1fr))",
  2: "repeat(2, minmax(0, 1fr))",
  3: "repeat(3, minmax(0, 1fr))",
  4: "repeat(4, minmax(0, 1fr))",
  5: "repeat(5, minmax(0, 1fr))",
  6: "repeat(6, minmax(0, 1fr))"
};

// src/styles/radii.ts
var radii = {
  none: "0",
  xs: "4px",
  sm: "8px",
  default: "16px",
  full: "9999px"
};

// src/styles/screen.ts
var screens = {
  _: 0,
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};

// src/styles/shadow.ts
var shadows = {
  1: "0px 1px 10px rgba(0, 0, 0, 0.12)",
  2: "0px 8px 10px rgba(0, 0, 0, 0.12)",
  3: "0px -5px 20px rgba(0, 0, 0, 0.1)",
  4: "0px 2px 2px rgba(0, 0, 0, 0.08)",
  5: "0px 8px 20px rgba(16, 24, 32, 0.1)",
  6: "0px 18px 30px rgba(16, 24, 32, 0.1)"
};

// src/styles/space.ts
var space5 = {
  0: 0,
  0.5: 2,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 40,
  8: 64,
  9: 80,
  xxxs: 4,
  xxs: 8,
  xs: 12,
  s: 16,
  m: 24,
  l: 32,
  xl: 40,
  xxl: 64,
  xxxl: 80
};

// src/styles/state.ts
var states = {
  _: null,
  motionSafe: "@media (prefers-reduced-motion: no-preference)",
  motionReduce: "@media (prefers-reduced-motion: reduce)",
  first: "&:first-child",
  last: "&:last-child",
  odd: "&:odd",
  even: "&:even",
  visited: "&:visited",
  checked: "&:checked",
  focusWithin: "&:focus-within",
  hover: "&:hover",
  focus: "&:focus",
  focusVisible: "&:focus-visible",
  active: "&:active",
  disabled: "&:disabled, &[aria-disabled=true]",
  placeholder: "&::placeholder"
};

// src/styles/typography.ts
var fontWeightLight = {
  fontWeight: 300
};
var fontWeightRegular = {
  fontWeight: 400
};
var fontWeightMedium = {
  fontWeight: 500
};
var fontWeightSemibold = {
  fontWeight: 600
};
var fontWeightBold = {
  fontWeight: 700
};
var supportingXS = {
  fontSize: "10px",
  lineHeight: "12px"
};
var supportingS = {
  fontSize: "12px",
  lineHeight: "16px"
};
var bodyS = {
  fontSize: "14px",
  lineHeight: "18px"
};
var bodyM = {
  fontSize: "16px",
  lineHeight: "20px"
};
var headingXS = {
  fontSize: "18px",
  lineHeight: "20px"
};
var headingS = {
  fontSize: "20px",
  lineHeight: "24px"
};
var headingM = {
  fontSize: "32px",
  lineHeight: "40px"
};
var headingL = {
  fontSize: "42px",
  lineHeight: "40px"
};
var headingXL = {
  fontSize: "48px",
  lineHeight: "48px"
};
var newTypography = {
  supportingRegularXS: __spreadValues(__spreadValues({}, supportingXS), fontWeightRegular),
  supportingMediumXS: __spreadValues(__spreadValues({}, supportingXS), fontWeightMedium),
  supportingSemiboldXS: __spreadValues(__spreadValues({}, supportingXS), fontWeightSemibold),
  supportingRegularS: __spreadValues(__spreadValues({}, supportingS), fontWeightRegular),
  supportingMediumS: __spreadValues(__spreadValues({}, supportingS), fontWeightMedium),
  supportingSemiboldS: __spreadValues(__spreadValues({}, supportingS), fontWeightSemibold),
  bodyRegularS: __spreadValues(__spreadValues({}, bodyS), fontWeightRegular),
  bodyMediumS: __spreadValues(__spreadValues({}, bodyS), fontWeightMedium),
  bodySemiboldS: __spreadValues(__spreadValues({}, bodyS), fontWeightSemibold),
  bodyRegularM: __spreadValues(__spreadValues({}, bodyM), fontWeightRegular),
  bodyMediumM: __spreadValues(__spreadValues({}, bodyM), fontWeightMedium),
  bodySemiboldM: __spreadValues(__spreadValues({}, bodyM), fontWeightSemibold),
  headingLightXS: __spreadValues(__spreadValues({}, headingXS), fontWeightLight),
  headingMediumXS: __spreadValues(__spreadValues({}, headingXS), fontWeightMedium),
  headingBoldXS: __spreadValues(__spreadValues({}, headingXS), fontWeightBold),
  headingLightS: __spreadValues(__spreadValues({}, headingS), fontWeightLight),
  headingMediumS: __spreadValues(__spreadValues({}, headingS), fontWeightMedium),
  headingBoldS: __spreadValues(__spreadValues({}, headingS), fontWeightBold),
  headingLightM: __spreadValues(__spreadValues({}, headingM), fontWeightLight),
  headingMediumM: __spreadValues(__spreadValues({}, headingM), fontWeightMedium),
  headingBoldM: __spreadValues(__spreadValues({}, headingM), fontWeightBold),
  headingLightL: __spreadValues(__spreadValues({}, headingL), fontWeightLight),
  headingMediumL: __spreadValues(__spreadValues({}, headingL), fontWeightMedium),
  headingBoldL: __spreadValues(__spreadValues({}, headingL), fontWeightBold),
  headingLightXL: __spreadValues(__spreadValues({}, headingXL), fontWeightLight),
  headingMediumXL: __spreadValues(__spreadValues({}, headingXL), fontWeightMedium),
  headingBoldXL: __spreadValues(__spreadValues({}, headingXL), fontWeightBold)
};
var typography2 = __spreadValues({}, newTypography);

// src/styles/theme.ts
var defaultTheme = {
  // Don't use dark mode based on the query media.
  // This would create confusion especially in storybook.
  useColorSchemeMediaQuery: false,
  colors,
  space: space5,
  inset: space5,
  screens,
  durations,
  radii,
  shadows,
  gridTemplateColumns,
  gridTemplateRows,
  fonts,
  typography: typography2,
  transitions,
  transitionProperties,
  timingFunctions,
  animations,
  states
};
var ThemeProvider = ({ children, theme }) => {
  const mergedTheme = mergeTheme(theme);
  return /* @__PURE__ */ React122.createElement(ThemeProvider$1, { theme: mergedTheme }, children);
};
var mergeTheme = (theme) => {
  if (!theme) {
    return defaultTheme;
  }
  if (typeof theme === "function") {
    return theme(defaultTheme);
  }
  return merge({}, defaultTheme, theme);
};
var ThemeProvider_default = ThemeProvider;
var SquircleContainer = styled54.svg`
  display: block;
  width: 0;
  height: 0;
`;
var Squircle = forwardRef((_props, ref) => {
  return /* @__PURE__ */ React122__default.createElement(SquircleContainer, { ref, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" }, /* @__PURE__ */ React122__default.createElement("defs", null, /* @__PURE__ */ React122__default.createElement("clipPath", { id: "svgPath", clipPathUnits: "objectBoundingBox", transform: "scale(0.01, 0.01)" }, /* @__PURE__ */ React122__default.createElement(
    "path",
    {
      id: "squircle",
      d: "m 78.831044,5.798472 c 4.81983,1.8730797 8.656314,5.078731 11.616304,9.229462 1.710259,2.39826 3.022328,4.962988 3.989926,7.528069 0.339092,0.898925 0.611267,1.734992 0.822933,2.487591 0.128659,0.457463 0.209358,0.789755 0.242215,0.948817 1.810168,7.521542 2.575736,15.656565 2.465189,24.043417 0.107264,8.054549 -0.721352,16.32087 -2.557537,24.040925 -0.039,0.186495 -0.11966,0.518794 -0.248267,0.976263 -0.211578,0.752606 -0.483665,1.588682 -0.822671,2.487615 -0.967354,2.565102 -2.279258,5.129853 -3.989474,7.528133 -2.960102,4.151029 -6.797177,7.356843 -11.611444,9.227224 -5.827534,2.31576 -16.436446,3.571875 -28.746653,3.681886 C 38.042142,97.870939 27.196322,96.56006 21.26748,94.298621 16.446841,92.425597 12.609904,89.219788 9.6497582,85.06877 7.9395212,82.6705 6.6275352,80.10576 5.6600587,77.540668 5.3210099,76.64174 5.0488795,75.805669 4.8372576,75.053066 4.7086242,74.595599 4.6279453,74.263304 4.5970194,74.112077 2.7055611,66.536823 1.9207205,58.433075 2.0323569,49.963193 1.9250644,41.906233 2.753082,33.640869 4.5889314,25.922209 4.6279451,25.735717 4.7086242,25.403422 4.8372576,24.945956 5.0488795,24.193353 5.3210099,23.357282 5.6600587,22.458355 6.6275352,19.893262 7.9395212,17.328522 9.6497582,14.930252 12.609904,10.779233 16.446841,7.5734249 21.27292,5.6983053 27.196903,3.4387398 38.043912,2.1279881 50.008319,2.0221243 62.048719,2.1288092 72.841786,3.4563161 78.831044,5.798472 Z"
    }
  ))));
});
var Squircle_default = Squircle;

// src/internal/Tractor.tsx
var Tractor = ({
  theme,
  icons,
  injectStyle = false,
  colorModeTargetSelector = "",
  children,
  toastConfig,
  bannerConfig
}) => {
  return /* @__PURE__ */ React122.createElement(ThemeProvider_default, { theme }, /* @__PURE__ */ React122.createElement(ColorModeProvider, { targetSelector: colorModeTargetSelector }, /* @__PURE__ */ React122.createElement(IconProvider, { value: { icons } }, /* @__PURE__ */ React122.createElement(ToastManager, __spreadValues({}, toastConfig), /* @__PURE__ */ React122.createElement(BannerManager, __spreadValues({}, bannerConfig), children, injectStyle && // FIXME
  // @ts-ignore
  /* @__PURE__ */ React122.createElement(InjectGlobalStyle, null), /* @__PURE__ */ React122.createElement(Squircle_default, null))))));
};
var Tractor_default = Tractor;

export { Accordion, AccordionBody, AccordionHeader, AccordionItem, ActionBar, ActionMenu, Audio2 as Audio, AudioBar, AudioContext, AudioCurrentTime, AudioDuration, AudioManager, AudioManagerContext, AudioTimeContext, Avatar, AvatarFallback, AvatarIcon, AvatarImg, AvatarText, Badge, Banner, BannerButton, BannerContext, BannerHeading, BannerIcon, BannerManager, BannerParagraph, BannerSuffix, Box_default as Box, Button, Checkbox, CheckboxDescription, CheckboxLabel, ColumnTextAlign, ComboBox, ComboBoxContent, ComboBoxItem, ComboBoxMenu, ComboBoxTrigger, CounterBadge, DEFAULT_PAGE_SIZE, DatePicker, Divider, DividerOrientation, DividerSize, Drawer, DrawerBody, DrawerClose, DrawerFooter, DrawerHeader, DrawerTitle, Dropdown, DropdownButton, Flag, FlagIcon, Flex_default as Flex, Form_default as Form, FormContext, FormItem_default as FormItem, FormItemContext, Gauge_default as Gauge, Grid, Icon_default as Icon, IconButton_default as IconButton, IconContext, IconProvider, Link_default as Link, List, ListFooter, ListItem, ListView, ListViewBase, MAX_Z_INDEX, Menu, MenuContext, MenuItem, MenuItemCheckIcon, MenuItemDescription, MenuItemGroup, MenuItemLabel, MenuItemPrefix, MenuItemSuffix, MenuProvider, ModalBody, ModalClose, ModalContext, ModalDialog, ModalFooter, ModalHeader, ModalTitle, MotionBox, OrderDirection, Pagination, PlayButton, Popover, PopoverArrowContext, PopoverContext, PopoverPlacementContext, Portal, QuickAudioPlayer, QuickAvatar, Radio, RadioDescription, RadioGroup, RadioLabel, RowActionType, Select, Skeleton, Slider, Spacer, StickTo, StyledListItem, StyledListView, StyledMenuItemDescription, StyledMenuItemLabel, TabContainer, TabContent, TabItem, TabMenu, TabMenuItem, TabToggle, Table3 as Table, Tag, TagDeleteIcon, TagLabel, TextInput, Textarea_default as Textarea, ThemeProvider_default as ThemeProvider, Toast, ToastButton, ToastCloseIcon, ToastConfigContext, ToastContext, ToastIcon, ToastManager, ToastMessage, Toggle, ToggleDescription, ToggleLabel, Tooltip, Tractor_default as Tractor, Typography_default as Typography, banners, defaultAudioContext, defaultTheme, fromTheme, getColor, getRadii, getShadow, getSpace, isScrollAtBottom, isScrollAtTop, join, mapValues, noop, textColor, toasts, useAudio, useAudioManager, useAudioTime, useBanner, useComboBox, useDropdownContext, useElementEdgeInView, useElementPosition, useFormContext, useFormItemContext, useIconContext, useMenu, useMenuSelection, useModalContext, usePopoverArrow, usePopoverContext, usePopoverPlacement, useSelect, useToast, useToastConfig };
